{
  "general.login": "登入",
  "general.logout": "登出",
  "general.title_zero": "故事",
  "general.title_one": "故事",
  "general.title_other": "故事",
  "general.chapter_zero": "話次",
  "general.chapter_one": "話次",
  "general.chapter_other": "話次",
  "general.character_zero": "角色",
  "general.character_one": "角色",
  "general.character_other": "角色",
  "general.title_language": "故事語言",
  "general.display_language": "顯示語言",
  "general.category_zero": "分類",
  "general.category_one": "分類",
  "general.category_other": "分類",
  "general.category.fantasy": "奇幻",
  "general.category.urban_fantasy": "現代奇幻",
  "general.category.romance_fantasy": "浪漫奇幻",
  "general.category.oriental_fantasy": "武俠",
  "general.category.boyslove": "BL",
  "general.category.girlslove": "GL",
  "general.category.alternative_history": "架空歷史",
  "general.category.drama": "劇情",
  "general.category.daily": "日常",
  "general.category.action": "動作",
  "general.category.romance": "愛情",
  "general.category.gag_comedy": "搞笑/喜劇",
  "general.category.horror": "驚悚",
  "general.category.mystery": "懸疑推理",
  "general.category.horror_mystery": "驚悚/懸疑",
  "general.category.sci_fi": "科幻",
  "general.category.know_how": "小訣竅",
  "general.category.Daily": "日常",
  "general.create_title": "故事創建",
  "general.edit_title": "故事編輯",
  "general.create_character": "角色創建",
  "general.edit_character": "角色編輯",
  "general.all": "全部",
  "general.home": "首頁",
  "general.navigation": "主要選單",
  "general.best": "熱門",
  "general.discover": "發現",
  "general.my_titles": "我的故事",
  "general.library": "圖書館",
  "general.profile": "個人檔案",
  "general.my": "我的",
  "general.bubblepick": "BubblePick",
  "general.username": "使用者代碼",
  "general.writername": "暱稱",
  "general.description": "說明",
  "general.setting": "設定",
  "general.setting_email": "電子郵件地址",
  "general.setting_autosave": "自動儲存",
  "general.setting_reading_mode": "閱讀模式",
  "general.setting_change_password": "變更密碼",
  "general.save": "儲存",
  "general.exitsave": "儲存後退出",
  "general.cancel": "取消",
  "general.next": "下一步",
  "general.create": "創建",
  "general.create_button": "創建",
  "general.add_chapter": "新增話次",
  "general.edit": "編輯",
  "general.delete": "刪除",
  "general.publish": "公開",
  "general.unpublish": "不公開",
  "general.publishrequest": "要求公開",
  "general.stay_on": "取消",
  "general.leave": "退出",
  "general.done": "完成",
  "general.no_chapter_name": "無標題",
  "general.unsaved_changes": "有未儲存的修改",
  "general.unsaved_changes_message": "是否要儲存變更？",
  "general.unsaved_changes_warning_message": "尚有未儲存的編輯",
  "general.leave_confirm_message": "確定要離開此頁面嗎?",
  "general.asset_no_list_message": "您還沒有素材",
  "general.chapter_status.publish_requested": "已要求公開",
  "general.chapter_status.published": "已設定為公開",
  "general.chapter_status.unpublished": "已設定為不公開",
  "general.title_status.draft": "草稿匣",
  "general.title_status.ongoing": "連載中",
  "general.title_status.completed": "完結",
  "general.title_status.blocked": "已封鎖",
  "general.title_status.waiting": "處理中",
  "general.character_name": "角色名稱",
  "general.character_status": "角色說明",
  "general.character_position.left": "左邊",
  "general.character_position.right": "右邊",
  "general.image_filetype_validation_message": "可以上傳的檔案格式為webp、 png、jpg 和 jpeg",
  "general.image_size_validation_message": "每張圖片最大10MB",
  "general.image_load_validation_message": "無法載入相片，請重新嘗試",
  "general.contact_customer_support_error_message": "發生了未知的錯誤，請聯繫客服中心",
  "general.yes": "是",
  "general.no": "否",
  "general.modify": "編輯",
  "general.modify_button": "編輯",
  "general.save_alert": "有未儲存的變更。<br/>您確定要結束嗎？",
  "general.save_success_message": "變更已儲存",
  "general.save_fail_message": "儲存變更失敗，請再試一次。",
  "general.delete_alert_message": "確定要刪除嗎?",
  "general.delete_success_message": "該內容已刪除",
  "general.saving_successful": "儲存成功",
  "general.saving_unsuccessful": "儲存失敗，請重新嘗試",
  "general.terms_of_service": "服務條款",
  "general.privacy_policy": "個人資料使用告知事項",
  "general.operation_policy": "營運規章",
  "general.juvenile_protection_policy": "兒童及少年福利與權益保障法",
  "general.apply": "套用",
  "general.language_letter_zero": "字",
  "general.language_letter_one": "字",
  "general.language_letter_other": "字",
  "general.tap_zero": "點擊",
  "general.tap_one": "點擊",
  "general.tap_other": "點擊",
  "general.scroll_zero": "滾動",
  "general.scroll_one": "滾動",
  "general.scroll_other": "滾動",
  "general.original": "原創",
  "general.gallery": "相簿",
  "general.camera": "相機",
  "general.size": "尺寸",
  "general.contest": "徵選",
  "general.challenge": "挑戰",
  "general.bubbletap_original": "BubbleTap原創",
  "general.bubbleup": "BubbleUp",
  "general.bubbleup.challenge_header_button": "BubbleUp挑戰",
  "general.bubbleup.challenge_message": "我正在參加BubbleUp挑戰",
  "general.story_created_complete": "已創建故事",
  "general.list_tap_asset_sort_last_hour": "最近1小時",
  "general.list_tap_asset_sort_daily": "每日排行榜",
  "general.list_tap_asset_sort_weekly": "每週排行榜",
  "general.list_tap_asset_sort_monthly": "每月排行榜",
  "general.list_tap_asset_sort_all": "全部",
  "general.tap_order_newest": "依新到舊排序",
  "general.tap_order_liked": "最多人按讚",
  "general.tap_order_oldest": "依舊到新排序",
  "general.tap.order_int_hourly": "{{int_number}}小時",
  "general.tap.order_int_daily": "{{int_number}}日",
  "general.tap.order_int_weekly": "{{int_number}}週",
  "general.tap.order_int_monthly": "{{int_number}}個月",
  "general.pass.basic": "BASIC",
  "general.pass.super": "SUPER",
  "general.pass.hyper": "HYPER",
  "general.comments": "留言",
  "general.event_awarded": "{{int_numbers}} 泡泡已發放!",
  "general.event_awarded_description1": "已發放偵探活動費和限偵探使用的裝飾<br/>馬上找出犯人吧!",
  "general.event_popup_alert1": "只限韓國用戶參與",
  "general.event_popup_alert2": "只限完成實名認證的用戶參與",
  "general.event_popup_alert3": "已參與活動",
  "general.event_popup_alert4": "活動已結束",
  "general.bubbles_zero": "{{int_numbers}} 泡泡",
  "general.bubbles_one": "{{int_numbers}} 泡泡",
  "general.bubbles_other": "{{int_numbers}} 泡泡",
  "general.copy": "複製",
  "general.maintenance_title": "系統維護中",
  "general.maintenance_title2": "為了提供更優質的服務，進行系統維護中。<br/>請稍候。",
  "general.maintenance_description": "維護時間：今日上午 05:30~08:30",
  "general.maintenance_period": "維護時間：{{startDate}} {{startTime}}~{{endTime}}",
  "popup.banner_close_button": "關閉",
  "popup.close_for_a_day_button": "今日不再查看",
  "popup.banner_close_for_a_day_button": "3天內不再顯示",
  "register.userinfo_username_message": "請選擇使用者代碼",
  "register.userinfo_username_used_validation_message": "此使用者代碼已有人使用",
  "register.userinfo_writername_used_validation_message": "此暱稱已有人使用",
  "register.userinfo_username_impossible_used_validation_message": "此使用者代碼無法使用",
  "register.userinfo_writername_impossible_used_validation_message": "此暱稱無法使用",
  "register.userinfo_username_format_validation_message": "請輸入6~25個字元的使用者代碼，可包含英文和數字",
  "register.userinfo_writername_format_validation_message": "請輸入2~25個字元，可包含文字、數字和一部份特殊符號",
  "register.userinfo_password_message": "請輸入密碼",
  "register.userinfo_password_placeholder": "密碼",
  "register.userinfo_password_format_validation_message": "請輸入8~25個字元的密碼",
  "register.userinfo_next": "確認",
  "register.userinfo_password_retype_placeholder": "重新輸入密碼",
  "register.userinfo_username_description_message": "使用者代碼不可更改，請慎重考慮後送出",
  "register.userinfo_email_title_message": "請輸入電子郵件地址",
  "register.userinfo_email_description_message": "驗證電子郵件地址後，即可找回密碼",
  "register.userinfo_email_description_message2": "驗證電子郵件地址後<br/>可使用以下服務",
  "register.userinfo_email_certification_message": "請驗證電子郵件地址",
  "register.userinfo_email_certification_message2": "請確認電子郵件地址驗證狀態",
  "register.userinfo_email_certification_button": "前往驗證",
  "register.userinfo_email_checkbox_description_message1": "找回密碼",
  "register.userinfo_email_checkbox_description_message2": "活動中獎公告",
  "register.userinfo_email_checkbox_description_message3": "BubbleUp入選公告",
  "register.userinfo_email_checkbox_description_message4": "連載提案",
  "register.userinfo_verification_agree_select_all": "全部同意",
  "register.userinfo_verification_privacy_policy": "個人資料使用告知事項",
  "register.userinfo_verification_terms_of_service": "服務條款",
  "register.userinfo_verification_agree_description1": "一個身分最多只能認證三個帳號",
  "register.userinfo_verification_agree_description2": "實名認證確認成年後，即可創建或使用成人專用內容",
  "register.userinfo_verification_failed_modal_description": "一個身分最多只能認證三個帳號",
  "register.userinfo_verification_failed_modal_retry": "重試",
  "register.userinfo_set_nickname_title": "設定暱稱",
  "register.userinfo_set_nickname_skip": "跳過",
  "register.userinfo_set_nickname_placeholder": "請輸入欲使用的暱稱",
  "register.userinfo_set_nickname_description1": "此暱稱會在聊天室及應用程式服務中使用",
  "register.userinfo_set_nickname_description2": "如另外設定個人檔案，角色會用其他名稱稱呼您，而非此暱稱",
  "register.userinfo_set_nickname_description3": "可以隨時至我的頁面更改暱稱",
  "register.userinfo_set_nickname_done_button": "完成",
  "register.userinfo_set_nickname_format_validation_message": "請輸入2~25個字元，可包含文字、數字和一部份特殊符號",
  "register.userinfo_set_nickname_already_used_validation_message": "此暱稱已有人使用",
  "register.userinfo_set_nickname_inappropriate_words_validation_message": "您輸入的暱稱包含不當詞彙，請輸入其他暱稱",
  "register.userinfo_set_nickname_invalid_characters_validation_message": "此暱稱包含不得使用的文字",
  "register.userinfo_set_country_korea": "대한민국",
  "register.userinfo_set_country_thai": "ประเทศไทย",
  "register.userinfo_set_country_taiwan": "臺灣",
  "register.userinfo_set_country_japan": "日本",
  "login.userinfo_message": "輸入<strong>使用者代碼</strong>和<strong>密碼</strong>登入",
  "login.userinfo_login": "登入",
  "login.userinfo_forgot_password_message": "忘記密碼?",
  "login.userinfo_username_format_validation_message": "請輸入6~25個字元的使用者代碼，可包含英文和數字",
  "login.userinfo_password_format_validation_message": "請輸入8~25個字元的密碼",
  "login.userinfo_username_fail_validation_message": "使用者代碼不存在，請重新確認",
  "login.userinfo_password_fail_validation_message": "密碼錯誤，請重新確認",
  "login.userinfo_password_not_set_validation_message": "您尚未設定密碼，使用社群帳號登入者請先設定密碼",
  "login.password_reset_password_first_description_message": "請輸入使用者代碼和驗證完成之電子郵件地址",
  "login.password_reset_password_second_description_message": "將會寄出讓您重設<strong>新密碼</strong>的電子郵件",
  "login.password_reset_password_username_placeholder": "請輸入使用者代碼",
  "login.password_reset_password_email_placeholder": "請輸入驗證完成之電子郵件地址",
  "login.password_reset_password_button": "設定新密碼",
  "login.password_reset_password_username_fail_validation_message": "請輸入六個字以上的使用者代碼",
  "login.password_reset_password_email_fail_validation_message": "請輸入正確格式的電子郵件地址",
  "login.password_reset_password_username_fail_validation_toast": "此使用者代碼不存在，請重新確認",
  "login.password_reset_password_email_validation_email_none_message": "此帳號尚未驗證過電子郵件地址",
  "login.password_reset_password_email_success_title": "已寄出設定新密碼的電子郵件",
  "login.password_reset_password_email_success_message": "請確認收件匣",
  "login.password_reset_password_email_current_validation_toast": "現在使用中的密碼錯誤，請重新確認",
  "login.password_reset_password_email_new_validation_toast": "現在使用中的密碼和新密碼不相符",
  "login.password_reset_password_email_validation_email_verify_message": "請輸入有效的電子郵件地址",
  "login.connect_fail_unknown_title": "發生了未知的錯誤",
  "login.connect_fail_unknown_description": "發生錯誤，請透過電子郵件與我們聯繫<br/>(tw.support@bubbletap.com)",
  "login.account_member": "您已經有帳號了嗎?",
  "login.account_kakao": "以<strong>Kakao</strong>帳戶繼續",
  "login.account_google": "以<strong>Google</strong>帳戶繼續",
  "login.account_facebook": "以<strong>Facebook</strong>繼續",
  "login.account_apple": "以<strong>Apple</strong>繼續",
  "login.account_agree_policy": "登入帳號，即表示您已閱讀並同意<link1>服務條款</link1>與<link2>個人資料使用告知事項</link2>",
  "login.account_fail_toast": "登入失敗，請再次嘗試",
  "login.account_fail_password_toast": "密碼錯誤",
  "login.account_cancel_toast": "已取消登入",
  "login.account_must_login": "登入後即可使用",
  "login.nonlogin_users_login_button": "前往登入",
  "login.account_existing_account_title": "使用現有帳號登入",
  "login.account_social_account_title": "使用社群帳號登入",
  "login.password_reset_modal_title": "已寄出重設密碼信件至您的信箱。",
  "login.password_reset_modal_description": "請確認您的收件匣。",
  "login.password_change_login_button": "變更密碼並登入",
  "login.password_change_title": "變更密碼",
  "gnb.about_bubblechat": "BubbleChat介紹",
  "gnb.studio": "Studio",
  "gnb.faq": "常見問題",
  "gnb.guide_download": "下載使用手冊",
  "story.my_titles.title_list": "故事清單",
  "story.my_titles.published_titles": "公開的故事",
  "story.create_title.list_thumbnail_guide_message": "創建新故事",
  "story.create_title.list_null_text": "尚未有編輯中的故事",
  "story.create_edit_title.add_cover": "請新增封面",
  "story.create_edit_title.bubbletap_original_cover_assets_alert_name": "原創封面素材",
  "story.create_edit_title.title_completed_label": "故事完結",
  "story.create_edit_title.select_categories_text": "請選擇1~2個分類",
  "story.create_edit_title.add_characters_text": "新增角色到您的故事",
  "story.create_characters.name_guide_text": "請輸入新角色名稱",
  "story.create_characters.status_guide_text": "請輸入角色說明",
  "story.create_characters.position_guide_text": "請選擇角色的左右位置",
  "story.select_characters_text": "請選擇角色",
  "story.delete_characters_confirmation_message": "確定要刪除角色嗎?",
  "story.delete_characters_warning_message": "此角色無法在故事中使用",
  "story.delete_characters_validation_message": "無法刪除此角色",
  "story.delete_characters_info_message": "無法刪除故事內使用中的角色",
  "story.delete_title_confirmation_message": "故事刪除後無法復原<br/>確定要刪除嗎?",
  "story.delete_title_character_chapter_warning_message": "該故事內使用的角色和話次已全部刪除",
  "story.delete_title_like_warning_message": "該故事的按讚數已全部刪除",
  "story.delete_title_comment_warning_message": "該故事的留言已全部刪除",
  "story.delete_title_read_warning_message": "該故事的點擊數已全部刪除",
  "story.create_edit_title.title_validation_message": "故事名稱必須介於1~40字",
  "story.create_edit_title.description_validation_message": "故事說明必須介於1~150字",
  "story.create_edit_title.category_validation_message": "請選擇1個以上的分類",
  "story.create_edit_title.status_validation_message": "故事說明為必填項目",
  "story.create_edit_title.delete_chapter_confirmation_message": "確定要刪除話次嗎?",
  "story.create_edit_title.delete_chapter_warning_message": "此話次不會再出現在此故事裡",
  "story.create_edit_title_serial_chapter_unpublished_impossible_alert_message": "連載作品的話次無法設定為不公開",
  "story.create_edit_title_serial_chapter_published_impossible_alert_message": "連載作品的話次無法親自公開",
  "story.create_edit_title_serial_chapter_deleted_impossible_alert_message": "無法刪除連載中作品的話次",
  "story.create_edit_title.title_placeholder": "請輸入故事名稱",
  "story.create_edit_title.description_placeholder": "請輸入故事介紹",
  "story.create_edit_title.chapter_order_tooltip": "編輯話次順序",
  "story.create_title_info_title": "故事名稱",
  "story.create_edit_component_delete_message": "已刪除",
  "story.create_characters.bubbletap_original_avatar_assets_alert_name": "角色頭貼",
  "story.create_characters.edit_image_zoom_button": "放大",
  "story.create_characters.edit_image_reset_all_button": "恢復原狀",
  "story.create_characters.edit_image_remove_background_button": "移除背景",
  "story.create_characters.edit_image_send_button": "設定",
  "story.create_characters.edit_image_cancel_button": "取消",
  "story.create_edit_title_serial_title_delete_impossible_alert_message": "無法刪除連載中的作品",
  "story.create_edit_title_serial_title_completed_impossible_alert_message": "連載中的作品無法變更連載狀態",
  "story.create_edit_title_status_change_publishrequest_alert_title": "一旦要求公開後，無法再變更狀態",
  "story.create_edit_title_status_change_publishrequest_alert_message": "要求公開後，無法再編輯和刪除話次",
  "story.create_edit_title_status_change_publishrequest_alert_error_message": "要求失敗，請重新嘗試",
  "story.create_edit_title.list_null_message": "公開故事，和朋友們分享",
  "preview.controller_play_button": "播放",
  "preview.controller_pause_button": "暫停",
  "preview.controller_replay_button": "重新播放",
  "preview.controller_end_button": "結束",
  "preview.controller_info_scroll_zero": "總滑動次數",
  "preview.controller_info_scroll_one": "總滑動次數",
  "preview.controller_info_scroll_other": "總滑動次數",
  "preview.controller_info_tap_zero": "總點擊次數",
  "preview.controller_info_tap_one": "總點擊次數",
  "preview.controller_info_tap_other": "總點擊次數",
  "preview.controller_info_letter_zero": "總字數",
  "preview.controller_info_letter_one": "總字數",
  "preview.controller_info_letter_other": "總字數",
  "profile.username_placeholder": "請輸入欲使用的使用者代碼",
  "profile.description_placeholder": "寫下我的介紹",
  "profile.username_length_validation_message": "使用者代碼必須介於6~25個字元",
  "profile.username_format_validation_message": "使用者代碼只能使用英文大小寫和數字",
  "profile.image_upload": "上傳大頭貼",
  "chapter.confirm_publish_chapter_message": "您要公開這個話次嗎?",
  "chapter.confirm_draft_chapter_message": "您要儲存這個話次嗎?",
  "chapter.info_fail_validation_message": "不存在的話次",
  "chapter.edit": "編輯話次",
  "chapter.edit_background_image": "背景圖片",
  "chapter.edit_background_your_image": "自行上傳",
  "chapter.edit_background_simple_color": "背景顏色",
  "chapter.edit_text_input_narrative_placeholder": "輸入旁白",
  "chapter.edit_text_input_character_placeholder": "輸入台詞",
  "chapter.edit_text_input_background_image_button": "背景圖片",
  "chapter.edit_text_input_narrative_button": "旁白",
  "chapter.edit_text_input_image_button": "相片",
  "chapter.edit_text_input_clear_room_button": "新頁面",
  "chapter.edit_text_input_narrative_characters_limit_toast": "旁白最多能輸入10,000字",
  "chapter.edit_text_input_dialogue_characters_limit_toast": "台詞最多能輸入10,000字",
  "chapter.edit_text_input_newpage_limit_message": "無法一次新增多個新頁面",
  "chapter.edit_text_input_newpage_warning_alert_message": "新增頁面功能不能作為第一個操作",
  "chapter.edit_text_input_between_newpage_contents_limit_message": "欲刪除該泡泡時，請先刪除前一個或後一個新頁面",
  "chapter.edit_page_clear_room_tap": "以新頁面開始",
  "chapter.edit_page_current_location_line": "目前位置",
  "chapter.edit_page_delete_message": "該內容已刪除",
  "chapter.edit_page_background_color_tap": "背景顏色",
  "chapter.edit_preview_tooltip": "預覽",
  "chapter.edit_save_tooltip": "請輸入標題和一行以上的字後再儲存",
  "chapter.edit_save_publish_chapter_warning_alert_message": "已公開的話次無法編輯",
  "chapter.edit_chapter_name_text": "話次標題",
  "chapter.edit_chapter_title_placeholder": "請輸入話次標題",
  "chapter.edit_create_chapter": "創建話次",
  "chapter.edit_back": "上一頁",
  "chapter.edit_chapter_title": "請輸入話次標題",
  "chapter.edit_text_edit_text": "編輯內文",
  "chapter.edit_text_change_monologue": "變更為獨白",
  "chapter.edit_text_change_dialogue": "變更為對話",
  "chapter.edit_assets_background_color": "背景顏色",
  "chapter.edit_assets_background_title": "背景圖片",
  "chapter.edit_assets_background_category_your_image": "我的相片",
  "chapter.edit_assets_background_category_simple_color": "背景顏色",
  "chapter.edit_assets_background_category_bubbletap_original": "BubbleChat原創背景",
  "chapter.edit_assets_animated_overlay_image": "覆蓋",
  "chapter.edit_text_auto_separation": "對話自動分段",
  "chapter.edit_text_auto_separation_enter": "輸入Enter後<br/>可以自動分段對話",
  "chapter.edit_text_convo_type": "變更對話類型",
  "chapter.edit_cut": "剪下",
  "chapter.edit_paste": "貼上",
  "chapter.edit_searchby_char": "搜尋角色名稱",
  "chapter.edit_assets_bubbletap_original_transition_action_sheet": "變更切換方式",
  "chapter.edit_assets_bubbletap_original_transition_screen_name": "請選擇畫面切換方式",
  "chapter.edit_assets_bubbletap_original_transition_image_button": "畫面慢速切換(相片類)",
  "chapter.edit_assets_bubbletap_original_transition_text_button": "畫面快速切換(文字類)",
  "chapter.list_reading_mode_screen_name": "請設定閱讀模式",
  "chapter.list_reading_tap_mode_button": "點擊模式",
  "chapter.list_reading_scroll_mode_button": "滾動模式",
  "chapter.list_reading_tap_mode_alert_title": "已設定為點擊模式",
  "chapter.list_reading_tap_mode_alert_message": "想變更設定的話可至 <strong>我的頁面 > 設定 > 閱讀模式</strong><br/>進行變更",
  "chapter.list_reading_scroll_mode_alert_title": "已設定為滾動模式",
  "chapter.list_reading_scroll_mode_alert_message": "想變更設定的話可至 <strong>我的頁面 > 設定 > 閱讀模式</strong><br/>進行變更",
  "chapter.list_non_login_user_reading_mode_setting_alert_message": "想變更設定的話可在登入後至<br/><strong>我的頁面 > 設定 > 閱讀模式</strong>進行變更",
  "chapter.list_share_fail_message": "找不到該應用程式",
  "chapter.edit_assets_bubbletap_original_soundeffect_action_sheet": "新增效果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_screen_name": "效果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category1": "BubbleTap效果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category2": "我的最愛",
  "chapter.edit_assets_bubbletap_original_soundeffect_category1": "自然",
  "chapter.edit_assets_bubbletap_original_soundeffect_category2": "物品",
  "chapter.edit_assets_bubbletap_original_soundeffect_category3": "動物",
  "chapter.edit_assets_bubbletap_original_soundeffect_category4": "地點",
  "chapter.edit_assets_bubbletap_original_soundeffect_category5": "人",
  "chapter.edit_assets_bubbletap_original_soundeffect_category6": "種類",
  "chapter.edit_assets_bubbletap_original_soundeffect_category7": "其他",
  "chapter.edit_assets_bubbletap_original_soundeffect_categories_screen_name": "效果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_edit_action_sheet": "去除效果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_play_failed_toast": "播放音檔失敗",
  "chapter.list_free_label": "免費",
  "chapter.list_owned_label": "購買",
  "chapter.list_rented_label": "借閱",
  "chapter.list_rented_expire_label": "借閱到期",
  "chapter.list_share_title": "分享",
  "chapter.list_share_kakaotalk_label": "Kakao Talk",
  "chapter.list_share_kakaotalk_message": "立即前往!",
  "chapter.list_share_instagram_label": "Instagram",
  "chapter.list_share_link_label": "複製連結",
  "chapter.list_share_link_message": "已複製連結",
  "chapter.list_rented_label_time1": "{{int_rentDay}}日 {{int_rentHour}}小時",
  "chapter.list_rented_label_time2": "{{int_rentDay}}日",
  "chapter.list_rented_label_time3": "{{int_rentHour}}小時 {{int_rentMinute}}分鐘",
  "chapter.list_rented_label_time4": "{{int_rentHour}}小時 ",
  "chapter.list_rented_label_time5": "{{int_rentMinute}}分鐘",
  "chapter.list_charge_status": "免費閱讀",
  "chapter.list_charge_time_day_description_zero": "每{{int_rentDay}}日免費",
  "chapter.list_charge_time_day_description_one": "每{{int_rentDay}}日免費",
  "chapter.list_charge_time_day_description_other": "每{{int_rentDay}}日免費",
  "chapter.list_charge_time_hour_description_zero": "每{{int_rentHour}}小時免費",
  "chapter.list_charge_time_hour_description_one": "每{{int_rentHour}}小時免費",
  "chapter.list_charge_time_hour_description_other": "每{{int_rentHour}}小時免費",
  "chapter.list_charge_time_minute_description_zero": "每{{int_rentMinute}}分鐘免費",
  "chapter.list_charge_time_minute_description_one": "每{{int_rentMinute}}分鐘免費",
  "chapter.list_charge_time_minute_description_other": "每{{int_rentMinute}}分鐘免費",
  "chapter.list_charge_time_count_day_description": "剩餘{{int_rentDay}}日",
  "chapter.list_charge_time_count_day_hour_description": "剩餘{{int_rentDay}}日 {{int_rentHour}}小時",
  "chapter.list_charge_time_count_hour_description": "剩餘{{int_rentHour}}小時",
  "chapter.list_charge_time_count_hour_minute_description": "剩餘{{int_rentHour}}小時 {{int_rentMinute}}分鐘",
  "chapter.list_charge_time_count_minute_description": "剩餘{{int_rentMinute}}分鐘",
  "chapter.list_free_count": "{{int_count}}話免費",
  "chapter.list_charge_info_alert_tittle": "倒數免費",
  "chapter.list_charge_time_day_info_alert_message1_zero": "使用完使用券後，{{int_rentDay}}日後會再免費提供一張使用券",
  "chapter.list_charge_time_day_info_alert_message1_one": "使用完使用券後，{{int_rentDay}}日後會再免費提供一張使用券",
  "chapter.list_charge_time_day_info_alert_message1_other": "使用完使用券後，{{int_rentDay}}日後會再免費提供一張使用券",
  "chapter.list_charge_time_hour_info_alert_message1_zero": "使用完使用券後，{{int_rentHour}}小時後會再免費提供一張使用券",
  "chapter.list_charge_time_hour_info_alert_message1_one": "使用完使用券後，{{int_rentHour}}小時後會再免費提供一張使用券",
  "chapter.list_charge_time_hour_info_alert_message1_other": "使用完使用券後，{{int_rentHour}}小時後會再免費提供一張使用券",
  "chapter.list_charge_time_minute_info_alert_message1_zero": "使用完使用券後，{{int_rentMinute}}分鐘後會再免費提供一張使用券",
  "chapter.list_charge_time_minute_info_alert_message1_one": "使用完使用券後，{{int_rentMinute}}分鐘後會再免費提供一張使用券",
  "chapter.list_charge_time_minute_info_alert_message1_other": "使用完使用券後，{{int_rentMinute}}分鐘後會再免費提供一張使用券",
  "chapter.list_charge_time_info_alert_message2": "該使用券的借閱期間為3天",
  "chapter.list_charge_time_info_alert_message3": "最新{{int_rentRecent}}話次無法使用該使用券",
  "chapter.list_purchase_purchased_chapter_button": "持有話次",
  "chapter.list_purchase_chapter_collect": "購買",
  "chapter.list_purchase_chapter_rent": "借閱",
  "chapter.list_purchase_chapter_free_charge": "免費閱讀",
  "chapter.list_purchase_alert_my_bubble": "我的泡泡",
  "chapter.list_purchase_alert_message": "確定要購買此話次嗎?",
  "chapter.list_purchase_failed_alert_message": "購買話次失敗，請重新嘗試",
  "chapter.list_purchase_alert_footer_message": "可以借閱72小時",
  "chapter.edit_autosave_error_toast_message": "自動儲存失敗",
  "chapter.edit_autosave_saving_text": "自動儲存中",
  "chapter.edit_autosave_success_text": "自動儲存成功",
  "chapter.edit_autosave_last_success_time_text": "上次儲存",
  "chapter.read_config_font_size_change": "字體大小",
  "asset_browser.add": "新增",
  "asset_browser.in_use": "使用中",
  "asset_browser.max_num_images_limit_info_text": "最多只能選擇20張相片",
  "asset_browser.no_asset_in_use_message": "沒有使用中的素材",
  "asset_browser.character_image": "角色相片",
  "asset_browser.narrative_image": "旁白相片",
  "setting.edit_email_verify_now_button": "驗證電子郵件地址",
  "setting.edit_email_re_verify_button": "重新驗證",
  "setting.edit_email_password_change_button": "變更",
  "setting.edit_email_verify_message": "驗證電子郵件地址",
  "setting.edit_email_verify_info_text": "透過驗證電子郵件地址<br/>找回密碼",
  "setting.edit_email_verify_text": "輸入電子郵件地址",
  "setting.edit_email_verify_placeholder": "請輸入欲驗證的電子郵件地址",
  "setting.edit_cancel_button": "取消",
  "setting.edit_email_verify_verify_now_button": "驗證",
  "setting.edit_email_verify_validation_text": "請輸入正確格式的電子郵件地址",
  "setting.edit_email_verify_success_message": "我們已將驗證信<br/>發送到您輸入的電子郵件地址",
  "setting.edit_email_verify_success_info_text": "請在24小時內驗證電子郵件地址",
  "setting.edit_email_verify_fail_current_text": "這是目前已驗證的電子郵件地址",
  "setting.edit_email_verify_fail_use_text": "使用中的電子郵件地址",
  "setting.edit_ok_button": "確認",
  "setting.edit_email_verify_email_template_message": "驗證電子郵件地址",
  "setting.edit_email_verify_email_template_guide_text": "請點擊下方按鍵以驗證電子郵件地址",
  "setting.edit_email_verify_email_template_info_text": "這封電子郵件24小時內有效",
  "setting.edit_email_verify_email_template_click_here_button": "驗證",
  "setting.edit_email_verify_email_template_success_message": "驗證完成",
  "setting.edit_email_verify_email_template_success_text": "電子郵件已驗證完成，謝謝!",
  "setting.edit_email_verify_email_template_close_window_button": "關閉驗證視窗",
  "setting.edit_email_verify_email_template_fail_message": "此封驗證電子郵件已失效",
  "setting.edit_email_verify_email_template_fail_text": "驗證期限已過期，請重新嘗試。",
  "setting.edit_email_verify_email_template_expiration_message": "此電子郵件地址已驗證",
  "setting.edit_email_verify_email_template_expiration_text": "請使用其他電子郵件地址驗證",
  "setting.edit_email_verify_email_template_move_studio_button": "返回Studio",
  "setting.edit_email_re_verify_message": "請重新驗證電子郵件地址",
  "setting.edit_email_re_verify_info_text": "您可以改用其他電子郵件地址進行驗證，請輸入新的電子郵件地址",
  "setting.edit_autosave_setup_alert_title_message": "自動儲存設定",
  "setting.edit_autosave_setup_alert_description_message": "您可以設定話次<br/>自動儲存的時間週期",
  "setting.edit_autosave_setup_time_value_one_minute": "每一分鐘儲存",
  "setting.edit_autosave_setup_time_value_three_minutes": "每三分鐘儲存",
  "setting.edit_autosave_setup_time_value_five_minutes": "每五分鐘儲存",
  "setting.edit_autosave_setup_time_value_on": "開啟",
  "setting.edit_autosave_setup_time_value_off": "關閉",
  "setting.edit_autosave_setup_time_status_one_minute": "一分鐘",
  "setting.edit_autosave_setup_time_status_three_minutes": "三分鐘",
  "setting.edit_autosave_setup_time_status_five_minutes": "五分鐘",
  "setting.edit_autosave_setup_time_status_minute": "分鐘",
  "setting.edit_reading_tap_mode_title_message": "翻頁模式",
  "setting.edit_reading_tap_mode_description_message": "點擊以閱讀作品",
  "setting.edit_reading_scroll_mode_title_message": "滾動模式",
  "setting.edit_reading_scroll_mode_description_message": "滾動以閱讀作品",
  "setting.edit_password_change_your_password_description": "請輸入目前的密碼和新密碼",
  "setting.edit_password_change_your_password_message": "請更新密碼",
  "setting.edit_password_input_current_password_placeholder": "請輸入使用中的密碼",
  "setting.edit_password_input_new_password_placeholder": "請輸入新設定的密碼",
  "setting.edit_password_input_re_type_new_password_placeholder": "請重新輸入新設定的密碼",
  "setting.edit_password_change_your_password_validation_text": "請輸入8~25個字元的密碼，可包含英文、數字和特殊符號",
  "setting.edit_password_change_your_password_validation_toast": "密碼錯誤",
  "setting.edit_password_change_new_password_validation_toast": "您輸入的是目前使用中的密碼，請重新設定密碼",
  "setting.edit_password_change_success_message": "完成密碼變更",
  "setting.edit_password_change_success_text": "現在開始<br/>可以用新密碼登入",
  "setting.edit_password_change_enable_validation_text": "可用的密碼",
  "setting.edit_password_change_new_password_again_placeholder": "請再輸入一次新密碼",
  "setting.edit_password_change_new_password_match_validation_text": "新密碼相符",
  "setting.edit_password_change_new_password_not_match_validation_text": "新密碼不相符",
  "setting.edit_setuppassword_title_message": "設定密碼",
  "setting.edit_setuppassword_description_message": "設定完密碼後<br/>可在輸入使用者代碼登入時使用",
  "setting.edit_setuppassword_new_password_placeholder": "請輸入密碼",
  "setting.edit_setuppassword_new_password_validation_text": "請輸入8~25個字元的密碼，可包含英文、數字和特殊符號",
  "setting.edit_setuppassword_new_password_again_placeholder": "請重新輸入密碼",
  "setting.edit_setuppassword_new_password_again_validation_text": "請再輸入一次密碼",
  "setting.edit_setuppassword_change_button": "設定",
  "setting.edit_setuppassword_alert_title": "已設定密碼",
  "setting.edit_setuppassword_alert_description": "現在您可以用這個密碼登入了",
  "register.userinfo_password_not_match_validation_text": "密碼不相符",
  "register.userinfo_password_match_validation_text": "密碼相符",
  "email.template_footer_message": "本信件為系統自動發送請勿回覆，如有疑問請聯繫客服中心",
  "email.template_title": "設定新密碼",
  "email.template_password_reset_body_title": "設定新密碼",
  "email.template_password_reset_body_description": "請點擊下方按鈕以設定新密碼",
  "email.template_password_reset_reset_password_button": "設定新密碼",
  "email.page_password_reset_success_title": "<strong>已設定新密碼</strong>.",
  "email.page_password_reset_success_description": "您現在可以嘗試使用新密碼登入了",
  "email.page_password_reset_fail_title": "<strong>設定新密碼的連結已失效</strong>",
  "email.page_password_reset_fail_title_no_strong": "設定新密碼的連結已失效",
  "email.page_password_reset_fail_description": "請使用其他電子郵件地址再試一次",
  "email.page_password_reset_validation_text": "請輸入8~25個字元，可包含英文和數字",
  "email.page_password_reset_re_type_validation_text": "請輸入8~25個字元，可包含英文和數字",
  "email.page_password_reset_re_type_match_validation_text": "請再輸入一次相同的密碼",
  "block.account_title": "您的帳號被封鎖了",
  "block.account_message": "如果您有任何疑問，請聯絡客服中心",
  "block.account_re_active_date_text": "解除日期",
  "block.account_contact_us_button": "聯繫我們",
  "block.title_title": "您的故事已被封鎖，目前無法公開您的故事",
  "block.useraccount_alert_message": "您現在無法使用BubbleChat",
  "block.community_alert_message": "您現在無法使用社群活動功能",
  "block.account_unblocked_date_text": "預計解除日",
  "block.reason": "原因",
  "profile.introduction": "介紹",
  "block.block_button": "封鎖",
  "block.block_alert_title_character": "確定要封鎖此角色嗎?",
  "block.block_toast_complete": "封鎖成功",
  "block.block_toast_failed": "封鎖失敗",
  "block.block_toast_failed2": "無法再封鎖了",
  "block.block_list": "封鎖清單",
  "block.block_list_empty_character": "您沒有封鎖的角色",
  "block.unblock_toast_deleted": "此角色已被刪除",
  "block.unblock_button": "解除封鎖",
  "block.unblock_alert_title_character": "您確定要解除此角色的封鎖嗎?",
  "block.unblock_toast_complete": "已解除封鎖",
  "block.unblock_toast_failed": "解除封鎖失敗",
  "banner.body_title": "在BubbleTap Studio<br/>寫下您的故事",
  "banner.body_description": "使用具備更專業、更多樣功能的BubbleTap Studio<br/>寫下更有趣的故事",
  "banner.body_button": "前往Studio",
  "footer.rights_message": "© 2025 Bubble Tap CO., Inc.",
  "footer.ceo_text": "CEO",
  "footer.ceo_name_text": "JB Park",
  "footer.address_text": "地址",
  "footer.address_info_text": "5F, 207, Teheran-ro, Gangnam-gu, Seoul, Republic of Korea",
  "footer.company_name_text": "Bubble Tap CO., LTD.",
  "footer.tel_text": "電話",
  "footer.tel_info_text": "＋82 02-2039-7572",
  "footer.email_text": "Email ",
  "footer.email_info_text": "tw.support@bubbletap.com",
  "footer.registration_number_text": "營利事業統一編號",
  "footer.registration_bus_report_num": "網路銷售業申報號碼",
  "browser.support_alert_title_message": "請更新瀏覽器版本!",
  "browser.support_alert_description_message": "BubbleChat Studio已針對最新版本的瀏覽器進行最佳化",
  "browser.support_alert_chrome_description_message": "請使用Chrome版本9(含)以上開啟",
  "browser.support_alert_edge_description_message": "請使用Edge版本18(含)以上開啟",
  "browser.support_alert_safari_description_message": "請使用Safari版本14(含)以上開啟",
  "browser.support_alert_firefox_description_message": "請使用Firefox版本65(含)以上開啟",
  "browser.support_alert_ie_description_message": "抱歉，我們不支援IE",
  "error.page_title_message": "網址錯誤",
  "error.page_description_message": "按下下方按鈕，即可前往BubbleChat首頁",
  "error.page_bubblechat_go_button": "前往BubbleChat首頁",
  "contest.agree_message": "參加",
  "contest.agree_confirm_message": "參加''{{string_contestName}}'中",
  "contest.agree_alert_title": "'{{string_contestName}}'參加須知",
  "contest.agree_alert_description": "勾選後即代表同意參加",
  "contest.publish_alert_title": "無法公開此話次",
  "contest.publish_alert_description_first": "各個話次至少要輸入{{int_mintext}}字",
  "contest.publish_alert_description_second": "目前字數:",
  "contest.save_alert_title": "無法儲存此話次",
  "contest.save_alert_description_first": "各個話次至少要輸入{{int_mintext}}字",
  "contest.save_alert_description_second": "目前字數:",
  "contest.delete_alert_title": "無法刪除此故事",
  "contest.delete_alert_description": "此故事非草稿，無法刪除",
  "contest.modify_alert_title": "無法編輯此故事",
  "contest.modify_alert_description": "審查期間，參加徵選的故事無法編輯或刪除",
  "contest.edit_draft_alert_title": "無法編輯此故事",
  "contest.edit_draft_alert_description": "審查期間，參加徵選的故事無法編輯",
  "contest.bubbleup.challenge_message": "挑戰",
  "contest.bubbleup.challenge_description": "任何人都可以!",
  "contest.edit_draft_alert_character_title": "無法編輯此角色",
  "contest.edit_draft_alert_character_description": "審查期間，參加徵選的故事角色無法編輯",
  "contest.edit_draft_alert_warning_message": "刪除此故事後，將會取消您參加徵選和活動的資格",
  "contest.agree_end_error_alert_tittle": "暫時性的問題讓您無法參與，請重新嘗試",
  "contest.agree_end_error_alert_message": "徵選或活動已結束，無法參加",
  "contest.title": "徵選",
  "profile.edit_username_description": "編輯使用者代碼",
  "profile.edit_writername_description": "編輯暱稱",
  "profile.edit_username_description_message": "請輸入新使用者代碼",
  "profile.edit_writername_description_message": "請輸入新暱稱",
  "profile.edit_username_duplicate_message": "這個使用者代碼已有人使用",
  "profile.category_community_other_post_list_null_message": "寫寫看第一篇貼文!",
  "profile.following_suggestion": "追蹤看看別的用戶",
  "profile.gather_followers": "試著增加您的粉絲",
  "profile.category_community_post_list_null_message": "您尚未撰寫任何貼文",
  "profile.sns_category_following_list_null_message": "您尚未開始追蹤別的用戶",
  "profile.sns_category_follower_list_null_message": "您尚未有任何粉絲",
  "notice.legal_content_alert_message": "本服務內容為BubbleChat所有之著作，僅限於BubbleChat Web Studio及應用程式內使用，若未經BubbleChat授權擅自盜用或複製，將依據著作權法採取法律行動",
  "notice.legal_content_alert_create_story_title_message": "請閱讀注意事項!",
  "notice.legal_content_alert_create_story_main_message": "若用戶在創建故事、話次標題、封面、內文、角色等時違反下列事項，將會依BubbleChat的營運規章及相關法律受到制裁",
  "notice.legal_content_alert_create_story_body_message1": "未經當事人同意，非法分享或刊登包括其他用戶在內之他人智慧財產權產物",
  "notice.legal_content_alert_create_story_body_message2": "製造或散播侵犯、侮辱或誹謗他人(包括知名人士)之個人資料、隱私、肖像、姓名等相關所有權利，或損害其名譽之作品、封面、角色等",
  "notice.legal_content_alert_create_story_body_message3": "冒充本人以外之人士，或散播假消息等欺騙他人之行為",
  "notice.legal_content_alert_create_story_body_message4": "重複使用過度辱罵、粗俗言詞等，導致他人產生厭惡、不適或恐懼感",
  "notice.legal_content_alert_create_story_body_message5": "製造或散播可能導致他人心生畏懼或厭惡感的暴力及刺激性內容",
  "notice.legal_content_alert_create_story_body_message6": "製造或散播描述刺激或露骨性行為，足以導致他人產生性羞恥感或錯誤性觀念等之淫穢產物",
  "notice.legal_content_alert_create_story_body_message7": "對他人構成直接且明顯身體威脅之內容，或煽動、鼓勵他人自殘或自殺之行為",
  "notice.legal_content_alert_create_story_body_message8": "煽動對特定個人或團體的惡意歧視或偏見",
  "notice.legal_content_alert_create_story_body_message9": "從事相關法令禁止或構成刑事處罰之行為，或教唆、幫助犯罪等行為",
  "notice.legal_content_alert_create_story_body_message10": "宣傳、廣告或銷售相關法令禁止宣傳、廣告或銷售之物品或服務",
  "notice.legal_content_alert_create_story_body_message11": "製造或散播對公共安全構成直接且嚴重威脅之內容",
  "notice.legal_content_alert_create_story_body_message12": "對於違反注意事項的貼文，本公司可不經另行通知即採取刪除措施或暫停帳號使用",
  "notice.legal_content_alert_create_story_body_message13": "本公司可將用戶創建故事之文字、相片等用於行銷活動",
  "notice.legal_content_alert_create_story_tail_message": "因違反注意事項所產生之一切法律責任<br/>均由故事創作者承擔",
  "notice.legal_content_alert_create_story_button": "同意後創建故事",
  "ai.create_edit_title.cover_name": "AI服務",
  "ai.create_edit_title.name": "AI相片",
  "ai.create_edit_title.cover_message": "使用BubbleChat AI 製作專屬我的封面",
  "ai.create_screen_title.image_similarity_name": "相似度",
  "ai.create_screen_title.image_similarity_message": "相似度越高，原始圖像的保留程度就越高!",
  "ai.create_screen_title.image_style_name": "風格",
  "ai.create_screen_title.image_view_all_name": "全部顯示",
  "ai.create_screen_title.image_prompt_name": "提示詞",
  "ai.create_screen_title.image_prompt_example_name": "提示詞範例",
  "ai.create_screen_title.image_prompt_example_description1": "把這個女生相片的背景改成外太空",
  "ai.create_screen_title.image_prompt_example_description2": "一個女生在外太空",
  "ai.create_screen_title.image_prompt_example_description3": "把他變成八十歲老人，而且要全身照",
  "ai.create_screen_title.image_prompt_example_description4": "八十歲老人、皺紋、全身照",
  "ai.create_screen_title.image_prompt_example_description5": "少年、面無表情、金髮、白皮膚、白T恤、牛仔褲、森林",
  "ai.create_screen_title.image_prompt_example_description6": "帥哥、二十幾歲、褐色頭髮、綠色眼睛、藍襯衫、白T恤、黑褲、溫柔微笑、下雨天、路、拿著雨傘的男生",
  "ai.create_screen_title.image_prompt_example_description7": "躺在海邊的躺椅上做日光浴的男生手拿雞尾酒、椰子樹、海鷗",
  "ai.create_screen_title.image_prompt_example_description8": "剪影、夜晚棲息在樹枝上的貓頭鷹剪影的電影膠片、非常細緻的朦朧光效、從背後照亮、4k uhd 傑作",
  "ai.create_screen_title.image_prompt_description": "請說明想生成的相片",
  "ai.create_screen_title.original_image_button": "直接使用",
  "ai.create_screen_title.random_image_button": "隨機生成相片",
  "ai.create_screen_title.ai_image_button": "用AI生成相片",
  "ai.create_screen_title.return_message": "您不使用已生成的相片，要直接退出嗎?",
  "ai.create_studio_background_color_edit_name": "編輯背景顏色",
  "ai.create_studio_background_upload_fail_message": "上傳相片失敗",
  "ai.create_studio_background_example_description1": "藍天和廣闊海邊",
  "ai.create_studio_background_example_description2": "整片的藍天背景",
  "ai.create_studio_background_example_description3": "上半部是灰色天花板，下半部是課桌椅",
  "ai.create_studio_background_example_description4": "藍天和山、老韓屋巷弄",
  "ai.create_studio_background_example_description5": "雨天、在有氣氛的燈光下被點亮的都市",
  "ai.create_studio_background_example_description6": "粉彩色的倉庫內部",
  "ai.create_studio_background_example_description7": "繁星夜空下的戶外泳池",
  "ai.create_studio_background_example_description8": "相片上半部留白，下半部是房屋之間的巷弄",
  "ai.loading_screen_advertising_message1": "輕輕一點就能享受的故事",
  "ai.loading_screen_advertising_message2": "在BubbleChat上輕鬆創造專屬我的故事!",
  "ai.loading_screen_alert_description": "目前等待人數",
  "ai.loading_screen_alert_message": "AI相片生成中",
  "ai.loading_screen_alert_message2": "等待服務中，請稍候",
  "ai.result_screen_alert_message": "AI相片生成成功!",
  "ai.result_screen_alert_prompt_description1": "請下達指令!",
  "ai.result_screen_alert_prompt_description2": "請換個說法下達指令!",
  "ai.result_screen_title.ai_image_button1": "重新生成",
  "ai.result_screen_title.ai_image_button2": "使用",
  "ai.result.fail_create_image_message": "AI相片生成失敗",
  "ai.button_background": "背景",
  "notification.list_title": "通知",
  "notification.my_news_title": "我的通知",
  "notification.freebie_reads_title": "倒數免費",
  "notification.events_title": "活動",
  "notification.bubble_title": "代幣",
  "notification.notice_title": "公告",
  "notification.list_unread_notification": "未讀的提醒",
  "notification.list_all_read": "全部已讀",
  "notification.delete_90days_message": "您沒有新通知",
  "notification.delete_90days_message_part2": "通知在90天後會自動刪除",
  "notification.notice_history_headline_description": "可以至BubbleChat APP內確認通知的詳細內容",
  "tag.title": "主題標籤",
  "tag.selection": "請選擇1~10個主題標籤",
  "tag.selection_notification": "請選擇1個以上的主題標籤",
  "tag.suggestion_button": "建議主題標籤",
  "tag.suggestion_title": "建議主題標籤",
  "tag.suggestion_description": "若您想新增主題標籤請告訴我們<br/>我們將透過內部審核評估是否新增",
  "tag.suggestion_placeholder": "填寫主題標籤名稱及需求",
  "tag.suggestion_submission_button": "建議",
  "tag.selection_untap": "選擇主題標籤來尋找您想看的故事!",
  "tag.suggestion_no_match": "沒有符合此主題標籤的故事",
  "search.category_story_tab_msg": "搜尋想看的故事",
  "search.category_profile_tab_msg": "搜尋想找的暱稱",
  "search.category_title_list_null_message": "沒有符合您搜尋條件的故事",
  "search.category_profile_null_message": "沒有符合您搜尋條件的暱稱",
  "search.asset_none": "沒有您要找的素材",
  "search.story": "搜尋想看的故事",
  "topup.purchase_receive_bonus": "參加任務來獲得免費泡泡",
  "report.result_title": "您的檢舉已送出",
  "report.result_description": "我們會仔細審查<br/>您提交的檢舉內容",
  "report.error_occurred": "提交檢舉時發生錯誤!",
  "report.result_fail_description": "很抱歉造成您的不便<br/>請再重新嘗試",
  "report.type.chat_sexual_content": "色情內容",
  "report.type.chat_violent_content": "暴力",
  "report.type.chat_hate_discrimination": "仇恨歧視言論",
  "report.type.chat_privacy_violation": "侵犯隱私",
  "report.type.chat_other": "其他",
  "chapter.read_end_comment_list_null_message": "請留下留言",
  "chapter.list_null_message": "尚未有公開的故事",
  "library.category_favorites_asset_add_msg": "將您喜歡的素材<br/>加入我的最愛",
  "library.category_favorites_list_null_message": "將您有興趣的故事加上書籤",
  "library.category_purchased_story_list_null_message": "購買故事",
  "network.internet_no_connection_title": "無法連線到網際網路",
  "network.internet_no_connection_message": "您沒有連接到網路<br/>請重新嘗試連線",
  "setting.edit_delete_account_button": "刪除會員帳號",
  "setting.edit_delete_account_screen_name": "刪除會員帳號",
  "setting.edit_delete_account_screen_agree_alert_set_password_title": "請先設定密碼",
  "setting.edit_delete_account_screen_agree_alert_set_password_description": "您尚未設定密碼，請先設定密碼",
  "setting.edit_delete_account_screen_title": "確定要刪除會員帳號嗎?",
  "setting.edit_delete_account_screen_description": "刪除會員後無法再使用BubbleChat和其他作者提供的世界觀及故事",
  "setting.edit_delete_account_screen_agree_message": "已確認以下內容並同意其內容",
  "setting.edit_delete_account_screen_agree_story_message": "您創作的故事會全部刪除，無法再次復原<br/>除了您購買的故事，其他付費、免費購買的所有內容都會全部刪除，無法再次復原。",
  "setting.edit_delete_account_screen_agree_post_message": "您所撰寫的貼文，凡是用您本人帳號發的內容將一律刪除。<br/>但是，若該貼文已被第三人轉載、收藏、分享或重新發布，或是發布在公開佈告欄上的內容，則不會被刪除。",
  "setting.edit_delete_account_screen_agree_revenue_message": "您透過故事、話次等銷售的內容所產生的所有收益記錄將會消失，且無法復原。<br/>此外，您也無法申請提領收益餘額。",
  "setting.edit_delete_account_screen_agree_delete_message": "刪除會員帳號後仍會依法在一定期限內保管您的個人資料，期限一到即刻刪除。",
  "setting.edit_delete_account_screen_agree_verification_message": "實名認證後若選擇退出會員，七日內無法再使用同一身分進行實名認證",
  "setting.edit_delete_account_screen_agree_confirm_password_message": "輸入密碼以確認身分",
  "setting.edit_delete_account_screen_agree_alert_agree_title": "請同意所有內容",
  "setting.edit_delete_account_screen_agree_alert_agree_description": "同意所有內容後刪除會員帳號",
  "setting.edit_delete_account_screen_agree_alert_password_title": "密碼錯誤",
  "setting.edit_delete_account_screen_agree_alert_password_description": "請輸入使用中的密碼",
  "setting.edit_delete_account_screen_agree_alert_delete_account_title": "成功刪除會員帳號",
  "setting.edit_delete_account_screen_agree_alert_delete_account_description": "BubbleChat隨時等待大家的故事",
  "identity.verification": "實名認證",
  "identity.verification.adult": "實名認證",
  "identity.verification_request": "請進行實名認證",
  "identity.verification_completed": "已完成實名認證",
  "identity.reverification_completed_title": "重新認證成功",
  "identity.reverification_completed_description": "您現在可以繼續正常使用成人內容。",
  "identity.verification_explanation1": "實名認證是合法程序，用來證明您所使用的帳號確實屬於您本人",
  "identity.verification_explanation2": "每人最多可用同一身份驗證兩個帳號",
  "identity.verification_explanation3": "完成實名認證後，無法刪除資料和變更名義",
  "identity.verification_explanation4": "若在BubbleUp中入選，必須完成實名認證，才能進行後續流程",
  "identity.verification_notify1": "我同意<link1>個人資料的蒐集、處理及利用</link1>",
  "identity.verification_notify2": "我同意，若盜用他人身份或使用非本人個人資料，將承擔所有法律責任",
  "identity.verification_toverify": "認證",
  "identity.verification_expired": "實名認證已過期",
  "identity.verification_success": "實名認證成功",
  "identity.verification_completed2": "認證成功",
  "identity.verification_complete_date": "完成實名認證日期",
  "identity.verification_failed": "實名認證失敗",
  "identity.verification_cancelled": "該用戶已取消實名認證",
  "identity.verification_failed_reason_unknown": "因不明原因認證失敗",
  "identity.verification_fail_message": "實名認證失敗",
  "identity.verification_success_message": "實名認證成功",
  "charging_stn.free_tap": "免費儲值站",
  "charging_stn.paid_tap": "付費儲值站",
  "charging_stn.free_msg_choose_button": "按下您喜歡的按鍵",
  "charging_stn.free_msg_get_bubbles": "獲取免費泡泡吧",
  "charging_stn.top_title": "泡泡儲值站",
  "charging_stn.top_title_a": "免費泡泡儲值站",
  "charging_stn.button_bubble": "泡泡儲值站",
  "charging_stn.button_preparing": "準備中",
  "charging_stn.info_msg": "泡泡儲值站使用須知",
  "charging_stn.info_msg_expiration": "在儲值站獲取的廣告獎勵有七日的有效期限",
  "charging_stn.info_msg_refund": "在儲值站獲取的廣告獎勵不可退款",
  "charging_stn.info_msg_charge_time": "看完廣告後，發送獎勵最多需要三分鐘",
  "charging_stn.info_msg_inquiry": "若獎勵未正常發送，請洽各泡泡儲值站的客服中心，將在確認後發送",
  "charging_stn.free_button": "泡泡儲值站 {{int_number}}號",
  "payment.page_bubble_zero": "我的泡泡",
  "payment.page_bubble_one": "我的泡泡",
  "payment.page_bubble_other": "我的泡泡",
  "payment.page_paid_bubble_zero": "付費泡泡",
  "payment.page_paid_bubble_one": "付費泡泡",
  "payment.page_paid_bubble_other": "付費泡泡",
  "payment.page_bonus_bubble_zero": "免費泡泡",
  "payment.page_bonus_bubble_one": "免費泡泡",
  "payment.page_bonus_bubble_other": "免費泡泡",
  "payment.page_reward_bubble_zero": "發送泡泡",
  "payment.page_reward_bubble_one": "發送泡泡",
  "payment.page_reward_bubble_other": "發送泡泡",
  "payment.page_purchase_tab": "儲值",
  "payment.page_spent_tab": "付費購買",
  "payment.page_bonus_tab": "回饋",
  "payment.page_list_bubble_zero": "泡泡",
  "payment.page_list_bubble_one": "泡泡",
  "payment.page_list_bubble_other": "泡泡",
  "payment.history_rewards": "獎勵",
  "payment.history_awarded_bonus": "發送回饋",
  "payment.history_expired_bonus": "已過有效期限",
  "payment.history_ad_reward": "看廣告拿獎勵",
  "payment.history_adj": "調整",
  "payment.history_purchased_ep": "購買話次",
  "payment.history_rented_ep": "借閱話次",
  "payment.history_in_app_purchase": "APP內購買",
  "payment.history_topup_bubble": "購買泡泡",
  "payment.history_refunded": "退費",
  "payment.history_receive_bonus": "參加任務來獲得免費泡泡",
  "payment.history_purchase_shampoo_title": "購買",
  "payment.history_purchase_shampoo_detail": "洗髮精結帳",
  "payment.history_refund_shampoo": "退費",
  "payment.history_refund_for_censored_image": "已審查之相片退款",
  "payment.status_progress": "結帳進行中",
  "payment.status_failed": "結帳失敗，相關疑問請洽<link1>客服中心</link1>",
  "payment.status_invalid_info": "您輸入的卡片資訊無效<br/>請重新嘗試",
  "payment.status_completed": "已完成結帳",
  "payment.status_successful": "已成功結帳!",
  "payment.unavailable_paid_episodes": "無法借閱或購買付費話次",
  "chat.home_home_title": "首頁",
  "chat.home_characters_title": "角色",
  "chat.home_characters_count_zero": "角色",
  "chat.home_characters_count_one": "角色",
  "chat.home_characters_count_other": "角色",
  "chat.home_universes_title": "世界觀",
  "chat.home_universes_count_zero": "世界觀",
  "chat.home_universes_count_one": "世界觀",
  "chat.home_universes_count_other": "世界觀",
  "chat.home_scenes_title": "場景",
  "chat.home_scenes_count_zero": "場景",
  "chat.home_scenes_count_one": "場景",
  "chat.home_scenes_count_other": "場景",
  "chat.home_nsfw_toggle": "臉紅心跳模式",
  "chat.home_nsfw_toggle_modal_title": "臉紅心跳模式涉及成人內容。",
  "chat.home_nsfw_toggle_modal_description": "未滿18歲無法使用。<br/>您滿18歲了嗎?",
  "chat.home_nsfw_toggle_modal_confirm": "我滿18歲了。",
  "chat.home_nsfw_toggle_modal_cancel": "我還沒滿18歲。",
  "chat.home_nsfw_toggle_reject_country_modal_title": "您的所在地區無法使用該服務。",
  "chat.home_first_title": "專屬於你和你的角色的世界",
  "chat.home_first_select_character": "您想和什麼樣的角色對話呢?",
  "chat.home_first_select_character_female": "女性角色",
  "chat.home_first_select_character_male": "男性角色",
  "chat.home_first_start_chat": "開始對話",
  "chat.home_first_failed_character_list_message": "啊!載入角色清單失敗",
  "chat.home_first_failed_character_list_refresh_message": "請重新整理",
  "chat.home_first_failed_character_list_refresh_button": "重新整理",
  "chat.home_nsfw_toggle_mobile": "臉紅心跳",
  "chat.home_first_shampoo_empty": "洗髮精已全部使用完畢",
  "chat.home_first_verification_super_shampoo": "只要現在進行實名認證，就能立即免費升級成超級洗髮精，來試試能讓你24小時內聊到飽的超級洗髮精!",
  "chat.home_first_verification_super_shampoo_description": "*超級洗髮精比一般洗髮精的容量多十倍!<br/>*還有洗髮精時可免費聊天<br/>*洗髮精補充最多需要24小時",
  "chat.home_first_verification_no_thanks": "不用了",
  "chat.home_first_verification_button": "實名認證",
  "chat.home_first_upgrade_super_shampoo": "升級成超級洗髮精!",
  "chat.home_first_shampoo_bubbles_empty": "一般洗髮精和泡泡全部使用完畢",
  "chat.home_first_normal_shampoo_empty": "一般洗髮精已全部使用完畢",
  "chat.home_first_get_super_shampoo": "獲取超級洗髮精",
  "chat.home_first_no_show_again": "不再查看",
  "chat.home_first_verification_super_shampoo_upgrade": "初次實名認證，即可獲得免費升級成「超級洗髮精」，進行免費三日對話的機會!",
  "chat.home_first_sign_in": "登入後即可每天用 <strong>洗髮精</strong><br/>免費聊天!",
  "chat.home_first_start_kakao": "以<strong>Kakao</strong>帳戶繼續",
  "chat.home_first_start_google": "以<strong>Google</strong>帳戶繼續",
  "chat.home_first_start_apple": "以<strong>Apple</strong>帳戶繼續",
  "chat.home_first_welcome_title": "歡迎您加入!",
  "chat.home_first_welcome_sub_title": "歡迎您的加入，送您超級洗髮精，立即和豐富的角色對話。",
  "chat.home_first_welcome_description": "想進行比現在多十倍的免費對話，就立即實名認證後獲取超級洗髮精",
  "chat.home_first_welcome_regular": "使用一般洗髮精",
  "chat.home_first_welcome_super": "使用超級洗髮精",
  "chat.home_first_wait_title": "等等!您還可以繼續聊天",
  "chat.home_first_wait_description": "十秒完成實名認證，繼續用超級洗髮精免費聊天",
  "chat.home_first_wait_topup": "前往儲值",
  "chat.home_first_wait_verify": "實名認證",
  "chat.home_first_supershampoo_title": "用超級洗髮精升級成功!",
  "chat.home_first_supershampoo_description": "現在開始24小時內，可進行比平常多十倍的對話次數<br/>可至「我的頁面」確認超級洗髮精",
  "chat.home_first_supershampoo_done": "確認",
  "chat.home_more_button": "更多",
  "chat.home_sidebar_create": "創建",
  "chat.home_sidebar_reward": "獎勵",
  "chat.home_recent_chats": "最近的對話",
  "chat.title_chat_list": "對話清單",
  "chat.home_sidebar_chat_list": "對話清單",
  "chat.home_sidebar_favorites": "我的最愛",
  "chat.home_sidebar_likes": "讚",
  "chat.home_sidebar_charging_station": "儲值站",
  "chat.home_sidebar_guide": "使用手冊",
  "chat.home_sidebar_bg_fx": "背景效果",
  "chat.home_sidebar_bubbletap": "BubbleTap",
  "chat.home_sidebar_download": "下載",
  "chat.home_sidebar_display": "顯示模式",
  "chat.home_sidebar_community": "社群",
  "chat.home_sidebar_discord": "Discord",
  "chat.home_sidebar_bubble_apartment": "泡泡的小公寓",
  "chat.home_sidebar_facebook": "Facebook",
  "chat.home_sidebar_x": "官方 X",
  "chat.home_sidebar_kakaotalk": "KakaoTalk",
  "chat.home_sidebar_threads": "Threads",
  "chat.home_sidebar_instagram": "Instagram",
  "chat.home_sidebar_pinterest": "Pinterest",
  "chat.tap_order_recent": "依新到舊排序",
  "chat.tap_order_liked": "最多人按讚",
  "chat.tap_order_played": "最多人玩",
  "chat.tap_asset_sort_all": "全部",
  "chat.tap_asset_sort_week": "每週排行榜",
  "chat.tap_asset_sort_month": "每月排行榜",
  "chat.tap_asset_tap_rising": "熱門",
  "chat.tap_asset_tap_follow": "追蹤",
  "chat.tap_asset_tap_follow_empty": "尚未追蹤任何創作者",
  "chat.tap_asset_tap_follow_featured_creators": "推薦創作者",
  "chat.tap_asset_tap_follow_featured_creators_failed": "推薦創作者載入失敗<br/> 請稍後再試",
  "chat.tap_asset_tap_now": "最新",
  "chat.tap_asset_more_options_button": "更多設定",
  "chat.tap_asset_more_options_modal_title": "篩選",
  "chat.tap_asset_more_options_modal_sort": "排序",
  "chat.tap_asset_more_options_modal_gender": "角色性別",
  "chat.tap_asset_modal_all_characters": "全部角色",
  "chat.tap_asset_modal_male_characters": "男性角色",
  "chat.tap_asset_modal_female_characters": "女性角色",
  "chat.tap_asset_modal_other_characters": "其他角色",
  "chat.tap_asset_modal_type": "類型",
  "chat.tap_asset_modal_random": "隨機",
  "chat.tap_asset_more_options_modal_latest": "依新到舊排序",
  "chat.tap_asset_more_options_modal_multi_images": "多張相片",
  "chat.tap_asset_more_options_modal_most": "多到少",
  "chat.tap_asset_more_options_modal_least": "少到多",
  "chat.tap_asset_more_options_modal_none": "無",
  "chat.tap_asset_more_options_modal_most_commented": "依留言排序",
  "chat.tap_asset_more_options_modal_sort_none": "無",
  "chat.tap_asset_empty": "此條件無搜尋結果",
  "chat.home_login": "登入",
  "chat.home_terms_of_service": "服務條款",
  "chat.home_privacy_policy": "個人資料使用告知事項",
  "chat.home_operational_policy": "營運規章",
  "chat.home_juvenile_protection_policy": "兒童及少年福利與權益保障法",
  "chat.home_app_downloads_appstore": "到App Store下載BubbleChat",
  "chat.home_app_downloads_googleplay": "到Google Play下載BubbleChat",
  "chat.home_notification_list_unread": "待確認的通知",
  "chat.home_notification_list_read_all": "全部已讀",
  "chat.home_notification_list_view_more": "查看詳細資訊",
  "chat.home_notification_setting": "通知設定",
  "chat.home_notification_setting_agree_date": "同意日期",
  "update.setting_comment_label": "留言通知",
  "update.setting_comment_description": "當我的素材有新留言時，會收到通知。",
  "update.setting_reply_label": "留言回覆通知",
  "update.setting_reply_description": "我的留言有新回覆時，會收到通知。",
  "update.setting_like_label": "按讚通知",
  "update.setting_like_description": "有人按讚我的素材、留言、回覆時，會收到通知。",
  "update.setting_follow_label": "追蹤通知",
  "update.setting_follow_description": "有人追蹤我時，會收到通知。",
  "update.setting_event_label": "活動通知",
  "update.setting_event_description": "可以收到活動通知。",
  "update.setting_nighttime_event_label": "夜間活動通知",
  "update.setting_nighttime_event_description": "21點~8點會收到活動通知。",
  "update.setting_depletion_label": "泡泡使用完畢通知",
  "update.setting_depletion_description": "泡泡使用完畢時，會收到通知。",
  "update.setting_personal_label": "重要私人通知",
  "update.setting_personal_description": "會收到私人的重要通知。",
  "update.setting_official_label": "BubbleChat重要公告",
  "update.setting_official_description": "會收到BubbleChat的重要公告通知",
  "chat.list_empty": "開始跟喜歡的角色進行對話",
  "chat.list_menu_view_details": "查看詳細資訊",
  "chat.list_menu_delete": "刪除",
  "chat.list_menu_delete_alert_cancel": "取消",
  "chat.list_menu_delete_alert_delete": "刪除",
  "chat.list_modal_character_title": "角色",
  "chat.list_modal_character_description": "角色說明",
  "chat.list_modal_character_information": "詳細資訊",
  "chat.list_modal_character_information_gender": "性別",
  "chat.list_modal_character_information_age": "年齡",
  "chat.list_modal_character_information_age_help_text": "* 20歲以下的角色沒辦法用臉紅心跳模式創建",
  "chat.list_modal_character_information_job": "職業",
  "chat.list_modal_character_information_character": "個性",
  "chat.list_modal_character_information_speaking_style": "語氣",
  "chat.list_modal_character_information_interests": "興趣",
  "chat.list_modal_character_information_details": "補充說明",
  "chat.list_modal_character_information_details_private_exist": "存在不公開的補充說明",
  "chat.list_modal_first_sentence": "第一句話",
  "chat.list_modal_universe": "世界觀",
  "chat.list_modal_scene": "場景",
  "chat.list_modal_persona_title": "我的人格",
  "chat.list_modal_persona_information": "詳細資訊",
  "chat.list_modal_persona_gender": "性別",
  "chat.list_modal_persona_age": "年齡",
  "chat.list_modal_persona_job": "職業",
  "chat.list_modal_persona_character": "個性",
  "chat.list_modal_persona_speaking_style": "語氣",
  "chat.list_modal_persona_interests": "興趣",
  "chat.list_modal_persona_details": "詳細說明",
  "chat.list_modal_universe_title": "世界觀",
  "chat.list_modal_universe_relationship": "角色和我的關係",
  "chat.list_modal_universe_introduction": "世界觀說明",
  "chat.list_modal_universe_details": "補充說明",
  "chat.list_modal_universe_private_relationship": "存在不公開的關係設定",
  "chat.list_modal_universe_private_details": "存在不公開的補充說明",
  "chat.list_modal_scene_title": "場景",
  "chat.list_modal_scene_details": "補充說明",
  "chat.list_modal_scene_private_details": "存在不公開的補充說明",
  "chat.list_modal_edit_chat_name_title": "聊天室名稱",
  "chat.list_modal_edit_chat_name_placeholder": "輸入聊天室名稱",
  "chat.list_edit_chat_selected": "已選擇{{int_numbers}}個",
  "chat.list_edit_delete_button": "刪除聊天室",
  "chat.list_edit_select": "選擇項目",
  "chat.list_edit_delete": "刪除",
  "chat.list_edit_delete_all": "全部刪除",
  "chat.list_edit_select_all": "全選",
  "chat.list_edit_deselect_all": "取消全選",
  "chat.list_edit_chats": "編輯聊天室",
  "chat.list_edit_delete_failed": "刪除失敗，請重新嘗試",
  "chat.list_edit_edit_failed": "編輯時發生錯誤，請重新嘗試",
  "chat.information_character_title": "角色",
  "chat.information_character_none": "您沒有選擇角色",
  "chat.information_asset_information": "資訊",
  "chat.information_asset_information_nsfw": " 臉紅心跳",
  "chat.information_unit_thousand": "千",
  "chat.information_unit_ten_thousand": "萬",
  "chat.information_unit_hundred_million": "億",
  "chat.information_asset_information_first_release": "最初公開日",
  "chat.information_character_deleted_account": "不存在的用戶",
  "chat.information_character_deleted_account_toast": "不存在的用戶",
  "chat.information_start_chat": "開始對話",
  "chat.information_start_chat_guest": "開始對話",
  "chat.information_resume_chat": "繼續對話",
  "chat.information_custom_chat": "自訂對話",
  "chat.information_like": "讚",
  "chat.information_like_fail_message": "按讚失敗",
  "chat.information_unlike_fail_message": "取消按讚失敗",
  "chat.information_favorite": "加到我的最愛",
  "chat.information_favorite_fail_message": "加到我的最愛失敗",
  "chat.information_unfavorite_fail_message": "取消加到我的最愛失敗",
  "chat.information_persona": "目前選擇的人格",
  "chat.information_persona_active": "使用中",
  "chat.information_persona_add": "新增人格",
  "chat.information_character_introduction": "角色說明",
  "chat.information_information": "詳細資訊",
  "chat.information_character_gender": "性別",
  "chat.information_character_age": "年齡",
  "chat.information_character_job": "職業",
  "chat.information_character_character": "個性",
  "chat.information_character_speaking_style": "語氣",
  "chat.information_character_interests": "興趣",
  "chat.information_details": "補充說明",
  "chat.information_details_user": "我",
  "chat.information_details_private_only": "不公開的補充說明",
  "chat.information_details_private_exist": "存在不公開的補充說明",
  "chat.information_first_sentence": "第一句話",
  "chat.information_universe": "世界觀",
  "chat.information_universe_none": "世界觀",
  "chat.information_more": "更多",
  "chat.information_scene": "場景",
  "chat.information_scene_none": "您沒有選擇的場景 ",
  "chat.custom_selected_universe": "我選擇的世界觀",
  "chat.custom_selected_scene": "我選擇的場景",
  "chat.information_delete": "刪除",
  "chat.information_edit": "編輯",
  "chat.information_delete_alert_message_universe": "若刪除，所有套用此世界觀的角色將會被解除套用<br/>您確定要刪除嗎?",
  "chat.information_delete_alert_message_scene": "若刪除，所有套用此場景的角色將會被解除套用<br/>您確定要刪除嗎?",
  "chat.information_delete_alert_message_failed": "刪除失敗，請重新嘗試",
  "chat.information_delete_alert_cancel": "取消",
  "chat.information_delete_alert_delete": "刪除",
  "chat.information_reviews_submit_button": "留言",
  "chat.information_reviews_placeholder": "請輸入留言",
  "chat.information_reviews_empty": "尚無留言",
  "chat.information_reviews_few_seconds": "幾秒前",
  "chat.information_reviews_seconds": "{{int_seconds}}秒前",
  "chat.information_reviews_minutes": "{{int_minutes}}分前",
  "chat.information_reviews_hours": "{{int_hours}}小時前",
  "chat.information_reviews_view_translation": "翻譯年糕",
  "chat.information_reviews_view_original": "查看原文",
  "chat.information_reviews_view_translation_unsupported_language_toast": "不支援的語言。",
  "chat.information_reviews_delete failed": "刪除失敗",
  "chat.information_reviews_deleted_user_username": "已刪除的用戶",
  "chat.information_reviews_deleted_user_review": "已刪除用戶的留言",
  "chat.information_reviews_deleted_review": "已刪除的留言",
  "chat.information_replies": "回覆",
  "chat.information_sort_recent": "依新到舊排序",
  "chat.information_sort_liked": "熱門排序",
  "chat.information_new_comment": "有一則新留言",
  "chat.information_new_reply": "我的留言有新回覆",
  "chat.information_write_comment": "請寫下您的留言",
  "chat.information_write_reply": "撰寫回覆",
  "chat.information_reply_delete_fail_message": "無法刪除回覆",
  "chat.information_delete_comment_alert": "確定要刪除留言嗎?",
  "chat.information_delete_reply_alert": "確定要刪除回覆嗎?",
  "chat.information_comment_characters_limit_message": "留言最多能輸入1,000字",
  "chat.information_reply_characters_limit_message": "回覆最多能輸入1,000字",
  "chat.information_comment_character": "{{string_characterName}}角色有一則新留言",
  "chat.information_comment_universe": "{{string_universeName}} 世界觀有一則新留言",
  "chat.information_comment_scene": "{{string_sceneName}} 場景有一則新留言",
  "chat.information_comment_edit_placeholder": "請輸入內容",
  "chat.information_reply_edit_placeholder": "請輸入內容",
  "chat.information_comment_edit": "編輯",
  "chat.information_comment_delete": "刪除",
  "chat.information_comment_edit_done": "編輯",
  "chat.information_comment_edit_cancel": "取消",
  "chat.information_comment_view_all_comment": "查看所有留言",
  "chat.information_comment_pin_failed": "留言釘選失敗",
  "chat.information_comment_unpin_failed": "留言取消釘選失敗",
  "chat.information_comment_post_failed": "留言失敗",
  "chat.information_comment_edit_failed": "編輯留言失敗",
  "chat.information_comment_delete_success": "已刪除留言",
  "chat.information_comment_delete_failed": "刪除留言失敗",
  "chat.information_comment_like_failed": "按讚留言失敗",
  "chat.information_comment_report_success": "已成功檢舉",
  "chat.information_comment_report_failed": "檢舉失敗",
  "chat.information_reply_post_failed": "回覆失敗",
  "chat.information_reply_edit_failed": "編輯回覆失敗",
  "chat.information_reply_delete_success": "已刪除回覆",
  "chat.information_reply_delete_failed": "刪除回覆失敗",
  "chat.information_reply_like_failed": "按讚回覆失敗",
  "chat.information_reply_report_success": "已成功檢舉",
  "chat.information_reply_report_failed": "檢舉失敗",
  "chat.information_comment_reply_deleted_comment": "無法回覆已刪除的留言",
  "chat.information_comment_pin_deleted_comment": "無法釘選或取消釘選已刪除的留言",
  "chat.information_reviews_report": "檢舉",
  "chat.information_reviews_report_modal_title": "檢舉留言",
  "chat.information_reply_report_modal_title": "檢舉回覆",
  "chat.information_reply_deleted_user": "已刪除用戶的回覆",
  "chat.information_reply_deleted": "已刪除的回覆",
  "chat.information_leave_reply": "請寫下您的回覆",
  "chat.information_comment_button_submit_only": "提交",
  "chat.information_comment_show_more": "更多",
  "chat.information_comment_show_less": "隱藏",
  "chat.information_comment_show_more2": "展開",
  "chat.information_reviews_report_modal_description": "請告訴我們您檢舉的原因",
  "chat.information_reviews_report_modal_dropdown": "選擇檢舉原因",
  "chat.information_reviews_report_modal_misconduct": "不當舉動",
  "chat.information_reviews_report_modal_unapproved": "未經許可的廣告",
  "chat.information_reviews_report_modal_personal": "洩漏個人資料",
  "chat.information_reviews_report_modal_promo": "廣告",
  "chat.information_reviews_report_modal_other": "其他",
  "chat.information_reviews_report_modal_placeholder": "輸入檢舉原因",
  "chat.information_reviews_report_modal_cancel": "取消",
  "chat.information_reviews_report_modal_submit": "傳送",
  "chat.information_character_report_modal_title": "檢舉角色",
  "chat.information_universe_report_modal_title": "檢舉世界觀",
  "chat.information_scene_report_modal_title": "檢舉場景",
  "chat.information_asset_report_modal_copyright_title": "抄襲/侵害著作權",
  "chat.information_asset_report_modal_copyright_description": "抄襲或侵害著作權檢舉將依據證明資料及文件進行處理",
  "chat.information_universe_introduction": "世界觀說明",
  "chat.information_universe_relationship": "角色和我的關係",
  "chat.information_relationship_private_only": "此關係設定不公開",
  "chat.information_relationship_private_exist": "存在不公開的關係設定",
  "chat.information_scene_introduction": "介紹",
  "chat.information_scene_place": "地點",
  "chat.information_scene_time": "時間",
  "chat.information_character_load_fail_message": "角色資訊載入失敗",
  "chat.information_universe_load_fail_message": "世界觀資訊載入失敗",
  "chat.information_scene_load_fail_message": "場景資訊載入失敗",
  "chat.information_private_fail_message_character": "不存在的角色",
  "chat.information_private_fail_message_universe": "不存在的世界觀",
  "chat.information_private_fail_message_scene": "不存在的場景",
  "chat.information_no_chat_nsfw_characters": "臉紅心跳模式限20歲以上的角色使用",
  "chat.information_character_details_private_only": "此為不公開的人物說明。",
  "chat.information_character_details_private_exist": "存在不公開的人物說明。",
  "chat.information_background_details_private_only": "此為不公開的背景說明。",
  "chat.information_background_details_private_exist": "存在不公開的背景說明。",
  "chat.information_lorebook_private_only": "此設定集不公開",
  "chat.information_lorebook_private_exist": "存在不公開的設定集",
  "chat.information_weekly_character": "本週人氣角色",
  "chat.information_weekly_universe": "本週人氣世界觀",
  "chat.information_weekly_scene": "本週人氣場景",
  "chat.custom_title": "自訂對話",
  "chat.custom_help_text_title": "打造專屬我的對話",
  "chat.custom_help_text_description": "自訂我想要的故事元素開始對話",
  "chat.custom_character": "角色",
  "chat.custom_universe": "世界觀",
  "chat.custom_optional": "選擇",
  "chat.custom_scene": "場景",
  "chat.custom_add": "新增",
  "chat.custom_change": "編輯",
  "chat.custom_create": "創建",
  "chat.custom_first_sentence": "第一句話",
  "chat.custom_first_sentence_placeholder": "請輸入{{string_characterName}}的第一句話",
  "chat.custom_first_sentence_edit_modal_title": "編輯第一句話",
  "chat.custom_first_sentence_edit_modal_description": "可以編輯角色的第一句話喔!",
  "chat.custom_first_sentence_edit_modal_placeholder": "請輸入{{string_characterName}}的第一句話",
  "chat.custom_first_sentence_edit_modal_cancel": "取消",
  "chat.custom_first_sentence_edit_modal_save": "編輯",
  "chat.custom_start_chat": "開始對話",
  "chat.custom_character_modal_title": "請選擇角色",
  "chat.custom_modal_done": "選擇完成",
  "chat.custom_modal_tag_placeholder": "搜尋主題標籤",
  "chat.custom_modal_tap_recents": "最近使用紀錄",
  "chat.custom_modal_tap_favorites": "我的最愛",
  "chat.custom_character_modal_tap_my": "我的角色",
  "chat.custom_universe_modal_title": "請選擇世界觀",
  "chat.custom_universe_modal_tap_my": "我的世界觀",
  "chat.custom_scene_modal_title": "請選擇場景",
  "chat.custom_scene_modal_tap_my": "我的場景",
  "chat.custom_select_character": "請選擇角色",
  "chat.custom_select_universe": "請選擇世界觀",
  "chat.custom_select_scene": "請選擇場景",
  "chat.custom_retry": "重新嘗試",
  "chat.custom_back_home": "返回首頁",
  "chat.custom_find_character_failed": "沒有您在找的角色嗎?",
  "chat.custom_go_create_character": "創建我的角色",
  "chat.custom_report_once": "只能檢舉一次",
  "chat.custom_private_universe_selected": "您選擇的是不公開的世界觀，請選擇其他世界觀",
  "chat.custom_private_scene_selected": "您選擇的是不公開的場景，請選擇其他場景",
  "chat.custom_nsfw_age_verification": "年齡驗證後即可使用臉紅心跳模式中的角色、世界觀和場景",
  "chat.custom_no_exist_assets": "包含不存在的角色/世界觀/場景，請重新嘗試",
  "chat.custom_create_chat_failed": "新增聊天室失敗，請重新嘗試",
  "chat.custom_search_characters": "搜尋角色",
  "chat.custom_search_universes": "搜尋世界觀",
  "chat.custom_search_scenes": "搜尋場景",
  "chat.custom_search_no_results": "沒有搜尋結果",
  "chat.custom_select_modal_asset_same_language": "您只能預設相同語言生成的世界觀和場景",
  "chat.character.list_empty": "沒有角色",
  "chat.universe.list_empty": "沒有世界觀",
  "chat.scene.list_empty": "沒有場景",
  "chat.popup_settings_title": "聊天室設定",
  "chat.popup_name_title": "姓名",
  "chat.popup_name_placeholder": "請輸入姓名",
  "chat.popup_chat_mode_title": "風格",
  "chat.popup_chat_mode_chat": "對話型",
  "chat.popup_chat_mode_story": "小說型",
  "chat.popup_model_title": "AI模型",
  "chat.popup_model_estimated_cost": "預估價格",
  "chat.popup_model_estimated_cost_failed": "顯示錯誤",
  "chat.popup_model_estimated_cost_description": "根據您輸入的字數、累積的對話量，和系統輸出的字數，價格可能會有所浮動。",
  "chat.popup_model_diamond": "鑽金",
  "chat.popup_model_dia_description": "極具創意性及理解能力的高品質模式",
  "chat.popup_model_price_bubble": "泡泡",
  "chat.popup_model_emerald": "綠寶石",
  "chat.popup_model_emerald_description": "具一定水準表現能力的穩定模式",
  "chat.popup_model_ruby": "紅寶石",
  "chat.popup_model_ruby_description": "CP值高，反應速度快的模式",
  "chat.popup_model_best": "推薦",
  "chat.popup_nsfw_toggle_title": "臉紅心跳模式",
  "chat.popup_nsfw_toggle_description_nsfw_enable": "臉紅心跳模式限20歲以上的角色使用",
  "chat.popup_nsfw_toggle_description_nsfw_disable": "未滿18歲的角色無法啟用臉紅心跳模式進行對話",
  "chat.popup_done": "確認",
  "chat.popup_label_new": "New",
  "chat.popup_label_beta": "Beta",
  "chat.popup_label_value": "CP值",
  "chat.popup_label_sale": "促銷中",
  "chat.popup_label_date": "~{{int_date}} 為止",
  "chat.popup_chat_ai_model_signature": "Signature",
  "chat.popup_chat_ai_model_basic": "一般",
  "chat.conversation_ai_model_basic_failed_message": "接收訊息失敗，未使用任何泡泡",
  "chat.conversation_ai_model_basic_switch_failed": "AI模型變更失敗",
  "chat.popup_character_switched_nsfw_alert": "已將該角色轉換為臉紅心跳模式",
  "chat.popup_character_switched_nsfw_alert_description": "實名認證後即可開始對話",
  "chat.popup_nsfw_asset_normal_mode_failed_message": "臉紅心跳模式的角色／世界觀／場景無法在一般模式中進行對話。",
  "chat.conversation_menu": "管理聊天室",
  "chat.conversation_username": "姓名",
  "chat.conversation_menu_gallery": "相簿",
  "chat.conversation_menu_display_images": "查看相片",
  "chat.conversation_menu_gallery_unlock_button": "解鎖",
  "chat.conversation_menu_gallery_unlock_image": "對話後取得相片",
  "chat.conversation_menu_gallery_no_images": "相簿目前無相片",
  "chat.conversation_menu_settings": "聊天室設定",
  "chat.conversation_menu_oldbie_shampoo": "洗髮精",
  "chat.conversation_menu_newbie_shampoo": "超級洗髮精",
  "chat.conversation_menu_hyper_shampoo": "高檔洗髮精",
  "chat.conversation_menu_shampoo_loading": "補充中",
  "chat.conversation_menu_shampoo_error": "補充失敗",
  "chat.popup_new_user_title": "恭喜您加入會員!",
  "chat.popup_new_user_description": "恭喜您加入，我們將贈送您可免費對話的「洗髮精」!",
  "chat.popup_newbie_shampoo_title": "已升級為超級洗髮精!",
  "chat.popup_newbie_shampoo_description": "在未來24小時內，您將可以使用超級洗髮精享受更多免費對話",
  "chat.popup_same_identity_under_seven_days_description": "實名認證後若選擇退出會員，七日內無法再使用同一身分進行實名認證",
  "chat.popup_same_identity_over_seven_days_description": "您是現有用戶，可以使用一般洗髮精進行免費對話",
  "chat.popup_newbie_shampoo_history_exist_description": "該帳號已經使用過超級洗髮精福利，現在可以使用一般洗髮精進行免費對話",
  "chat.popup_newbie_to_oldbie_title": "超級洗髮精已使用完畢",
  "chat.popup_newbie_to_oldbie_description": "從現在開始，可以使用一般洗髮精進行免費對話",
  "chat.popup_newbie_to_oldbie_description_purchase": "現在要加購嗎？",
  "chat.popup_shampoo_limit_message": "洗髮精已使用完畢<br/>從現在開始可以使用泡泡進行對話",
  "chat.conversation_menu_charging_station": "儲值泡泡",
  "chat.popup_persona_in_use": "使用中的人格模式",
  "chat.popup_persona_notes": "筆記",
  "chat.popup_persona_notes_placeholder": "寫下人格的筆記",
  "chat.popup_persona_pass_message": "馬上升級洗髮精，體驗能設定更多字數的人格",
  "chat.popup_persona_pass_alert_message": "您現在的人格已超過目前使用券限制之字數<br/>請購買使用券或調整人格字數",
  "chat.popup_persona_content_empty": "您沒有已設定的人格。",
  "chat.popup_persona_deleted_title": "您在使用已刪除的人格。",
  "chat.popup_persona_deleted_description": "編輯人格後無法復原<br/>您確定要編輯人格嗎?",
  "chat.popup_usernote_title": "使用者筆記",
  "chat.popup_usernote_in_use": "使用中的使用者筆記",
  "chat.popup_usernote_pass_message": "馬上升級洗髮精，體驗能設定更多字數的使用者筆記",
  "chat.popup_usernote_pass_alert_message": "現在的使用者筆記內容已超過目前使用券限制之字數<br/>請購買使用券或調整使用者筆記字數",
  "chat.popup_usernote_content_title": "內容",
  "chat.popup_usernote_content_placeholder": "請輸入希望角色記住的內容",
  "chat.popup_usernote_toggle": "套用至對話",
  "chat.popup_usernote_save": "儲存",
  "chat.popup_usernote_save_fail_message": "儲存失敗",
  "chat.popup_usernote_fail_message": "使用者筆記載入失敗",
  "chat.popup_usernote_copied_toast": "已複製使用者筆記內容",
  "chat.popup_usernote_copied_failed_toast": "複製使用者筆記失敗<br/>請重新嘗試",
  "chat.popup_edit_user_message_title": "我傳送的訊息",
  "chat.popup_edit_character_message_title": "角色傳送的訊息",
  "chat.popup_edit_edit_button": "編輯",
  "chat.popup_edit_placeholder": "請輸入內容",
  "chat.popup_edit_deleted_message": "已刪除的訊息",
  "chat.popup_rpm_limit_description_one": "訊息傳送失敗，請{{int_seconds}}秒後再試",
  "chat.popup_rpm_limit_description_other": "訊息傳送失敗，請{{int_seconds}}秒後再試",
  "chat.popup_exit_title": "確定要離開聊天室嗎?",
  "chat.popup_exit_description": "您選擇的角色和聊天紀錄都會消失",
  "chat.bottom_exit_title": "離開聊天室",
  "chat.popup_purchase_title": "您的泡泡不足無法繼續對話",
  "chat.popup_purchase_description": "儲值泡泡後繼續和角色對話",
  "chat.popup_purchase_event_per_chat": "每一則訊息",
  "chat.popup_purchase_button": "前往儲值",
  "chat.conversation_send_message_placeholder": "傳送訊息(動作旁白請輸入於* *內)",
  "chat.conversation_shampoo_refill_alert_toast": "洗髮精已經少於{{int_number}}%了!",
  "chat.conversation_shampoo_refill_alert_toast_button": "補充洗髮精",
  "chat.conversation_current_shampoo_refill_message_modal": "現在的洗髮精",
  "chat.conversation_current_shampoo_refill_description1_modal": "啊!洗髮精見底了!🫣",
  "chat.conversation_current_shampoo_refill_description2_modal": "現在補充洗髮精，對話不中斷",
  "chat.conversation_current_super_shampoo_refill_description3_modal": "超級洗髮精不能延長使用期限，只提供即時補充",
  "chat.conversation_current_hyper_shampoo_refill_description3_modal": "高檔洗髮精不會延長既有使用券期限，只提供即時補充。",
  "chat.conversation_current_shampoo_refill_description5_modal": "您的字數超過目前使用券的限制了",
  "chat.conversation_current_shampoo_refill_description6_modal": "目前的使用券最多只能輸入<strong>{{string_textCount}}字</strong><br/>請購買使用券或調整使用者筆記字數",
  "chat.conversation_current_shampoo_refill_description7_modal": "現在最多只能輸入<strong>{{string_textCount}}字</strong><br/>請購買使用券或是調整人格的字數",
  "chat.conversation_current_shampoo_refill_description8_modal": "您的洗髮精已消耗完畢，可以使用的字數上限已減少",
  "chat.conversation_current_shampoo_refill_description9_modal": "現在最多只能輸入{{string_textCount}}字<br/>請補充洗髮精或是調整使用者筆記的字數",
  "chat.conversation_current_shampoo_refill_description10_modal": "現在最多只能輸入{{string_textCount}}字<br/>請補充洗髮精或是調整人格的字數",
  "chat.conversation_current_shampoo_refill_description11_modal": "您現在使用中的人格和使用者筆記可能沒有正常啟用",
  "chat.conversation_expired_ai_model_change_modal": "此語言模型已不可使用<br/>請改用其他語言模型",
  "chat.conversation_ai_model_change_modal": "聊天室使用中的語言模型<br/>已經終止服務",
  "chat.conversation_ai_model_change_description_modal": "請點選右上方「使用中的AI模型」<br/>改選其他語言模型",
  "chat.conversation_ai_model_change_alert_toast": "此語言模型已終止服務<br/>請點選「使用中的AI模型」改選其他語言模型",
  "chat.conversation_ai_model_pass_modal_title": "升級洗髮精後即可使用",
  "chat.conversation_ai_model_pass_modal_description1": "您目前的使用券無法使用您所選擇的AI模型",
  "chat.conversation_ai_model_pass_modal_description2": "購買使用券，以體驗更多樣的AI模型",
  "chat.conversation_ai_model_pass_modal_back_button": "返回",
  "chat.conversation_ai_model_change_modal2_title": "您目前的使用券無法使用該AI模型",
  "chat.conversation_ai_model_change_modal2_description": "點擊右上角圖示後，變更「使用中的AI模型」",
  "chat.conversation_ai_model_change_alert_toast2": "您目前的使用券無法使用該AI模型，請變更「使用中的AI模型」",
  "chat.conversation_image_unlock_popup_message": "您已解鎖新相片!",
  "chat.conversation_delete_alert_message": "確定要刪除該訊息嗎?",
  "chat.conversation_delete_alert_message_cancel": "取消",
  "chat.conversation_delete_alert_message_delete": "刪除",
  "chat.conversation_delete_message": "已刪除訊息",
  "chat.conversation_text_input_limit_message": "最多只能輸入2000字",
  "chat.conversation_send_message_fail_message": "傳送訊息失敗",
  "chat.conversation_edit_message_fail_message": "編輯訊息失敗",
  "chat.conversation_delete_message_fail_message": "刪除訊息失敗",
  "chat.conversation_send_message_fallback_message": "讀取訊息失敗<br/>請重新進入聊天室",
  "chat.conversation_edit_message_latest_message": "只能編輯最新訊息",
  "chat.conversation_delete_message_latest_message": "只能刪除最新訊息",
  "chat.conversation_reroll_message_latest_message": "只能重新傳送最新訊息",
  "chat.conversation_new_chat_deleted_character": "包含已刪除的角色，無法進行對話",
  "chat.conversation_new_chat_deleted_universe": "包含已刪除的世界觀，無法進行對話",
  "chat.conversation_new_chat_deleted_scene": "包含已刪除的場景，無法進行對話",
  "chat.conversation_load_fail_message": "對話載入失敗",
  "chat.conversation_action": "動作旁白",
  "chat.conversation_image_alert_deleted": "該相片不存在",
  "chat.conversation_image_alert_failed_pin": "相片釘選失敗",
  "chat.conversation_select_model": "請選擇模型",
  "chat.conversation_chat_title": "聊天視窗",
  "chat.conversation_alert_animated_image": "您的瀏覽器不支援播放動態圖片",
  "chat.conversation_alert_load_persona_failed": "人格資訊載入失敗",
  "chat.conversation_select_persona": "請選擇人格",
  "chat.conversation_failed_load_message": "訊息載入失敗",
  "chat.conversation_copied_toast": "已複製",
  "chat.conversation_sidebar_ai_model": "使用中的AI模型",
  "chat.conversation_sidebar_my_persona": "我的人格",
  "chat.conversation_sidebar_character": "角色",
  "chat.conversation_sidebar_universe": "世界觀",
  "chat.conversation_sidebar_scene": "場景",
  "chat.conversation_sidebar_bubbles": "泡泡",
  "chat.conversation_sidebar_free_charging_station": "免費儲值站",
  "chat.conversation_sidebar_next_refill": "下次補充",
  "chat.conversation_sidebar_full_refill": "下次補滿",
  "chat.conversation_sidebar_memory": "記憶",
  "chat.conversation_sidebar_settings": "環境設定",
  "chat.conversation_sidebar_output_settings": "輸出設定",
  "chat.conversation_modal_shampoo_refill_regular_description": "補充速度快十倍，容量也多十倍!升級成超級洗髮精!",
  "chat.conversation_modal_shampoo_refill_title": "補充時間還剩下",
  "chat.conversation_modal_shampoo_refill_count": "剩下時間",
  "chat.conversation_modal_shampoo_refill_count_day": "{{int_numbers}}日",
  "chat.conversation_modal_shampoo_refill_count_hour": "{{int_numbers}}小時",
  "chat.conversation_modal_shampoo_refill_count_minute": "{{int_numbers}}分鐘",
  "chat.conversation_modal_shampoo_refill_count_second": "{{int_numbers}}秒",
  "chat.conversation_modal_tag_first_buy": "限購1次",
  "chat.conversation_modal_tag_n_buy": "限購{{int_numbers}}次",
  "chat.conversation_modal_topup_button": "前往儲值站",
  "chat.conversation_modal_Hold_on": "等等!",
  "chat.conversation_sidebar_long_term_memory": "長期記憶",
  "chat.conversation_long_term_memory_title": "長期記憶",
  "chat.conversation_long_term_memory_auto_summary": "自動摘要",
  "chat.conversation_long_term_memory_content_label": "內容",
  "chat.conversation_long_term_memory_content_placeholder": "請輸入希望角色記住的內容",
  "chat.conversation_long_term_memory_history_button": "歷史紀錄",
  "chat.conversation_long_term_memory_ok_button": "確認",
  "chat.conversation_long_term_memory_history_title": "您可以確認、套用之前的記憶",
  "chat.conversation_long_term_memory_history_latest": "依新到舊排序",
  "chat.conversation_long_term_memory_history_earliest": "依舊到新排序",
  "chat.conversation_long_term_memory_history_back": "退出",
  "chat.conversation_long_term_memory_history_save": "儲存",
  "chat.conversation_long_term_memory_history_empty": "無已儲存的記憶歷史紀錄",
  "chat.conversation_long_term_memory_edit_content": "內容",
  "chat.conversation_long_term_memory_failed_delete": "刪除失敗，請重新嘗試",
  "chat.conversation_long_term_memory_delete": "刪除",
  "chat.conversation_long_term_memory_cancel": "取消",
  "chat.conversation_long_term_memory_edit_title": "編輯長期記憶",
  "chat.conversation_long_term_memory_failed_save": "儲存失敗",
  "chat.conversation_long_term_memory_select_history": "選擇項目",
  "chat.conversation_long_term_memory_setting": "設定",
  "chat.conversation_long_term_memory_next_summary_in": "離下次摘要還剩",
  "chat.conversation_long_term_memory_turn_zero": "次對話",
  "chat.conversation_long_term_memory_turn_one": "次對話",
  "chat.conversation_long_term_memory_turn_other": "次對話",
  "chat.conversation_long_term_memory_summary_settings": "摘要設定",
  "chat.conversation_long_term_memory_summary_frequency": "摘要頻率",
  "chat.conversation_long_term_memory_character_limit": "字數限制",
  "chat.conversation_long_term_memory_characters": "字",
  "chat.conversation_long_term_memory_character_limit_description": "當摘要內容達到字數限制時，全部記憶將會被壓縮儲存，並產生歷史紀錄。",
  "chat.conversation_long_term_memory_summary_prompt_title": "提示詞摘要",
  "chat.conversation_long_term_memory_character_auto_button": "自動",
  "chat.conversation_long_term_memory_character_custom_button": "自行輸入",
  "chat.conversation_long_term_memory_character_custom_description": "*您設定的內容會全數套用到所有聊天室",
  "chat.conversation_long_term_memory_auto_summary_toast": "摘要內容會以累積的方式儲存，當達到一定字數時，系統會自動進行摘要",
  "chat.conversation_long_term_memory_replace_history_alert": "既有內容將變更為您所選的歷史記錄，確定要套用嗎?",
  "chat.conversation_long_term_memory_apply_button": "套用",
  "chat.conversation_long_term_memory_unsaved_alert_message": "您有尚未儲存的修改 確定要離開嗎?",
  "chat.conversation_long_term_memory_apply_failed_toast": "發生錯誤，請重新嘗試",
  "chat.conversation_output_environment_title": "輸出設定",
  "chat.conversation_output_environment_control_memory_title": "調整記憶力",
  "chat.conversation_output_environment_control_max_output_title": "調整輸出量上限",
  "chat.conversation_output_environment_description1": "記憶力越高，消耗的代幣也會增加",
  "chat.conversation_output_environment_description2": "若記憶力設定短於長期記憶的摘要頻率，可能會遺漏重要內容。建議將其設定為相同或更高。",
  "chat.conversation_output_environment_description3": "輸出量越高，消耗的代幣也會增加",
  "chat.conversation_output_environment_description4": "變更後的設定將自下一次輸出開始生效",
  "chat.conversation_output_environment_description5": "您設定的內容會全數套用到所有聊天室",
  "chat.conversation_output_environment_save_modal_title": "您確定要儲存變更的內容嗎？",
  "chat.conversation_output_environment_save_modal_description": "您設定的內容會全數套用到所有聊天室",
  "chat.conversation_chat_settings_image_display": "查看相片",
  "chat.conversation_chat_settings_image_display_text": "文字",
  "chat.conversation_image_unlock_locked_image": "此為私人圖片",
  "chat.conversation_image_unlock_with_bubbles": "使用泡泡解鎖",
  "chat.conversation_image_unlock_no_with_bubbles": "無法使用泡泡解鎖",
  "chat.conversation_image_unlock_image_title": "解鎖相片",
  "chat.conversation_image_unlock_your_bubbles": "我的泡泡",
  "chat.conversation_image_unlock_unlocked_image": "已解鎖的相片",
  "chat.conversation_image_unlock_unlockable_image": "可以解鎖",
  "chat.conversation_image_unlock_no_bubble_unlock": "不可解鎖",
  "chat.conversation_image_unlock_selected_image": "已選擇的相片",
  "chat.conversation_image_unlock_all_unlockable_image": "可以解鎖的所有相片",
  "chat.conversation_image_unlock_refund_bubble_description": "用於解鎖圖片的泡泡無法退款",
  "chat.conversation_image_unlock_not_enough_bubbles": "泡泡不足<br/>無法解鎖相片",
  "chat.conversation_image_unlock_top_up_bubbles": "儲值泡泡以解鎖相片",
  "chat.conversation_image_unlock_current_bubbles": "我的泡泡",
  "chat.conversation_image_unlock_required_bubbles": "解鎖所需的泡泡",
  "chat.conversation_image_unlock_missing_bubbles": "不足的泡泡",
  "chat.conversation_image_unlock_cancel_button": "關閉",
  "chat.conversation_image_unlock_top_up_button": "前往儲值",
  "chat.conversation_image_unlock_failed": "解鎖相片失敗",
  "chat.conversation_image_unlock_failed_description": "請重新嘗試",
  "chat.conversation_image_unlock_failed_button": "確認",
  "chat.conversation_image_unlock_already_unlocked": "此相片已解鎖",
  "chat.conversation_image_unlock_already_unlocked_button": "確認",
  "chat.conversation_streaming_mode_off_alert_toast": "現在對話只能使用目前的聊天模式<br/>打字模式復原中",
  "chat.conversation_streaming_mode_on_alert_toast": "打字模式已復原",
  "chat.conversation_markdown_mode_on_alert_toast": "Markdown 標記式語言功能已開啟",
  "chat.conversation_markdown_mode_off_alert_toast": "Markdown 標記式語言功能修復中",
  "chat.conversation_message_send_error_alert_toast": "接收訊息失敗<br/>未消耗任何泡泡",
  "chat.conversation_streaming_message_error_alert_toast": "處理您的請求時發生錯誤<br/>請稍後再試",
  "chat.conversation_prohibited_content_error_toast": "AI模型拒絕針對該則訊息生成回覆。如有對話及退款相關問題，請洽客服中心。",
  "chat.conversation_prohibited_content_no_charge_toast": "AI內容過濾器導致訊息回覆失敗，未扣除您的泡泡/洗髮精。",
  "chat.conversation_chat_new_conversation_button": "開啟新對話",
  "chat.conversation_chat_new_conversation_modal_select_title": "選擇第一句話",
  "chat.conversation_chat_new_conversation_modal_start_conversation_button": "開始對話",
  "chat.conversation_chat_copy_button": "複製聊天室",
  "chat.conversation_chat_copied_toast": "該聊天室已複製到最近的對話",
  "chat.conversation_chat_copied_failed_toast": "複製聊天室失敗",
  "chat.conversation_reconnect_toast": "若未顯示新回覆，請確認網路連線並重新開啟。",
  "chat.conversation_limit_toast": "您已使用完所有洗髮精，使用者筆記和人格的使用可能會受到限制",
  "chat.conversation_usernote_limit_toast": "您的洗髮精已消耗完畢，使用者筆記的使用已受到限制(最多500字)",
  "chat.conversation_persona_limit_toast": "您的洗髮精已消耗完畢，人格的使用已受到限制(最多250字)",
  "chat.conversation_bookmark": "書籤",
  "chat.conversation_bookmark_number": "書籤 {{int_numbers}}",
  "chat.conversation_bookmark_button": "移動到對話",
  "chat.conversation_bookmark_add_title": "新增書籤",
  "chat.conversation_bookmark_edit_title": "編輯書籤",
  "chat.conversation_bookmark_note": "筆記",
  "chat.conversation_bookmark_note_placeholder": "自由輸入",
  "chat.conversation_bookmark_note_description": "*您輸入的內容不會影響到對話",
  "chat.conversation_bookmark_empty": "您沒有已儲存的書籤",
  "chat.conversation_bookmark_no_content": "此內容因重新整理或刪除，已不存在",
  "chat.conversation_bookmark_delete_success": "已刪除書籤",
  "chat.conversation_bookmark_delete_failed": "書籤刪除失敗",
  "chat.conversation_bookmark_edit_success": "已編輯書籤",
  "chat.conversation_bookmark_edit_failed": "書籤編輯失敗",
  "chat.conversation_export_as_txt": "匯出TXT檔",
  "chat.conversation_export_as_txt_modal_description": "您確定要匯出所有對話紀錄嗎?",
  "chat.conversation_sidebar_extra_settings": "更多設定",
  "chat.conversation_extra_settings_mask_my_name": "隱藏我的名字",
  "chat.conversation_mask_my_name_user": "用戶",
  "chat.custom_modal_preview_character_dialogue": "角色的對白",
  "chat.custom_modal_preview_character_dialogue_mask_on": "正稱呼您為「User」。",
  "chat.custom_modal_preview_character_dialogue_mask_off": "正稱呼您為「{{user}}」。",
  "chat.custom_modal_preview_character_narration": "角色的旁白",
  "chat.custom_modal_preview_user_dialogue": "用戶的對白",
  "chat.custom_modal_preview_user_narration": "用戶的旁白",
  "chat.custom_modal_viewer_settings": "顯示設定",
  "chat.custom_modal_viewer": "顯示",
  "chat.custom_modal_viewer_background": "背景",
  "chat.custom_modal_transparency": "透明度",
  "chat.custom_modal_text_settings": "文字設定",
  "chat.custom_modal_text_size": "大小",
  "chat.custom_modal_color_settings": "顏色設定",
  "chat.custom_modal_color_settings_reset_button": "重置",
  "chat.custom_modal_preset_button": "預設",
  "chat.custom_modal_custom_button": "自行設定",
  "chat.custom_modal_theme_dark": "暗",
  "chat.custom_modal_theme_light": "亮",
  "chat.custom_modal_theme_default": "Bubble",
  "chat.custom_modal_label_character_dialogue": "角色對白",
  "chat.custom_modal_label_user_dialogue": "用戶對白",
  "chat.custom_modal_label_character_narration": "角色旁白",
  "chat.custom_modal_label_user_narration": "用戶旁白",
  "chat.custom_modal_label_character_bubble": "角色對話框",
  "chat.custom_modal_label_user_bubble": "用戶對話框",
  "chat.custom_modal_color_picker_recent_colors": "最近顏色",
  "chat.custom_modal_color_picker_default_custom_button": "基本",
  "chat.custom_modal_color_picker_custom_button": "自行設定",
  "chat.custom_modal_apply_chat_all_alert_title": "您的變更項目只會套用到對話型的聊天室",
  "chat.custom_modal_apply_story_all_alert_title": "您的變更項目只會套用到小說型的聊天室",
  "chat.custom_modal_apply_all_alert_description": "您確定要儲存嗎?",
  "chat.custom_modal_unsaved_alert_title": "有還沒儲存的變更",
  "chat.custom_modal_unsaved_alert_description": "您確定要結束嗎?",
  "chat.custom_modal_reset_alert_title": "所有的顏色設定會重置",
  "chat.custom_modal_reset_alert_description": "您確定要繼續嗎?",
  "chat.conversation_suggested_messages_title": "推薦訊息",
  "chat.conversation_suggested_messages_description": "請選擇要傳送給角色的訊息。",
  "chat.message_card_title": "訊息卡",
  "chat.message_card_select_message_deselect": "取消勾選",
  "chat.message_export_title": "匯出對話紀錄",
  "chat.message_card_select_message": "選擇訊息",
  "chat.message_card_private_unavailable": "不公開角色的聊天室不適用訊息卡",
  "chat.message_card_select_text_guide": "請選擇訊息製作訊息卡",
  "chat.message_card_edit": "編輯訊息卡",
  "chat.message_card_card_design": "訊息卡風格",
  "chat.message_card_style": "風格",
  "chat.message_card_bg_background": "半透明",
  "chat.message_card_bg_cutscene": "原相片",
  "chat.message_card_bg_text": "純文字",
  "chat.message_card_ratio": "比例",
  "chat.message_card_ratio_portrait": "直向",
  "chat.message_card_ratio_landscape": "橫向",
  "chat.message_card_ratio_square": "正方形",
  "chat.message_card_image": "相片",
  "chat.message_card_edit_text": "編輯內文",
  "chat.message_card_save_success": "訊息卡已儲存於您的裝置",
  "chat.message_card_save_failed": "儲存訊息卡失敗，請重新嘗試",
  "chat.nsfw_character_not_available_toast_message": "臉紅心跳模式角色無法於App中使用。",
  "chat.nsfw_universe_not_available_toast_message": "臉紅心跳模式世界觀無法於App中使用。",
  "chat.nsfw_scene_not_available_toast_message": "臉紅心跳模式場景無法於App中使用。",
  "payment.charging_station_title": "儲值站",
  "payment.charging_station_shampoo": "洗髮精儲值站",
  "payment.charging_station_paid_bubble": "泡泡儲值站",
  "payment.charging_station_free_bubble": "免費儲值",
  "payment.charging_station_pass": "使用券",
  "payment.page_topup": "儲值",
  "payment.page_history": "使用紀錄",
  "payment.page_topup_history": "儲值紀錄",
  "payment.page_topup_history_earned": "儲值/回饋",
  "payment.page_topup_history_used": "使用",
  "payment.page_topup_balance": "持有狀態",
  "payment.page_topup_expiry_date": "到期日",
  "payment.page_topup_remaining": "剩餘泡泡",
  "payment.charging_station_toast_success": "購買成功",
  "payment.charging_station_toast_failed": "結帳失敗，請重新嘗試",
  "payment.charging_station_shampoo_purchase_modal": "確定要購買<br/>超級洗髮精嗎?",
  "payment.charging_station_super_shampoo_menu_title": "購買超級洗髮精",
  "payment.charging_station_hyper_shampoo_menu_title": "購買高檔洗髮精",
  "payment.charging_station_shampoo_menu_your_bubbles": "我的泡泡",
  "payment.charging_station_shampoo_super_shampoo": "超級洗髮精",
  "payment.charging_station_shampoo_days_zero": "{{int_days}}日",
  "payment.charging_station_shampoo_days_one": "{{int_days}}日",
  "payment.charging_station_shampoo_days_other": "{{int_days}}日",
  "payment.charging_station_shampoo_hours_zero": "{{int_hours}}小時",
  "payment.charging_station_shampoo_hours_one": "{{int_hours}}小時",
  "payment.charging_station_shampoo_hours_other": "{{int_hours}}小時",
  "payment.charging_station_shampoo_purchase_complete": "成功完成購買!",
  "payment.charging_station_shampoo_purchase_ok": "確認",
  "payment.charging_station_shampoo_not_enough_bubbles_title": "泡泡不足<br/>無法購買洗髮精",
  "payment.charging_station_shampoo_not_enough_bubbles_description": "儲值泡泡後即可購買洗髮精",
  "payment.charging_station_shampoo_modal_your_bubbles": "我的泡泡",
  "payment.charging_station_shampoo_modal_required": "購買所需泡泡",
  "payment.charging_station_shampoo_modal_missing": "不足的泡泡",
  "payment.charging_station_shampoo_modal_cancel": "關閉",
  "payment.charging_station_shampoo_modal_topup": "前往儲值",
  "payment.charging_station_shampoo_purchase_failed_title": "購買失敗",
  "payment.charging_station_shampoo_purchase_failed_description": "請重新嘗試",
  "payment.charging_station_shampoo_modal_account_verification": "實名認證後<br/>即可購買此商品",
  "payment.charging_station_shampoo_modal_verify": "前往實名認證",
  "payment.charging_station_shampoo_modal_already_in_use": "您已經在使用洗髮精了!",
  "payment.charging_station_shampoo_modal_already_in_use_description1": "您用掉了一部份的洗髮精<br/>馬上就能再補充至100%<br/>您確定要儲值嗎?",
  "payment.charging_station_shampoo_modal_already_in_use_description2": "*選擇要填滿的洗髮精後<br/>不得退款",
  "payment.charging_station_shampoo_modal_already_in_use_cancel": "否",
  "payment.charging_station_shampoo_modal_already_in_use_recharge": "填滿",
  "payment.charging_station_shampoo_pass_info": "我現在的使用券",
  "payment.charging_station_shampoo_purchase_pass": "購買使用券",
  "payment.charging_station_shampoo_pass_description1": "比一般洗髮精還多{{int_value}}倍容量",
  "payment.charging_station_shampoo_pass_description2": "人格{{string_textCount}}字",
  "payment.charging_station_shampoo_pass_description3": "使用者筆記{{string_textCount}}字",
  "payment.charging_station_shampoo_tooltip_title1": "✅ 什麼是洗髮精?",
  "payment.charging_station_shampoo_tooltip_description1": "BubbleChat每天會提供固定的免費聊天量",
  "payment.charging_station_shampoo_tooltip_description2": "可以透過「洗髮精」來確定剩餘的免費聊天量",
  "payment.charging_station_shampoo_tooltip_description3": "開始免費聊天後，每6小時會補充25%",
  "payment.charging_station_shampoo_tooltip_title2": "📌 請參考!",
  "payment.charging_station_shampoo_tooltip_description4": "不同種類的洗髮精，消耗速度也不同",
  "payment.charging_station_shampoo_tooltip_description5": "洗髮精的消耗速度會受聊天室風格和AI模型影響",
  "payment.charging_station_shampoo_tooltip_description6": "消耗速度會受角色指令的量、聊天時的輸入量、角色的輸出量影響",
  "payment.charging_station_shampoo_tooltip_title3": "✅ 使用券介紹",
  "payment.charging_station_shampoo_tooltip_description7": "超級洗髮精",
  "payment.charging_station_shampoo_tooltip_description8": "超級洗髮精可享有比一般洗髮精還多{{int_value}}倍的聊天量",
  "payment.charging_station_shampoo_tooltip_description9": "使用超級洗髮精時，可以購買補充型商品，並享有使用者筆記，人格的升級功能。",
  "payment.charging_station_shampoo_tooltip_description10": "高檔洗髮精",
  "payment.charging_station_shampoo_tooltip_description11": "高檔洗髮精可享有比一般藥水還多{{int_value}}倍的聊天量",
  "payment.charging_station_shampoo_tooltip_description12": "使用高檔洗髮精時，可以購買補充型商品，並享有更進階的使用者筆記，人格的升級功能。",
  "payment.charging_station_shampoo_tooltip_description13": "追加購買使用券時，不會補充現有的使用券剩餘量。",
  "payment.charging_station_shampoo_tooltip_description14": "若是想補充剩餘量，請購買補充型商品。",
  "payment.charging_station_shampoo_tooltip_description15": "當洗髮精剩餘量低於{{int_number}}%，可以到儲值站和聊天室內購買補充型商品。",
  "payment.footer_msg_0": "服務資訊",
  "payment.footer_msg_1": "已儲值泡泡的有效期限為儲值後兩年",
  "payment.footer_msg_2": "未使用的泡泡，您可以在7天內申請取消購買",
  "payment.footer_msg_3": "泡泡一旦使用後便無法退款。若您以不正當方式取得退款，本公司有權在未經您事先同意的情況下收回您帳號持有的泡泡，並可能導致您的帳號被暫停使用",
  "payment.footer_msg_4": "活動贈送的免費泡泡無法退款",
  "payment.footer_msg_5": "獎勵發放的付費泡泡無法退款",
  "payment.footer_msg_6": "促銷商品退款後可能難以再次購買",
  "payment.footer_msg_7": "詳細事項可至BubbleChat的服務條款中確認",
  "payment.footer_msg_8": "如有任何疑問，請透過<link1>客服中心</link1>與我們聯繫",
  "payment.footer_msg_9": "若使用手機付款，僅限於辦理當月結帳訂單取消，且退款僅能退回至本人帳戶。",
  "payment.footer_exchange_rate_msg_bt_6_7_except_kr": "以上的價格會因匯率變動而產生波動。",
  "payment.shampoo_footer_msg_0": "",
  "payment.shampoo_footer_msg_1": "商品資訊",
  "payment.shampoo_footer_msg_2": "超級洗髮精為購買後立即生效的數位商品，並分別適用 3 日券與 7 日券的有效期限。",
  "payment.shampoo_footer_msg_3": "使用券在結帳成功後會立即開始生效，能在效期內使用",
  "payment.shampoo_footer_msg_4": "首次購買券僅限完成實名認證的帳號使用，每人限使用一次",
  "payment.shampoo_footer_msg_5": "退費政策",
  "payment.shampoo_footer_msg_6": "購買超級洗髮精後若完全未使用服務，可申請取消訂單。",
  "payment.shampoo_footer_msg_7": "使用超級洗髮精期間額外購買的票券，在該額外購買部分的有效期限開始扣除前，皆可申請取消訂單。",
  "payment.shampoo_footer_msg_8": "若因系統錯誤而無法正常使用，可透過客服中心獲得問題解決方法及補償",
  "payment.shampoo_footer_msg_9": "注意事項",
  "payment.shampoo_footer_msg_10": "活動贈送的免費使用券及折扣促銷商品，恕不提供退費",
  "payment.shampoo_footer_msg_11": "若以不正當方式申請退款或濫用使用券，本公司有權不經事前通知，逕行收回商品並限制帳號使用",
  "payment.shampoo_footer_msg_12": "促銷商品在退費後，可能無法以相同條件再次購買，請您謹慎考慮後再購買",
  "payment.shampoo_footer_msg_13": "若偵測到多次重複購買並退費，將可能被視為濫用行為，限制帳號使用",
  "payment.shampoo_footer_msg_14": "退出會員後再重新註冊重複領取優惠，將會被系統偵測並可能導致帳號使用受到限制",
  "payment.shampoo_footer_msg_15": "超級洗髮精補充不會延長商品的使用期限，僅提供即時補充。",
  "payment.shampoo_footer_msg_16": "在超級洗髮精狀態下再次購買超級洗髮精時，僅會延長使用期限，不會補充剩餘量。",
  "payment.shampoo_footer_msg_17": "當您從超級洗髮精升級至高檔洗髮精時，超級洗髮精的剩餘時間將以 5:1 的比例計算，並加入至高檔洗髮精。",
  "payment.shampoo_footer_msg_18": "補充型商品僅限購買超級洗髮精的使用者購買。",
  "payment.shampoo_footer_msg_19": "其他問題請洽客服中心",
  "payment.shampoo_footer_msg_20": "超級洗髮精的剩餘量低於 0% 時，人格最多只能輸入 250 字，使用者筆記最多只能輸入 500 字。",
  "payment.history_bubblechat": "BubbleChat",
  "payment.history_unlock_image": "解鎖相片",
  "payment.history_payment": "結帳",
  "payment.history_referrer_registration": "輸入推薦碼",
  "payment.history_payment_no_record": "無付費購買紀錄",
  "payment.history_used_no_record": "尚無使用紀錄",
  "payment.failed_button_description": "回到結帳頁面",
  "payment.super_shampoo_refill_expired_message_modal": "超級洗髮精已到期<br/>補充失敗",
  "payment.super_shampoo_refill_expired_description_modal": "試著購買超級洗髮精",
  "payment.super_shampoo_refill_expired_message_modal_button": "購買超級洗髮精",
  "payment.super_shampoo_refill_message_modal": "補充超級洗髮精",
  "payment.super_shampoo_refill_description1_modal": "超級洗髮精到期後<br/>無法使用剩餘的量",
  "payment.super_shampoo_refill_description2_modal": "您確定要補充嗎?",
  "payment.hyper_shampoo_refill_expired_message_modal": "高檔洗髮精使用期限已過<br/>補充失敗",
  "payment.hyper_shampoo_refill_expired_description_modal": "高檔洗髮精等你來購買",
  "payment.hyper_shampoo_refill_expired_message_modal_button": "購買高檔洗髮精",
  "payment.hyper_shampoo_refill_message_modal": "補充高檔洗髮精",
  "payment.hyper_shampoo_refill_description1_modal": "若高檔洗髮精的使用效期已過<br/>沒使用的量也會消失",
  "payment.shampoo_refill_message_modal_button": "補充洗髮精",
  "payment.shampoo_refill_complete_message_modal": "洗髮精補充成功!",
  "payment.shampoo_refill_complete_description1_modal": "已補充洗髮精，可以繼續對話了!",
  "payment.shampoo_refill_failed_message_modal": "泡泡不足<br/>無法補充洗髮精",
  "payment.shampoo_refill_failed_description1_modal": "還需這些泡泡才能補充",
  "payment.payletter_modal_title": "付款",
  "payment.payletter_modal_selected_item": "您選擇的商品",
  "payment.payletter_modal_payment_method": "付款方式",
  "payment.payletter_modal_card_button": "信用卡/簽帳金融卡",
  "payment.payletter_modal_transfer_button": "虛擬帳號付款",
  "payment.payletter_modal_billing_button": "手機門號付款",
  "payment.payletter_modal_pay_button": "結帳",
  "payment.payletter_modal_success_title": "付款成功",
  "payment.payletter_modal_success_description": "已完成付款",
  "payment.payletter_modal_fail_title": "付款失敗",
  "payment.payletter_modal_fail_description": "付款失敗",
  "payment.payletter_modal_fail_description_sub": "請重新嘗試",
  "payment.ad_free_modal_title": "移除廣告，享受更投入的故事體驗。",
  "payment.ad_free_product_name": "Weave Plus",
  "payment.ad_free_product_price_subscription": "月 / {{string_N}}",
  "payment.ad_free_product_price_1day": "1天 / {{string_N}}",
  "payment.ad_free_product_price_30days": "30天 / {{string_N}}",
  "payment.ad_free_modal_description1": "移除廣告",
  "payment.ad_free_modal_description2": "更快的回覆速度",
  "payment.ad_free_modal_description3": "更多回覆內容",
  "payment.ad_free_modal_description4": "提供使用者筆記",
  "payment.ad_free_modal_description5": "贈送 {{int_number}} 點數",
  "payment.ad_free_modal_description_inactived": "網頁付款功能正在準備中。<br/>目前可以在 App 內購買。<br/>App → 儲值站 → 使用券",
  "payment.ad_free_modal_description_inactived_button": "在 App 中購買",
  "payment.ad_free_product_name_subscription": "定期訂閱",
  "payment.ad_free_product_name_day": "1天",
  "payment.ad_free_product_recommended_web_top_up_title": "網頁版定期訂閱為每月／{{int_number}}",
  "payment.ad_free_product_recommended_web_top_up_title2": "在網頁版購買更划算，最低₩1,500起",
  "payment.ad_free_product_recommended_web_top_up_button": "立即前往",
  "payment.ad_free_product_purchase": "購買",
  "payment.ad_free_product_price_day2": "使用 {{int_number}} 體驗 Weave Plus 1天",
  "payment.ad_free_modal_description6": "1日券不會贈送點數。",
  "payment.ad_free_urchase_modal_title1": "要購買 {{string_productName}} 嗎？",
  "payment.ad_free_urchase_modal_title_completed": "已完成購買 {{string_productName}}！",
  "payment.ad_free_urchase_modal_title_failed": "購買 {{string_productName}} 失敗。",
  "payment.ad_free_chatroom_banner_title": "想要更專心地享受對話嗎？",
  "payment.ad_free_chatroom_banner_remove_Ads": "移除廣告",
  "payment.ad_free_product_infomation_subscription_date": "預計扣款日",
  "payment.ad_free_product_infomation_subscription": "訂閱中",
  "payment.ad_free_product_infomation_subscribe": "訂閱",
  "payment.ad_free_product_infomation_cancellation_date": "預計取消日期",
  "payment.ad_free_product_infomation_cancellation": "即將取消",
  "payment.ad_free_product_infomation_undo_cancellation": "撤回取消訂閱",
  "payment.ad_free_product_infomation_cancel_Subscription": "取消訂閱",
  "payment.ad_free_product_infomation_expiration_date": "使用期限",
  "payment.ad_free_product_infomation_Inactive_pass": "目前沒有可用的使用券",
  "payment.ad_free_cancel_subscription_error_title1": "可於網頁版取消訂閱。",
  "payment.ad_free_cancel_subscription_error_description1": "網頁：儲值站 > 使用券 > 目前使用券資訊 > 取消訂閱",
  "payment.ad_free_cancel_subscription_error_title2": "可於 Play 商店 取消訂閱。",
  "payment.ad_free_cancel_subscription_error_description2": "Android：Play 商店 > 個人資料 > 付款與訂閱 > 訂閱項目 > 選擇應用程式 > 取消訂閱",
  "payment.ad_free_cancel_subscription_error_title3": "可於 App Store 取消訂閱。",
  "payment.ad_free_cancel_subscription_error_description3": "iOS：設定 > Apple ID > 訂閱項目 > 選擇 App > 取消訂閱",
  "payment.ad_free_resubscribe_error_title1": "若要重新訂閱，請至網頁版操作。",
  "payment.ad_free_resubscribe_error_title2": "若要重新訂閱，請至 App Store 操作。",
  "payment.ad_free_resubscribe_error_title3": "若要重新訂閱，請至 Google Play 操作。",
  "payment.ad_free_perchase_error_title": "已有使用中的使用券。",
  "payment.ad_free_perchase_error_description": "可於 {{string_productName}} 結束後購買。",
  "payment.ad_free_chatroom_sidemenu_active": "使用中",
  "payment.ad_free_footer_msg_1": "服務資訊 - Weave Plus 使用券",
  "payment.ad_free_footer_msg_2": "商品說明",
  "payment.ad_free_footer_msg_3": "Weave Plus 使用券為付款完成後即可立即使用的數位商品，1日券／30 日券將分別適用各自的有效期限（權益期間）。",
  "payment.ad_free_footer_msg_4": "Weave Plus 使用券為付款完成後即可立即使用的數位商品，1日券／定期訂閱券（1個月）將分別適用各自的有效期限（權益期間）。",
  "payment.ad_free_footer_msg_5": "權益將自付款完成時起自動生效，於有效期限內使用免費模型「Weave」時，可享有移除廣告、提升回覆速度、提升輸出量，以及使用者筆記功能。",
  "payment.ad_free_footer_msg_6": "購買30日券時將發放加贈Bubble，1日券不會發放加贈Bubble。",
  "payment.ad_free_footer_msg_7": "購買30日券、定期訂閱券時將發放加贈Bubble，1日券不會發放加贈 Bubble。",
  "payment.ad_free_footer_msg_8": "使用券無法重複持有，須待目前使用中的使用券結束後，方可購買其他使用券。",
  "payment.ad_free_footer_msg_9": "首次購買限定商品僅限已完成本人認證的帳號購買，且每人僅限購買1次。",
  "payment.ad_free_footer_msg_10": "定期訂閱（1個月券）說明",
  "payment.ad_free_footer_msg_11": "訂閱費用：每月 {{int_number}} 韓元（含加值型營業稅VAT）",
  "payment.ad_free_footer_msg_12": "Weave Plus 1個月券為每30天自動續訂的訂閱商品。在取消訂閱前，系統將於每次預定續訂日，透過您登錄的付款方式自動扣款。",
  "payment.ad_free_footer_msg_13": "您可於下一次預定付款日前隨時取消訂閱。取消訂閱後，剩餘使用期間內仍可繼續享有相關權益。",
  "payment.ad_free_footer_msg_14": "透過 App 內購買的訂閱，若未於訂閱期間結束前24小時以前取消，將以相同金額自動續訂並扣款。您可透過「設定 > 帳號 > 訂閱」或「Play 商店 > 定期付款」進行訂閱管理與取消。",
  "payment.ad_free_footer_msg_14_1": "＊訂閱管理及解除訂閱方式：iOS - 設定 > 帳號 > 訂閱／AOS - Play商店 > 訂",
  "payment.ad_free_footer_msg_15": "退款政策",
  "payment.ad_free_footer_msg_16": "Weave Plus 使用券為付款完成後即提供權益、並產生使用效益的數位內容。依據《電子商務等消費者保護相關法律》，付款後之退款（取消申購）將受到限制。",
  "payment.ad_free_footer_msg_17": "付款後若完全未使用使用券權益，亦即：（1）從未使用過免費模型，因此移除廣告權益從未被套用；且（2）所發放的免費泡泡完全未使用，則可於付款日起7日內申請取消申購及退款。若上述任一權益已開始使用，將視為內容提供已開始，退款將受到限制。",
  "payment.ad_free_footer_msg_18": "透過 App 內購買的項目，將依各商店（App Store、Google Play）的退款政策辦理。",
  "payment.ad_free_footer_msg_19": "若因系統錯誤等原因導致無法正常使用，請透過客服中心與我們聯繫，我們將協助您處理。",
  "payment.ad_free_footer_msg_20": "注意事項",
  "payment.ad_free_footer_msg_21": "活動贈送的免費使用券及折扣促銷商品，不適用退款。",
  "payment.ad_free_footer_msg_22": "若以不正當方式嘗試退款，或濫用使用券，平台可能不經事前通知，回收已發放的商品或權益，並限制帳號使用。",
  "payment.ad_free_footer_msg_23": "促銷商品退款後，可能無法再以相同條件重新購買，購買前請審慎確認。",
  "payment.ad_free_footer_msg_24": "若偵測到反覆購買與退款的異常模式，可能會被視為濫用行為，並限制帳號使用。",
  "payment.ad_free_footer_msg_25": "透過註銷帳號後重新加入，以重複領取權益的行為，將由系統偵測，並可能採取使用限制措施。",
  "payment.ad_free_footer_msg_26": "如有其他疑問，請透過客服中心與我們聯繫。",
  "payment.ad_watch_incomplete_toast": "尚未完成廣告觀看，請重新送出訊息。",
  "payment.app_only_guide_title": "付款功能目前僅支援App使用。",
  "payment.app_only_guide_description": "我們預計近期內開放網頁版也能使用此功能。",
  "chat.profile_my_title": "我的頁面",
  "chat.profile_other_title": "個人檔案",
  "chat.profile_writername": "暱稱",
  "chat.profile_username": "使用者代碼",
  "chat.profile_followers_zero": "粉絲",
  "chat.profile_followers_one": "粉絲",
  "chat.profile_followers_other": "粉絲",
  "chat.profile_my_following": "追蹤中",
  "chat.profile_my_following_modal_title": "追蹤中",
  "chat.profile_my_following_modal_description": "試著追蹤其他用戶",
  "chat.profile_others_follow_button": "追蹤",
  "chat.profile_others_following_button": "追蹤中",
  "chat.profile_introduction": "介紹",
  "chat.profile_my_introduction_empty": "寫下我的介紹",
  "chat.profile_other_introduction_empty": "尚未有我的介紹",
  "chat.profile_username_copy_message": "已複製使用者代碼",
  "chat.profile_my_personas": "人格",
  "chat.profile_my_personas_my_personas_zero": "我的人格",
  "chat.profile_my_personas_my_personas_one": "我的人格",
  "chat.profile_my_personas_my_personas_other": "我的人格",
  "chat.profile_my_personas_empty": "尚未有我創建的人格",
  "chat.profile_character": "角色",
  "chat.profile_my_characters_my_characters_zero": "我的角色",
  "chat.profile_my_characters_my_characters_one": "我的角色",
  "chat.profile_my_characters_my_characters_other": "我的角色",
  "chat.profile_my_characters_empty": "尚未有我創建的角色",
  "chat.profile_others_characters_empty": "沒有角色",
  "chat.profile_universe": "世界觀",
  "chat.profile_my_universes_my_universes_zero": "我的世界觀",
  "chat.profile_my_universes_my_universes_one": "我的世界觀",
  "chat.profile_my_universes_my_universes_other": "我的世界觀",
  "chat.profile_my_universes_empty": "尚未有我創建的世界觀",
  "chat.profile_others_universes_empty": "沒有世界觀",
  "chat.profile_scene": "場景",
  "chat.profile_my_scenes_my_scenes_zero": "我的場景",
  "chat.profile_my_scenes_my_scenes_one": "我的場景",
  "chat.profile_my_scenes_my_scenes_other": "我的場景",
  "chat.profile_my_scenes_empty": "尚未有我創建的場景",
  "chat.profile_others_scenes_empty": "沒有場景",
  "chat.profile_assets_count_zero": "素材",
  "chat.profile_assets_count_one": "素材",
  "chat.profile_assets_count_other": "素材",
  "chat.profile_my_rewards": "獎勵",
  "chat.profile_my_shampoo": "洗髮精",
  "chat.profile_others_nsfw_toggle": "臉紅心跳模式",
  "chat.profile_my_edit_title": "編輯個人檔案",
  "chat.profile_my_edit_modal_edit_writername": "編輯暱稱",
  "chat.profile_my_edit_modal_profile_introduction": "個人檔案介紹",
  "chat.profile_my_edit_writername": "暱稱",
  "chat.profile_my_edit_username": "使用者代碼",
  "chat.profile_my_edit_introduction": "介紹",
  "chat.profile_my_edit_introduction_empty": "寫下我的介紹",
  "chat.profile_my_edit_email": "電子郵件地址",
  "chat.profile_my_edit_email_verify_message": "驗證電子郵件地址",
  "chat.profile_my_edit_password": "密碼",
  "chat.profile_my_edit_password_set_message": "設定密碼",
  "chat.profile_my_edit_password_completed_message": "完成設定密碼",
  "chat.profile_my_edit_identify_verification": "實名認證",
  "chat.profile_my_edit_verify_identity": "請進行實名認證",
  "chat.profile_my_edit_identify_verification_completed_message": "已完成實名認證",
  "chat.profile_my_edit_edit_button": "編輯",
  "chat.profile_my_edit_edit_verify_button": "認證",
  "chat.profile_my_edit_edit_verify_completed_button": "認證成功",
  "chat.profile_my_edit_country_content_options_change_toast": "已變更國家",
  "chat.profile_my_edit_content_display_settings_change_toast": "已變更內容顯示設定",
  "chat.profile_my_edit_country_content_options": "國家和遊戲內容",
  "chat.profile_my_edit_view_content_other_languages": "查看其他語種的遊戲內容",
  "chat.profile_my_edit_view_content_other_languages_thai": "泰語",
  "chat.profile_my_edit_view_content_other_languages_korean": "韓語",
  "chat.profile_my_edit_view_content_other_languages_taiwanese": "台語",
  "chat.profile_my_edit_view_content_other_languages_japanese": "日本話",
  "chat.profile_my_edit_view_content_display_settings": "他國遊戲內容設定",
  "chat.profile_my_edit_view_content_current_country": "只看現在選取的國家",
  "chat.profile_my_edit_view_content_all_countries": "所有國家",
  "chat.profile_my_edit_country_settings": "國家設定",
  "chat.profile_my_edit_language_settings": "語言設定",
  "chat.profile_my_edit_language_settings_popup_title": "語言設定",
  "chat.profile_my_edit_language_settings_popup_subtitle": "語言選擇",
  "chat.profile_no_exist": "此用戶不存在",
  "chat.profile_number_of_people": "{{int_numbers}}人",
  "chat.profile_my_create_no_personas": "尚未有我創建的人格",
  "chat.profile_my_create_no_scenes": "尚未有我創建的場景",
  "chat.profile_my_create_no_universes": "尚未有我創建的世界觀",
  "chat.profile_my_create_no_characters": "尚未有我創建的角色",
  "chat.profile_my_favorite_no_scenes": "尚未有加到我的最愛中的場景",
  "chat.profile_my_favorite_no_universes": "尚未有加到我的最愛中的世界觀",
  "chat.profile_my_favorite_no_characters": "尚未有加到我的最愛中的角色",
  "chat.profile_my_recently_played_no_scenes": "沒有最近使用過的場景",
  "chat.profile_my_recently_played_no_universes": "沒有最近使用過的世界觀",
  "chat.profile_my_recently_played_no_characters": "沒有最近使用過的角色",
  "chat.profile_my_like_find_scenes": "搜尋我會喜歡的場景",
  "chat.profile_my_like_find_universes": "搜尋我會喜歡的世界觀",
  "chat.profile_my_like_find_characters": "搜尋我會喜歡的角色",
  "chat.profile_my_contest_tab_title": "徵選",
  "chat.profile_my_contest_tab_ongoing": "進行中",
  "chat.profile_my_contest_tab_past_entries": "之前的參加作品",
  "chat.profile_my_contest_participate_button": "參加",
  "chat.profile_my_contest_badge_button": "審查中",
  "chat.profile_my_contest_view_button": "確認徵選內容",
  "chat.profile_my_contest_view_results_button": "查看徵選結果",
  "chat.profile_my_contest_no_ongoing_contests": "目前無舉行中的徵選",
  "chat.profile_my_contest_ongoing_contests": "徵選進行中！<br/>馬上製作角色參加徵選",
  "chat.profile_my_contest_entered_null": "您沒有參加的徵選",
  "chat.profile_my_set_password": "設定",
  "chat.profile_my_same_verified_email": "與已驗證的電子郵件地址相同",
  "chat.profile_my_already_verified": "此身分已完成實名認證",
  "chat.profile_my_verify_adult_verification_toast_title": "Adult verification required.",
  "chat.profile_my_verify_adult_reverification_toast_title": "成人驗證有效期限<br/>已到期",
  "chat.profile_my_verify_adult_reverification_toast_description": "依據韓國《青少年保護法》施行細則 第17條 第2項規定，必須一年進行一次實名認證 <br/><br/> 為了安全且合法的使用環境\\n請重新認證。",
  "chat.profile_my_verify_youth_protection_toast_title": "未成年人禁止使用",
  "chat.profile_my_verify_adult_verification_identity_verification": "進行實名認證",
  "chat.profile_my_verify_adult_verification_identity_reverification": "重新進行認證",
  "chat.profile_my_verify_youth_protection_toast": "此資訊內容為有害青少年身心之產物<br/>依據韓國《資訊通信網路利用促進及資訊保護法》等法律<br/>及《青少年保護法》之規定<br/>未滿18歲之青少年不得利用",
  "chat.profile_my_edit_verify_modal_personal_information": "我同意<link1>個人資料的蒐集、處理及利用</link1>",
  "chat.profile_my_edit_verify_modal_personal_information_transfer": "我同意將蒐集的個人資料傳送至韓國網路振興院 (KISA) 的 e-Privacy Clean Service，以防止個人資料被盜用",
  "chat.profile_my_edit_verify_modal_legally_responsible": "我同意，若盜用他人身份或使用非本人個人資料，將承擔所有法律責任",
  "chat.profile_my_edit_verify_modal_termination_suspension": "我同意，若經查帳號盜用他人身份，服務使用可能會受到限制",
  "chat.profile_my_edit_verify_modal_one_identify": "每個帳號僅限使用一個身份進行實名認證",
  "chat.profile_my_edit_verify_modal_adult_content": "透過實名認證確認成年後，就可以製作或使用成人內容",
  "chat.profile_my_edit_verify_modal_valid": "實名認證在一年內有效。",
  "chat.profile_my_edit_verify_modal_penalties": "若在實名認證時使用他人身份，將可能面臨法律制裁及服務使用受限等不利後果",
  "chat.profile_delete_account_rewards": "當您退出會員時，所有獎勵收益將會消失且無法復原",
  "chat.profile_delete_account_delete_assets": "當您退出會員時，您所創建的角色、世界觀、場景不會被刪除，若有刪除需求請自行刪除",
  "chat.profile_delete_account_personal_info": "退出會員後，依據Bubbletab的個人資料使用告知事項，個人資料將會保留一段時間後銷毀",
  "chat.profile_delete_account_verification": "實名認證後若選擇退出會員，七日內無法再使用同一身分進行實名認證",
  "chat.profile_delete_account_benefits": "新會員在享受超級洗髮精優惠後，若選擇退出會員，將無法再使用同一身分再次獲得該優惠",
  "chat.profile_delete_account_enter_password": "輸入密碼以確認本人身分",
  "chat.profile_delete_account_current_password": "請輸入使用中的密碼",
  "chat.profile_delete_account_password_combination": "請輸入8~25個字元，可包含英文、數字和特殊符號",
  "chat.profile_delete_account_agree_all": "請同意所有條款",
  "chat.profile_delete_account_agree_all_delete": "同意所有條款後即可刪除帳號",
  "chat.profile_delete_account_password_incorrect": "密碼錯誤",
  "chat.profile_delete_account_set_password": "設定密碼以繼續",
  "chat.profile_delete_account_delete_success": "已成功刪除帳號",
  "chat.profile_my_purchased_stories_title": "已購買的故事",
  "chat.profile_my_purchased_stories_count_zero": "故事",
  "chat.profile_my_purchased_stories_count_one": "故事",
  "chat.profile_my_purchased_stories_count_other": "故事",
  "chat.profile_my_upload_image_button": "上傳圖片",
  "chat.profile_my_decorate_profile_button": "裝飾我的頁面",
  "chat.profile_my_decorater_profile_edit_message": "變更個人檔案相片後既有的裝飾會消失",
  "chat.profile_my_decorater_upload_profile_message": "新增個人檔案相片後即可使用",
  "chat.profile_my_edit_referrer_title": "推薦人",
  "chat.profile_my_edit_referrer_register_code_title": "輸入序號",
  "chat.profile_my_edit_referrer_register_code_button": "輸入",
  "chat.profile_my_edit_referrer_copy_code_title": "複製序號",
  "chat.profile_my_edit_referrer_register_code_description": "輸入推薦碼<br/><bold>帶</bold><highlight>{{int_numbers}}泡泡</highlight><bold>回家!</bold>",
  "chat.profile_my_edit_referrer_register_code_input_placeholder": "輸入推薦碼",
  "chat.profile_my_edit_referrer_register_code_remaining_time_label": "輸入推薦碼剩餘時間",
  "chat.profile_my_edit_referrer_register_code_remaining_time_format": "{{int_day}}天 {{int_time}}:{{int_minute}}:{{int_second}}",
  "chat.profile_my_edit_referrer_notice_title": "注意事項",
  "chat.profile_my_edit_referrer_notice_description1": "完成實名認證的帳號才能成為推薦人",
  "chat.profile_my_edit_referrer_notice_description2": "完成實名認證的帳號才能輸入推薦碼",
  "chat.profile_my_edit_referrer_notice_description3": "登錄推薦人時，登錄的使用者將獲得 {{int_refereeAmount}} 泡泡，推薦人使用者將獲得 {{int_referrerAmount}} 泡泡。",
  "chat.profile_my_edit_referrer_copy_code_description": "當使用者登錄我的推薦碼時<br/>我將立即獲得 {{int_referrerAmount}} 泡泡，登錄的使用者將立即獲得 {{int_refereeAmount}} 泡泡",
  "chat.profile_my_edit_referrer_register_code_completed_prefix": "已完成輸入：",
  "chat.profile_my_edit_referrer_verification_required_description": "實名認證後即可輸入推薦碼",
  "chat.profile_my_edit_referrer_copy_code_toast": "已複製推薦碼",
  "chat.profile_my_edit_referrer_register_code_expired": "已超過可輸入期限",
  "chat.profile_my_edit_referrer_error_unverified_account": "未完成身分認證帳號的推薦碼，無法登記為推薦人。",
  "chat.profile_my_edit_referrer_error_user_not_found": "此用戶不存在",
  "chat.profile_my_edit_referrer_error_self_register": "無法輸入自己的推薦碼",
  "chat.profile_my_edit_referrer_error_period_expired": "輸入期限已截止",
  "chat.profile_my_edit_referrer_registration_error_other_country": "其他國家使用者的推薦碼無法登錄為推薦人。",
  "chat.profile_my_edit_referrer_registration_completed": "已輸入推薦碼",
  "chat.profile_my_edit_referrer_registered_referrer": "您輸入的推薦人：",
  "chat.profile_my_edit_referrer_registration_period_expired": "僅限實名認證後{{deadline_time}}天內輸入推薦碼",
  "chat.profile_my_edit_referrer_benefit_title": "優惠",
  "chat.profile_my_edit_referrer_benefit_registration": "可輸入推薦碼",
  "chat.profile_my_edit_referrer_benefit_condition": "登錄時",
  "chat.profile_my_edit_referrer_benefit_reward": "發放 3,000 泡泡",
  "chat.profile_setting_account_settings": "帳號設定",
  "chat.profile_setting_service_settings": "服務設定",
  "chat.profile_setting_country_content_settings": "國家與內容設定",
  "chat.profile_setting_blocked_list": "管理封鎖名單",
  "chat.profile_setting_creator_support": "創作者支援",
  "chat.profile_setting_account": "帳號",
  "chat.profile_setting_service_support": "服務支援",
  "chat.profile_my_mileage_convert_menu_title": "貢獻值",
  "chat.profile_my_mileage_convert_sheet_title": "轉換貢獻值",
  "chat.profile_my_mileage_convert_sheet_description": "貢獻值1點可轉換為1泡泡",
  "chat.profile_my_mileage_convert_balance_label": "持有的貢獻值",
  "chat.profile_my_mileage_convert_input_label": "欲轉換的貢獻值",
  "chat.profile_my_mileage_convert_input_max": "最大",
  "chat.profile_my_mileage_convert_input_placeholder": "可以{{int_numbers}}點為單位進行轉換。",
  "chat.profile_my_mileage_convert_input_error_unit": "＊僅能以{{int_numbers}}點為單位進行轉換。",
  "chat.profile_my_mileage_convert_info_title": "什麼是貢獻值？",
  "chat.profile_my_mileage_convert_info_description_1": "累積滿{{int_numbers}}點即可轉換為泡泡，轉換後的泡泡可與一般泡泡享有相同用途。",
  "chat.profile_my_mileage_convert_info_description_2": "由貢獻值轉換而來的泡泡，有效期限為1年。",
  "chat.profile_my_mileage_convert_info_description_3": "貢獻值無法兌換、退還。",
  "chat.profile_my_mileage_convert_submit_button": "轉換為泡泡",
  "chat.profile_my_mileage_convert_confirm_modal_title": "要轉換貢獻值嗎？",
  "chat.profile_my_mileage_convert_confirm_modal_description": "轉換後的泡泡無法再變回貢獻值，發放之泡泡的有效期限為1年。",
  "chat.profile_my_mileage_convert_confirm_modal_submit": "轉換",
  "chat.profile_my_mileage_convert_complete_modal_title": "轉換完成",
  "chat.profile_my_mileage_convert_complete_modal_description": "已發放 {{int_numbers}} 泡泡",
  "chat.profile_my_mileage_convert_my_bubble_label": "我的泡泡",
  "chat.profile_my_mileage_convert_remaining_label": "剩餘貢獻值",
  "chat.profile_my_mileage_load_failed": "載入失敗",
  "chat.profile_my_mileage_reward_view": "查看",
  "chat.studio_create_image": "生成相片",
  "chat.studio_create_story": "生成故事",
  "chat.create_create_preset_create_description": "從角色到世界觀，一次完成",
  "chat.create_create_custom_create_description": "組合想要的世界觀、場景，打造喜歡的角色。",
  "chat.create_create_universe_create_description": "請設定對話當下的背景和環境",
  "chat.create_create_scene_create_description": "請設定當特定對話出現時，需立即出現的狀況",
  "chat.create_create_preset": "整合型",
  "chat.create_create_preset_title": "角色×世界觀×場景",
  "chat.create_create_custom": "組合型",
  "chat.create_create_preset_tooltip_title": "✅  整合型是什麼？",
  "chat.create_create_preset_tooltip_description1": "可以一口氣製作角色、世界觀、場景。",
  "chat.create_create_preset_tooltip_description2": "運用廣泛的提示詞與功能，快速創作完成度高的角色。",
  "chat.create_create_preset_tooltip_description3": "用整合型功能製作的素材無法跟組合型素材一起使用。",
  "chat.create_create_preset_tooltip_description4": "一旦使用整合型功能創作，就無法再轉為組合型創作。",
  "chat.create_create_custom_tooltip_title": "✅ 組合型是什麼？",
  "chat.create_create_custom_tooltip_description1": "階段性製作並套用至各個角色、世界觀、場景。",
  "chat.create_create_custom_tooltip_description2": "可個別製作與修改每個素材，具有高靈活性，可多次利用。",
  "chat.create_create_custom_tooltip_description3": "組合性素材只能與組合型素材一起使用。",
  "chat.create_create_custom_tooltip_description4": "用組合型功能製作的素材無法跟整合型素材一起使用。",
  "chat.create_preset_lorebook_placeholder": "標題字數不包含於本文內容字數",
  "chat.create_preset_character_details": "人物說明",
  "chat.create_preset_character_details_placeholder": "人物說明中不想公開的內容，請填寫於此處。",
  "chat.create_preset_background_details": "背景說明",
  "chat.create_preset_background_details_public_placeholder": "您可以自由設定角色的故事背景和故事情節<br/><br/>例)<br/>魔法普及的時代<br/>怪異現象與怪物橫行的世界",
  "chat.create_preset_background_details_private_placeholder": "背景說明中不想公開的內容，請填寫於此處。",
  "chat.create_asset_relationship_placeholder": "請把不想對外公開在關係中的資訊填寫在這裡",
  "chat.create_asset_details_placeholder": "請把不想對外公開在補充說明中的資訊填寫在這裡",
  "chat.create_asset_lorebook_placeholder": "請把不想對外公開在設定集中的資訊填寫在這裡",
  "chat.create_create_button": "生成",
  "chat.create_character_profile_img": "個人檔案相片",
  "chat.create_character_name_placeholder1": "李煥",
  "chat.create_character_name_placeholder2": "金雨彬",
  "chat.create_character_name_placeholder3": "鄭漢娜",
  "chat.create_introduction_label": "介紹",
  "chat.create_character_introduction_placeholder1": "偶爾會到學校上課的偶像",
  "chat.create_character_introduction_placeholder2": "一個內向卻渴望愛情的書呆子男性朋友",
  "chat.create_character_introduction_placeholder3": "人形機器人女僕",
  "chat.create_character_introduction_help_text": "*該介紹不會影響角色的運作",
  "chat.create_tags_label": "主題標籤",
  "chat.create_character_tags_description": "請選擇與角色相關的主題標籤",
  "chat.create_tags_placeholder": "搜尋主題標籤",
  "chat.create_tags_add": "新增新主題標籤",
  "chat.create_tags_minimum_fail_message": "請至少選擇1個主題標籤",
  "chat.create_tags_repeated_fail_message": "無法選擇重複的主題標籤",
  "chat.create_tags_maximum_fail_message": "最多能選擇5個主題標籤",
  "chat.create_tags_maximum_fail_message_a": "最多能選擇{{int_tagNumbers}}個主題標籤",
  "chat.create_tags_no_match_scenes": "此主題標籤無相關的場景",
  "chat.create_tags_no_match_universes": "此主題標籤無相關的世界觀",
  "chat.create_tags_no_match_characters": "此主題標籤無相關的角色",
  "chat.create_sharing_option_label": "公開與否",
  "chat.create_sharing_option_private_title": "不公開",
  "chat.create_sharing_option_private_description": "只有我能使用",
  "chat.create_sharing_option_public_title": "公開",
  "chat.create_sharing_option_public_description": "其他用戶也能使用",
  "chat.create_tap_specifics": "詳細資訊",
  "chat.create_age_minimum_fail_message": "年齡最小能設定為0歲",
  "chat.create_age_maximum_fail_message": "年齡最大能設定為10億歲",
  "chat.create_character_job_placeholder1": "高中生，偶像",
  "chat.create_character_job_placeholder2": "泡泡大學一年級新生",
  "chat.create_character_job_placeholder3": "女僕",
  "chat.create_character_character_placeholder1": "親切、善良、活潑",
  "chat.create_character_character_placeholder2": "拘謹、怕生、貼心、渴望愛",
  "chat.create_character_character_placeholder3": "溫柔體貼、嘮叨時態度堅決、有點異想天開",
  "chat.create_character_speaking_style_placeholder1": "「在學校裡，我只想當個普通的學生」",
  "chat.create_character_speaking_style_placeholder2": "「哈...哈囉...」「會...有人愛我嗎?」「我很想你」",
  "chat.create_character_speaking_style_placeholder3": "「我該整理哪裡呢?」",
  "chat.create_character_interests_placeholder1": "歌唱訓練、擔心即將到來的演唱會",
  "chat.create_character_interests_placeholder2": "讀書、健身房、戀愛、愛情",
  "chat.create_character_interests_placeholder3": "繡球花、家事、韓式炸雞塊",
  "chat.create_details_help_text": "使用{{assistant}}，對話時就會以角色的名稱代替; 使用{{user}}，對話時就會以用戶的名稱代替",
  "chat.create_global_availability_title": "是否要在其他國家公開",
  "chat.create_global_availability_global": "全球",
  "chat.create_global_availability_global_description": "全球用戶都能留言",
  "chat.create_global_availability_domestic": "國內",
  "chat.create_global_availability_domestic_description": "僅限現在設定的國家的用戶能留言",
  "chat.create_global_availability_help_text": "*在全球公開時，設定集的內容不會被翻譯、套用",
  "chat.create_global_availability_auto_translation_help_text": "*透過自動翻譯提供",
  "chat.create_character_failed_domestic_universe_scene": "由於您選擇的世界觀/場景並無同意在其他國家公開，因此暫不支援生成全球性角色。<br/>請選擇全球性世界觀/場景。",
  "chat.modify_character_failed_domestic_universe_scene": "由於您選擇的世界觀/場景並無同意在其他國家公開，因此暫不支援變更成全球性角色。<br/>請選擇全球性世界觀/場景\n",
  "chat.modify_character_alert_domestic_universe": "若設定為對其他國家非公開，則該世界觀將不會出現在其他國家角色的預設設定選項中。<br/>您確定要繼續編輯嗎?",
  "chat.modify_character_alert_domestic_scene": "若設定為對其他國家非公開，則該場景將不會出現在其他國家角色的預設設定選項中。<br/>您確定要繼續編輯嗎?",
  "chat.create_tap_background": "背景",
  "chat.create_tooltip_title": "幫助",
  "chat.create_tooltip_universe_description": "透過創建或新增世界觀，可以為角色預設符合其設定的世界觀",
  "chat.create_tooltip_scene_description": "透過創建或新增場景，可以為角色預設符合其設定的場景",
  "chat.create_first_sentence_description": "角色在聊天室傳的第一句話",
  "chat.create_first_sentence_placeholder1": "*久違來上學的李煥向你搭話*你有課本嗎?我沒帶來",
  "chat.create_first_sentence_placeholder2": "你為什麼現在才來?我等你很久了...",
  "chat.create_first_sentence_placeholder3": "您有什麼吩咐嗎?",
  "chat.create_first_sentence_int_numbers": "第一句話 {{int_numbers}}",
  "chat.create_first_sentence_add_button": "新增第一句話",
  "chat.create_first_sentence_title": "標題",
  "chat.create_first_sentence_description1": "*最多能寫3個第一句話",
  "chat.create_first_sentence_description2": "*第一句話的字數不包含在提示詞字數內",
  "chat.create_first_sentence_delete_confirm_message": "確定要刪除第一句話嗎?",
  "chat.create_creator_comment_label": "創作者評論",
  "chat.create_creator_comment_placeholder": "請輸入想告訴其他用戶們的話。",
  "chat.create_prompt_label": "提示詞",
  "chat.create_basic_info_label": "必要資訊",
  "chat.create_media_label": "媒體",
  "chat.create_extra_info_label": "補充資訊",
  "chat.create_prompt_characters_toast": "提示詞總字數不可超過{{int_characters}}字",
  "chat.create_creator_comment_characters_toast": "創作者評論總字數不可超過{{int_characters}}字",
  "chat.create_creator_first_sentence_characters_toast": "第一句話最多可輸入{{int_characters}}字。",
  "chat.create_creator_lorebook_characters_toast": "設定集最多可輸入{{int_characters}}字。",
  "chat.create_creator_keywordbook_characters_toast": "關鍵字手冊 {{int_keywordbookNumbers}} 的內容請不要輸入超過 {{int_characters}}字",
  "chat.create_creator_description_characters_toast": "說明狀況請不要輸入超過{{int_characters}}字",
  "chat.create_character_create_fail_message": "角色創建失敗<br/>請重新嘗試",
  "chat.create_alert_message_name": "請輸入名字",
  "chat.create_alert_message_image": "請新增相片",
  "chat.create_modal_gif_description": "不提供GIF編輯功能",
  "chat.create_alert_message_tags": "請至少選擇一個主題標籤",
  "chat.create_alert_message_introduction": "請輸入介紹",
  "chat.create_alert_message_age": "請輸入年齡",
  "chat.create_alert_message_nsfw": "臉紅心跳模式中的世界觀及場景，只限臉紅心跳模式中角色使用",
  "chat.create_alert_message_private": "您選擇了不公開的世界觀/場景，無法創建公開角色，要改為創建不公開角色嗎?",
  "chat.create_alert_message_cancel": "取消",
  "chat.create_private_character": "不公開創建",
  "chat.create_universe_name_help_text": "*禁止創建侵犯他人權益的世界觀",
  "chat.create_universe_details_placeholder": "請詳細說明世界觀<br/><br/>例)<br/>魔法普及的時代<br/>怪異現象與怪物橫行的世界",
  "chat.create_universe_create_fail_message": "世界觀創建失敗<br/>請重新嘗試",
  "chat.create_scene_name_help_text": "*禁止創建侵犯他人權益的場景",
  "chat.create_setup_label": "空間設定",
  "chat.create_scene_create_fail_message": "場景創建失敗<br/>請重新嘗試",
  "chat.create_draft_button": "暫存",
  "chat.create_draft_asset_in_progress_modal_title": "您有製作中的素材",
  "chat.create_draft_asset_in_progress_modal_description": "要繼續製作嗎?",
  "chat.create_draft_save_fail_storage_full_modal_title": "您現在製作的素材無法暫存",
  "chat.create_draft_save_fail_storage_full_modal_description": "儲存空間已滿，只能生成素材<br/>重新整理素材或生成後即可利用",
  "chat.create_draft_save_fail_storage_full_modal_manage_drafts_button": "整理暫存檔案",
  "chat.create_draft_save_modal_title": "您要暫存製作中的素材嗎?",
  "chat.create_draft_save_modal_description": "只能暫存最多{{count}}個素材，未儲存的內容將被刪除",
  "chat.create_draft_save_fail_maximum_limit_modal_title": "最多只能暫存{{count}}個素材",
  "chat.create_draft_save_success_toast": "您已成功暫存",
  "chat.create_draft_save_fail_toast": "暫存失敗，請重新嘗試",
  "chat.create_draft_edit_option": "繼續製作",
  "chat.create_draft_delete_success_toast": "您已刪除暫存的素材",
  "chat.create_draft_delete_fail_toast": "刪除暫存素材失敗<br/>請重新嘗試",
  "chat.create_draft_empty": "您沒有製作中的素材",
  "chat.create_draft_noname": "No name",
  "chat.create_create_title": "創建",
  "chat.create_create_character": "角色",
  "chat.create_create_universe": "世界觀",
  "chat.create_create_scene": "場景",
  "chat.create_create_character_header": "創建角色",
  "chat.create_create_universe_header": "創建世界觀",
  "chat.create_create_scene_header": "創建場景",
  "chat.create_add_image_help_text_square": "編輯成正方形時，顯示效果最佳",
  "chat.create_create_character_create": "創建角色",
  "chat.create_create_character_create_description": "請設定AI角色的個性和特點",
  "chat.create_create_character_my_characters": "我的角色",
  "chat.create_create_character_my_characters_empty": "創建專屬我的角色",
  "chat.create_create_universe_create": "創建世界觀",
  "chat.create_create_universe_my_universes": "我的世界觀",
  "chat.create_create_universe_my_universes_empty": "創建專屬我的世界觀",
  "chat.create_create_scene_create": "創建場景",
  "chat.create_create_scene_my_scenes": "我的場景",
  "chat.create_create_scene_my_scenes_empty": "創建專屬我的場景",
  "chat.create_character_creation_guide": "請詳閱角色創建指南!",
  "chat.create_character_add_thumbnail_image_button": "新增相片",
  "chat.create_add_image_failed": "新增相片失敗",
  "chat.create_character_basics_label": "基本資料",
  "chat.create_character_basics_name": "姓名",
  "chat.create_character_basics_name_help_text": "*禁止創建侵犯他人權益的角色，詳細內容請參考營運規章",
  "chat.create_character_basics_gender_label": "性別",
  "chat.create_character_basics_gender_male": "男",
  "chat.create_character_basics_gender_female": "女",
  "chat.create_character_basics_gender_other": "其他",
  "chat.create_character_basics_age_rating_label": "年齡分級",
  "chat.create_character_basics_age_rating_normal_mode": "一般模式",
  "chat.create_character_basics_age_verification": "年齡驗證後即可創建新的臉紅心跳模式角色",
  "chat.create_character_basics_age_rating_normal_mode_description": "所有用戶都能使用",
  "chat.create_character_basics_age_rating_nsfw_mode": "臉紅心跳模式",
  "chat.create_character_basics_age_rating_nsfw_mode_description": "限成人用戶使用",
  "chat.create_character_basics_age_rating_nsfw_mode_toast": "18歲以下的角色沒辦法用臉紅心跳模式創建",
  "chat.create_character_basics_age_rating_help_text": "*選擇一般模式創建角色時，無法套用臉紅心跳模式的世界觀/場景",
  "chat.create_character_Information_label": "詳細資訊",
  "chat.create_character_Information_optional": "選擇",
  "chat.create_character_Information_description": "您可以詳細描述角色",
  "chat.create_character_Information_age": "年齡",
  "chat.create_character_Information_job": "職業",
  "chat.create_character_Information_character": "個性",
  "chat.create_character_Information_speaking_style": "語氣",
  "chat.create_character_Information_interests": "興趣",
  "chat.create_character_details_label": "補充說明",
  "chat.create_character_details_toast": "補充說明最多能輸入{{int_characters}}字",
  "chat.create_character_details_public": "公開說明",
  "chat.create_character_details_placeholder": "請詳細說明角色的個性和其他設定<br/>不要提到任何關於「我」的資訊<br/><br/>例)<br/>角色是電競選手練習生<br/>角色對其他人毫無興趣<br/>角色很好勝",
  "chat.create_character_details_private": "不公開的說明",
  "chat.create_character_details_character_button": "角色",
  "chat.create_character_details_user_button": "我",
  "chat.create_character_multi_images_title": "多張相片",
  "chat.create_character_image_name_title": "相片標題 {{int_imageNumbers}}",
  "chat.create_character_image_name_placeholder1": "熬夜的小泡泡",
  "chat.create_character_image_name_placeholder2": "無聊的下午",
  "chat.create_character_image_name_placeholder3": "去運動的路上",
  "chat.create_character_image_name_placeholder4": "瘋狂科學家",
  "chat.create_character_image_name_placeholder5": "在用聊天機器人的小泡泡",
  "chat.create_character_add_multi_image_button": "新增相片",
  "chat.create_character_delete_multi_image_button": "刪除相片",
  "chat.create_character_context_title": "說明狀況",
  "chat.create_character_context_tooltip_message": "詳細描述姓名、表情、情感、地點、穿著、動作等，更能明確反映到相片上<br/>請參考以下範例<br/>- 小泡泡、睡眼惺忪、疲憊、書桌、帽T、整理頭髮<br/>- 米路、面無表情、無聊、學校、制服、趴在書桌上<br/>- 柳彩媛、靦腆微笑、緊張、去皮拉提斯的路上、緊身褲、引人注目的姿勢",
  "chat.create_character_context_placeholder1": "小泡泡、睡眼惺忪、疲憊、書桌、帽T、整理頭髮",
  "chat.create_character_context_placeholder2": "學校、制服、面無表情、無聊、趴在書桌上、米路",
  "chat.create_character_context_placeholder3": "去皮拉提斯的路上、走路、靦腆微笑、緊張、柳彩媛、緊身褲",
  "chat.create_character_context_placeholder4": "破掉的實驗服和橡膠手套、安娜・浮士德、瘋狂的眼神、好奇心、實驗室、化學實驗",
  "chat.create_character_context_placeholder5": "書桌、小泡泡、紅通通的臉、悸動、休閒帽T、正在聊天",
  "chat.create_character_multi_images_help_text": "上傳的相片在審查後，可能會依規定轉換成臉紅心跳模式專用角色，或設為不公開",
  "chat.create_character_add_multi_images_button": "新增多張相片",
  "chat.create_character_multi_images_modal_title": "新增相片",
  "chat.create_character_multi_images_modal_my_ai_images": "我的AI相片",
  "chat.create_character_multi_images_modal_upload_images": "我的裝置",
  "chat.create_character_multi_images_modal_help_text": "編輯成橫向(16:9)時，顯示效果最佳",
  "chat.create_character_multi_images_modal_edit": "編輯",
  "chat.create_character_multi_images_modal_edit_done": "完成",
  "chat.create_character_multi_images_modal_edit_zoom": "放大",
  "chat.create_character_multi_images_modal_edit_reset": "恢復原狀",
  "chat.create_character_multi_images_modal_edit_square": "正方形",
  "chat.create_character_multi_images_modal_edit_landscape": "橫式",
  "chat.create_character_multi_images_modal_edit_portrait": "直式",
  "chat.create_character_multi_images_context_error_msg_a": "*請輸入相片{{int_imageNumbers}}的說明",
  "chat.create_character_multi_images_context_error_msg_b": "*請勿重複輸入一樣的 相片 {{int_imageNumbers}} 說明",
  "chat.create_character_multi_images_main_image_badge": "封面",
  "chat.create_character_multi_images_main_image_description": "請新增封面",
  "chat.create_character_multi_images_image_title_description": "請輸入相片標題",
  "chat.create_character_multi_images_describe_image": "請輸入相片說明",
  "chat.create_character_multi_images_edit_info_button": "編輯資訊",
  "chat.create_character_multi_images_edit_info_modal_title": "編輯資訊",
  "chat.create_character_multi_images_delete_image_button": "刪除相片",
  "chat.create_character_multi_images_max_size": "最大 {{int_size}}",
  "chat.create_character_multi_images_edit_info_modal_public_toggle": "公開相片",
  "chat.create_character_multi_images_edit_info_modal_main_image_description": "只能新增一張封面",
  "chat.create_character_multi_images_edit_info_modal_save_button": "新增",
  "chat.create_character_context_placeholder6": "描述地越簡單，相片越容易開啟；描述地越複雜，相片越難開啟。<br/><br/>描述簡單的例子) 疲倦的小泡泡<br/>描述複雜的例子) 小泡泡聊了整夜的天，疲憊不堪地坐在書桌前，揉著惺忪的睡眼，不停撫摸著頭髮",
  "chat.create_character_multi_images_set_public": "公開全部相片",
  "chat.create_character_multi_images_modal_delete_description": "和相片一起輸入的資訊也會一起刪除",
  "chat.create_character_multi_images_modal_delete_cancel": "取消",
  "chat.create_character_multi_images_modal_delete_delete": "刪除",
  "chat.create_character_multi_images_modal_set_unlock_bubbles": "解鎖泡泡設定",
  "chat.create_character_multi_images_modal_unlock_available_images": "只能設定不公開之相片",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert1": "請設定解鎖泡泡",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert2": "您能以100個泡泡為單位來輸入",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert": "請設定解鎖泡泡<br/>您能以100個泡泡為單位來輸入",
  "chat.create_character_multi_images_modal_unlock_bubbles": "泡泡",
  "chat.create_character_multi_images_no_unlock_bubble_set": "解鎖泡泡設定失敗",
  "chat.create_character_multi_images_tooltip_title1": "什麼是多張相片?",
  "chat.create_character_multi_images_tooltip_description1": "當您使用多張相片功能，對話中提到特定關鍵字或狀況時，就會顯示對應相片",
  "chat.create_character_multi_images_tooltip_description2": "越簡單的描述，越容易解鎖相片。",
  "chat.create_character_multi_images_tooltip_title2": "供您參考!",
  "chat.create_character_multi_images_tooltip_description3": "對話中提到預先設定的狀況時，即可解鎖不公開的相片。",
  "chat.create_character_multi_images_tooltip_description4": "解鎖所需的泡泡最少為100，會包含進角色的獎勵收益",
  "chat.create_character_multi_images_tooltip_description5": "不公開之相片的分潤比例為50%",
  "chat.create_character_multi_images_title_placeholder": "請輸入相片標題(選填)",
  "chat.create_character_multi_images_upload_title": "請上傳相片",
  "chat.create_character_multi_images_add_title1": "新增相片",
  "chat.create_character_multi_images_add_title2": "({{int_numbers}}/200)",
  "chat.create_character_multi_images_add_description1": "點擊或拖曳相片上傳",
  "chat.create_character_multi_images_add_description2": "最多可同時上傳{{int_numbers}}張相片",
  "chat.create_character_multi_images_add_description3": "1張相片不得超過15MB",
  "chat.create_character_multi_images_upload_fail_size_toast": "檔案過大，有{{int_numbers}}張相片上傳失敗",
  "chat.create_character_multi_images_upload_fail_toast": "有 {{int_numbers}} 張相片上傳失敗",
  "chat.create_character_multi_images_upload_fail_size": "• 檔案過大",
  "chat.create_character_multi_images_upload_fail_format": "• 不支援的格式",
  "chat.create_character_multi_images_upload_fail_limit": "• 上傳數量超過上限",
  "chat.create_character_multi_images_upload_limit_toast": "一次最多只能上傳 {{int_numbers}} 張相片。",
  "chat.create_character_multi_images_uploading": "上傳相片中...",
  "chat.create_character_multi_images_bulk_edit_modal_title": "批次編輯",
  "chat.create_character_multi_images_bulk_edit_modal_image_settings_title": "圖片設定",
  "chat.create_character_multi_images_bulk_edit_modal_privacy_settings_title": "公開設定",
  "chat.create_character_multi_images_bulk_edit_modal_bubble_unit_placeholder": "請以 100 泡泡為單位輸入",
  "chat.create_character_multi_images_bulk_edit_modal_description": "封面圖片無法設定為公開。",
  "chat.create_character_multi_images_bulk_edit_modal_delete_alert_description": "刪除的圖片無法復原",
  "chat.create_character_multi_images_bulk_edit_modal_selected": "已選擇{{count}}個",
  "chat.create_character_multi_images_bulk_edit_modal_select_all": "全部選擇",
  "chat.create_character_multi_images_bulk_edit_modal_deselect": "取消選擇",
  "chat.create_character_multi_images_bulk_edit_unable_to_set": "無法設定",
  "chat.create_character_multi_images_upload_progress": "正在上傳 {{int_current}}/{{int_total}} 張",
  "chat.create_character_multi_images_upload_cancel": "取消",
  "chat.create_character_multi_images_upload_cancel_confirm_title": "要取消上傳嗎？",
  "chat.create_character_multi_images_upload_cancel_confirm": "已上傳完成的圖片會保留。",
  "chat.create_character_multi_images_upload_failed_label": "上傳失敗",
  "chat.create_character_multi_images_upload_retry": "重試",
  "chat.create_character_multi_images_upload_retry_all": "重試失敗的 {{int_numbers}} 張",
  "chat.create_character_multi_images_upload_partial_toast": "已依剩餘空位新增 {{int_numbers}} 張。",
  "chat.create_character_multi_images_upload_slot_full_toast": "空位已滿，有 {{int_numbers}} 張無法新增。",
  "chat.create_character_multi_images_upload_in_progress_block": "圖片上傳完成後即可儲存。",
  "chat.create_character_multi_images_error_nav_prev": "上一張錯誤圖片",
  "chat.create_character_multi_images_error_nav_next": "下一張錯誤圖片",
  "chat.create_character_select_universe": "請選擇世界觀",
  "chat.create_character_select_universe_optional": "選擇",
  "chat.create_character_select_universe_add": "新增",
  "chat.create_character_select_universe_create": "創建",
  "chat.create_character_select_universe_change": "編輯",
  "chat.create_character_select_scene": "請選擇場景",
  "chat.create_character_select_scene_optional": "選擇",
  "chat.create_character_select_scene_add": "新增",
  "chat.create_character_select_scene_create": "創建",
  "chat.create_character_select_scene_change": "編輯",
  "chat.create_character_first_sentence": "第一句話",
  "chat.create_character_first_sentence_optional": "選擇",
  "chat.create_character_first_sentence_description": "角色在聊天室傳的第一句話",
  "chat.create_character_create_character": "角色創建",
  "chat.create_character_link_only": "公開連結",
  "chat.create_character_link_only_help_text": "*連結公開的角色無法將狀態改為公開或不公開",
  "chat.create_character_link_only_description": "擁有連結的用戶才能使用",
  "chat.create_character_link_only_copied": "已複製連結",
  "chat.create_character_link_only_copied_failed": "複製連結失敗",
  "chat.create_character_keyword_book_title": "關鍵字手冊",
  "chat.create_character_keyword_book_number": "關鍵字手冊 {{int_numbers}}",
  "chat.create_character_keyword_book_keyword": "關鍵字",
  "chat.create_character_keyword_book_keyword_placeholder": "輸入關鍵字後請按Enter鍵 (例：轉學)",
  "chat.create_character_keyword_book_keyword_description": "一本關鍵字手冊最多能輸入五個關鍵字",
  "chat.create_character_keyword_book_max_toast": "最多可以輸入五個關鍵字",
  "chat.create_character_keyword_book_keyword_alert": "輸入關鍵字後請按Enter鍵",
  "chat.create_character_keyword_book_content": "內容",
  "chat.create_character_keyword_book_content_placeholder": "請輸入訊息提及關鍵字時，要顯示的內容。<br/>(例：徐真宇國中時因涉及暴力事件轉過一次學。)",
  "chat.create_character_keyword_book_content_alert": "請輸入內容",
  "chat.create_character_keyword_book_add_keyword_book": "新增關鍵字手冊",
  "chat.create_character_keyword_book_incomplete_toast": "請把編輯中的關鍵字手冊填滿五個關鍵字",
  "chat.create_character_keyword_book_edit_modal_title": "關鍵字手冊名稱",
  "chat.create_character_keyword_book_edit_modal_cancel": "取消",
  "chat.create_character_keyword_book_edit_modal_done": "編輯",
  "chat.create_character_keyword_book_delete_modal_title": "確定要刪除關鍵字手冊嗎?",
  "chat.create_character_keyword_book_delete_modal_cancel": "取消",
  "chat.create_character_keyword_book_delete_modal_delete": "刪除",
  "chat.create_character_keyword_book_tooltip_title1": "什麼是關鍵字手冊?",
  "chat.create_character_keyword_book_tooltip_description1": "關鍵字手冊的功能是，當對話中提及特定關鍵字時，會自動載入預先編輯好的相關內容。",
  "chat.create_character_keyword_book_tooltip_description2": "關鍵字要完全相符，才會載入預先設定好的內容。",
  "chat.create_character_keyword_book_tooltip_title2": "請參考!",
  "chat.create_character_keyword_book_tooltip_description3": "請將重要的關鍵字手冊拖曳到上方",
  "chat.create_character_keyword_book_tooltip_description4": "如果同一個關鍵字同時收錄在多本關鍵字手冊中，將會載入最上方的手冊所記載的內容。",
  "chat.create_character_keyword_book_tooltip_description5": "當多個關鍵字同時被提及，會優先套用收錄最多提及關鍵字的關鍵字手冊。",
  "chat.create_character_keyword_book_tooltip_description6": "關鍵字手冊能夠辨識角色與使用者的訊息。",
  "chat.create_universe_creation_guide": "請詳閱世界觀創建指南!",
  "chat.create_universe_profile_img": "縮圖相片",
  "chat.create_universe_basics_label": "基本資訊",
  "chat.create_universe_add_thumbnail_image_button": "新增照片",
  "chat.create_universe_basics_name": "名稱",
  "chat.create_universe_basics_name_placeholder1": "和名人的第一次對話",
  "chat.create_universe_basics_name_placeholder2": "未來科學城",
  "chat.create_universe_basics_name_placeholder3": "偶遇",
  "chat.create_universe_introduction": "介紹",
  "chat.create_universe_introduction_help_text": "*該介紹不會影響世界觀的運作",
  "chat.create_universe_introduction_placeholder1": "看似沒有交集的角色主動前來搭話",
  "chat.create_universe_introduction_placeholder2": "科學飛速發展的近未來",
  "chat.create_universe_introduction_placeholder3": "偶然遇到了一位輕而易舉地制伏了公車劫持犯的角色",
  "chat.create_universe_tags_label": "主題標籤",
  "chat.create_universe_tags_description": "請選擇與世界觀相關的主題標籤",
  "chat.create_universe_tags_placeholder": "搜尋主題標籤",
  "chat.create_universe_sharing_options_label": "公開與否",
  "chat.create_universe_sharing_options_private": "不公開",
  "chat.create_universe_sharing_options_private_description": "只有我能使用",
  "chat.create_universe_sharing_options_public": "公開",
  "chat.create_universe_sharing_options_public_description": "其他用戶也能使用",
  "chat.create_universe_age_rating_label": "年齡分級",
  "chat.create_universe_age_rating_normal_mode": "一般模式",
  "chat.create_universe_age_verification": "年齡驗證後即可創建新的臉紅心跳模式世界觀",
  "chat.create_universe_age_rating_normal_mode_description": "所有用戶都能使用",
  "chat.create_universe_age_rating_nsfw_mode": "臉紅心跳模式",
  "chat.create_universe_age_rating_nsfw_mode_description": "限成人用戶使用",
  "chat.create_universe_relationship_label": "角色和我的關係",
  "chat.create_universe_relationship_label2": "關係",
  "chat.information_universe_relationship_toast_characters": "角色和我的關係最多能輸入{{int_characters}}字",
  "chat.create_universe_relationship_public": "公開說明",
  "chat.create_universe_relationship_private": "不公開的說明",
  "chat.create_universe_relationship_character_button": "角色",
  "chat.create_universe_relationship_user_button": "我",
  "chat.create_universe_relationship_placeholder": "請詳細說明角色和「我」的關係<br/>不要提到任何關於角色的個性或設定<br/><br/>例)<br/>角色和我在同居<br/>角色和我是宿敵<br/>角色積極追求我",
  "chat.create_universe_details_label": "補充說明",
  "chat.create_universe_details_public": "公開說明",
  "chat.create_universe_details_private": "不公開的說明",
  "chat.create_universe_details_character_button": "角色",
  "chat.create_universe_details_user_button": "我",
  "chat.create_universe_create_universe": "創建世界觀",
  "chat.create_universe_lorebook_label": "設定集",
  "chat.create_universe_lorebook_description1": "我們會理解您輸入的內容，並在對話中自然地引用或根據上下文進行反映",
  "chat.create_universe_lorebook_title": "標題",
  "chat.create_universe_lorebook_title_placeholder": "奇幻異世界設定集 v0.1.0",
  "chat.create_universe_lorebook_content": "內容",
  "chat.create_universe_lorebook_content_placeholder": "這個世界環繞著貝拉諾特而建，貝拉諾特是七個次元交會的中心點。<br/>每個次元都有其獨特的時間流、物理定律和生命體，使貝拉諾特成為一個匯集多元生物的大熔爐。",
  "chat.create_universe_lorebook_description2": "新增、編輯、刪除設定集都會影響到既有的聊天室",
  "chat.create_universe_lorebook_description3": "*設定集的標題不會影響世界觀的運作",
  "chat.create_universe_lorebook_incomplete_title_alert": "請輸入標題",
  "chat.create_universe_lorebook_incomplete_content_alert": "請輸入內容",
  "chat.create_universe_lorebook_incomplete_toast": "請將設定集的每一個空格填滿",
  "chat.create_scene_creation_guide": "請詳閱場景觀創建指南!",
  "chat.create_scene_basics_label": "基本資訊",
  "chat.create_scene_add_thumbnail_image_button": "新增相片",
  "chat.create_scene_basics_name": "名稱",
  "chat.create_scene_basics_name_placeholder1": "坐隔壁的名人",
  "chat.create_scene_basics_name_placeholder2": "探病",
  "chat.create_scene_basics_name_placeholder3": "被劫持的公車",
  "chat.create_scene_introduction_placeholder1": "早上九點，我跟坐在教室前方的角色對到眼了。",
  "chat.create_scene_introduction_placeholder2": "下午兩點，角色來探病。",
  "chat.create_scene_introduction_placeholder3": "在下班時間，整台公車遭到劫持。",
  "chat.create_scene_introduction_help_text": "*該介紹不會影響場景的運作",
  "chat.create_scene_tags_label": "主題標籤",
  "chat.create_scene_tags_description": "請選擇與場景相關的主題標籤",
  "chat.create_scene_tags_placeholder": "搜尋主題標籤",
  "chat.create_scene_sharing_options_label": "公開與否",
  "chat.create_scene_sharing_options_private": "不公開",
  "chat.create_scene_sharing_options_private_description": "只有我能使用",
  "chat.create_scene_sharing_options_public": "公開",
  "chat.create_scene_sharing_options_public_description": "其他用戶也能使用",
  "chat.create_scene_age_rating_label": "年齡分級",
  "chat.create_scene_age_rating_normal_mode": "一般模式",
  "chat.create_scene_age_verification": "年齡驗證後即可創建新的臉紅心跳模式場景",
  "chat.create_scene_age_rating_normal_mode_description": "所有用戶都能使用",
  "chat.create_scene_age_rating_nsfw_mode": "臉紅心跳模式",
  "chat.create_scene_age_rating_nsfw_mode_description": "限成人用戶使用",
  "chat.create_scene_time": "時間",
  "chat.create_scene_place": "場所",
  "chat.create_scene_place_placeholder1": "教室",
  "chat.create_scene_place_placeholder2": "泡泡綜合醫院住院病房",
  "chat.create_scene_place_placeholder3": "公車上",
  "chat.create_scene_time_placeholder1": "早上9點",
  "chat.create_scene_time_placeholder2": "星期六，下午2點",
  "chat.create_scene_time_placeholder3": "下班時間",
  "chat.create_scene_optional": "選擇",
  "chat.create_scene_details_label": "補充說明",
  "chat.create_scene_details_public": "公開說明",
  "chat.create_scene_details_private": "不公開的說明",
  "chat.create_scene_details_character_button": "角色",
  "chat.create_scene_details_user_button": "我",
  "chat.create_scene_details_placeholder": "請設定對話開始的場景<br/>寫得越詳細，越能享受優質的對話體驗!<br/><br/>例)角色叫醒睡夢中的我<br/>角色來醫院探望我",
  "chat.create_scene_create_universe": "創建場景",
  "chat.create_persona_title": "創建人格",
  "chat.create_persona_placeholder1": "李煥, 17歲, 男, 高中生, 偶像, 親切、善良、活潑, 興趣: 歌唱訓練、擔心即將到來的演唱會",
  "chat.create_persona_placeholder2": "金雨彬, 20歲, 男, 泡泡大學一年級新生, 拘謹、怕生、貼心、渴望愛, 興趣: 讀書、健身房、戀愛、愛情",
  "chat.create_persona_placeholder3": "鄭漢娜, 18歲, 女, 女僕, 溫柔體貼、嘮叨時態度堅決、有點異想天開, 興趣: 繡球花、家事、韓式炸雞塊",
  "chat.create_persona_create_failed": "人格創建失敗，請重新嘗試",
  "chat.create_persona_done": "完成",
  "chat.create_persona_create": "自行創建",
  "chat.create_persona_add_image": "新增相片",
  "chat.create_persona_optional": "選擇",
  "chat.create_persona_name_label": "姓名",
  "chat.create_persona_name_placeholder": "李煥",
  "chat.create_persona_name_help_text": "*禁止創建侵犯他人權益的人格，詳細內容請參考營運規章",
  "chat.create_persona_gender_label": "性別",
  "chat.create_persona_gender_male": "男",
  "chat.create_persona_gender_female": "女",
  "chat.create_persona_gender_other": "其他",
  "chat.create_persona_age_label": "年齡",
  "chat.create_persona_job_label": "職業",
  "chat.create_persona_job_placeholder": "高中生，偶像",
  "chat.create_persona_character": "個性",
  "chat.create_persona_personality_placeholder": "親切、善良、活潑",
  "chat.create_persona_interests_label": "興趣",
  "chat.create_persona_interests_placeholder": "歌唱訓練、擔心即將到來的演唱會",
  "chat.create_persona_import": "創建成角色",
  "chat.create_persona_search": "請輸入搜尋關鍵字",
  "chat.create_persona_select_tags_button": "選擇主題標籤",
  "chat.create_persona_select_tags_modal_title": "選擇主題標籤",
  "chat.create_persona_select_tags_modal_search": "搜尋主題標籤",
  "chat.create_persona_select_tags_modal_trending_tags": "即時熱門主題標籤",
  "chat.create_persona_select_tags_modal_selected_tags": "已選擇的主題標籤",
  "chat.create_persona_select_tags_modal_reset_button": "恢復原狀",
  "chat.create_persona_select_tags_modal_apply_tags_button": "套用主題標籤",
  "chat.create_persona_select_tags_button_selected": "已選擇{{int_tagNumbers}}個",
  "chat.create_persona_chat_list_relevancy": "最相關",
  "chat.create_persona_chat_list_order_recent": "依新到舊排序",
  "chat.create_persona_chat_list_order_liked": "最多人按讚",
  "chat.create_persona_chat_list_order_played": "最多人玩",
  "chat.create_persona_create_toast": "已創建人格",
  "chat.create_persona_age_limit": "年齡最大能設定為10億歲，最小能設定為負10億歲",
  "chat.create_add_multiple_images_toast": "請填滿中間所有的空白欄位，才能一次上傳多張圖片",
  "chat.create_tags_characters_toast": "標籤請控制在{{int_characters}}個字以內。",
  "chat.modify_change_thumbnail_image_button": "編輯相片",
  "chat.modify_persona": "編輯人格",
  "chat.modify_persona_failed": "人格編輯失敗，請重新嘗試",
  "chat.modify_character_modify_fail_message": "角色編輯失敗<br/>請重新嘗試",
  "chat.modify_universe_modify_fail_message": "世界觀編輯失敗<br/>請重新嘗試",
  "chat.modify_scene_modify_fail_message": "場景編輯失敗<br/>請重新嘗試",
  "chat.general_connect_fail_message": "無法連接到服務，請重新整理或稍後再試",
  "chat.modify_character_header": "編輯角色",
  "chat.modify_universe_header": "編輯世界觀",
  "chat.modify_scene_header": "編輯場景",
  "chat.modify_character_modify_save": "編輯角色",
  "chat.modify_universe_modify_save": "編輯世界觀",
  "chat.modify_scene_modify_save": "編輯場景",
  "chat.modify_modal_unsaved_changes_title": "有未儲存的修改",
  "chat.modify_modal_excluded_character_universe": "若設為不公開，所有套用此世界觀的角色將會被解除套用<br/>您確定要繼續修改嗎?",
  "chat.modify_modal_excluded_character_scene": "若設為不公開，所有套用此場景的角色將會被解除套用<br/>您確定要繼續修改嗎?",
  "chat.modify_toast_blocked_universe": "已設定為不公開的世界觀，無法改設為公開",
  "chat.modify_toast_blocked_scene": "已設定為不公開的場景，無法改設為公開",
  "chat.modify_toast_created_only_character": "只能編輯自己創建的角色",
  "chat.modify_toast_created_only_universe": "只能編輯自己創建的世界觀",
  "chat.modify_toast_created_only_scene": "只能編輯自己創建的場景",
  "chat.modify_toast_nsfw_character": "無法將臉紅心跳模式中的角色年齡變更為18歲以下",
  "chat.modify_modal_unsaved_changes_description": "編輯中的內容尚未儲存<br/>確定要離開此頁面嗎?",
  "chat.modify_modal_unsaved_changes_cancel_button": "取消",
  "chat.modify_modal_unsaved_changes_leave_button": "退出",
  "chat.modify_no_change_private_character": "已設定為不公開的角色，無法改設為公開",
  "chat.modify_persona_deleted": "已刪除人格",
  "chat.modify_persona_deleted_failed": "刪除人格失敗",
  "chat.search_title": "您在找什麼呢?",
  "chat.search_search_description_characters": "搜尋角色",
  "chat.search_search_description_universes": "搜尋世界觀",
  "chat.search_search_description_scenes": "搜尋場景",
  "chat.search_search_toggle_menu_characters": "角色",
  "chat.search_search_toggle_menu_universes": "世界觀",
  "chat.search_search_toggle_menu_scenes": "場景",
  "chat.search_search_modal_recent_searches": "最近搜尋",
  "chat.search_search_modal_delete_all": "全部刪除",
  "chat.search_select_tags_button": "選擇主題標籤",
  "chat.search_select_tags_modal_title": "選擇主題標籤",
  "chat.search_select_tags_modal_search": "搜尋主題標籤",
  "chat.search_select_tags_modal_trending_tags": "即時熱門主題標籤",
  "chat.search_select_tags_modal_selected_tags": "已選擇的主題標籤",
  "chat.search_select_tags_modal_reset_button": "恢復原狀",
  "chat.search_select_tags_modal_apply_tags_button": "套用主題標籤",
  "chat.search_select_tags_button_selected": "已選擇{{int_tagNumbers}}個",
  "chat.search_nsfw_toggle": "臉紅心跳模式",
  "chat.search_chat_list_relevancy": "最相關",
  "chat.search_chat_list_order_recent": "依新到舊排序",
  "chat.search_chat_list_order_liked": "最多人按讚",
  "chat.search_chat_list_order_played": "最多人玩",
  "chat.search_no_results": "沒有搜尋結果",
  "chat.search_search_description_writername": "搜尋暱稱",
  "chat.search_search_toggle_menu_writername": "暱稱",
  "chat.rewards_revenue_information": "收益資訊",
  "chat.rewards_revenue_information_total_revenue": "累積收益",
  "chat.rewards_revenue_information_total_withdrawals": "累計提款金額",
  "chat.rewards_revenue_information_last months_withdrawal": "上個月收益",
  "chat.rewards_revenue_information_withdrawable_revenue": "可提領收益",
  "chat.rewards_revenue_information_withdrawable_revenue_help_text": "這是根據淨收益和分潤比例計算出的金額<br/>此金額每月15日更新",
  "chat.rewards_revenue_information_profit_sharing_rate": "分潤比例",
  "chat.rewards_revenue_information_request_a_withdrawal": "提領申請",
  "chat.rewards_revenue_converted_amount_help_text": "一旦申請轉換並已扣款，該筆金額將無法取消",
  "chat.rewards_creator_information": "創作者資訊",
  "chat.rewards_creator_information_username": "使用者代碼",
  "chat.rewards_creator_information_identity_verification": "實名認證",
  "chat.rewards_creator_information_completed_button": "認證成功",
  "chat.rewards_creator_information_email": "電子郵件地址",
  "chat.rewards_creator_information_edit": "編輯",
  "chat.rewards_creator_information_account_verification": "驗證銀行帳戶",
  "chat.rewards_creator_information_verify": "驗證",
  "chat.rewards_tracking_revenue": "追蹤收益",
  "chat.rewards_tracking_revenue_total": "全部",
  "chat.rewards_tracking_revenue_characters": "角色",
  "chat.rewards_tracking_revenue_universes": "世界觀",
  "chat.rewards_tracking_revenue_scenes": "場景",
  "chat.rewards_tracking_revenue_day_button": "日",
  "chat.rewards_tracking_revenue_week_button": "週",
  "chat.rewards_tracking_revenue_month_button": "月",
  "chat.rewards_monthly_sales": "{{int_month}}銷售額",
  "chat.rewards_monthly_sales_my_assets": "我的素材",
  "chat.rewards_monthly_sales_total": "全部",
  "chat.rewards_monthly_sales_characters_button": "角色",
  "chat.rewards_monthly_sales_universes_button": "世界觀",
  "chat.rewards_monthly_sales_scenes_button": "場景",
  "chat.home_require_alert_login_age_verification_character": "此角色需登入及實名認證後才可使用",
  "chat.home_require_alert_login_age_verification_universe": "此世界觀需登入及實名認證後才可使用",
  "chat.home_require_alert_login_age_verification_scene": "此場景需登入及實名認證後才可使用",
  "chat.home_require_alert_age_verification_character": "此角色需實名認證後才可使用",
  "chat.home_require_alert_age_verification_universe": "此世界觀需實名認證後才可使用",
  "chat.home_require_alert_age_verification_scene": "此場景需實名認證後才可使用",
  "chat.modify_modal_select_public_description": "您選擇的為不公開的世界觀/場景，因此無法公開此角色<br/>請改選公開的世界觀/場景",
  "chat.rewards_convert_bubbles_button": "轉換泡泡",
  "chat.rewards_convert_bubbles_modal_title": "轉換泡泡",
  "chat.rewards_convertible_bubbles": "可轉換的泡泡",
  "chat.rewards_bubbles_to_convert": "已申請轉換的泡泡",
  "chat.rewards_convert_bubbles_description_calculated": "*可轉換的泡泡是從可提領收益中扣除 3.3% 稅金後計算出的數值",
  "chat.rewards_convert_bubbles_description_refund": "代幣一旦申請轉換並已扣除，將無法申請取消或退款(依據韓國《與信專門金融業法(暫譯)》第70條第3項第2款規範) ",
  "chat.rewards_convert_bubbles_description_units": "泡泡轉換以1,000為單位，申請後立即扣除",
  "chat.rewards_convert_bubbles_alert_units": "泡泡可以1,000為單位進行轉換",
  "chat.rewards_convert_bubbles_alert_limit": "每次轉換上限為150萬泡泡",
  "chat.rewards_notification_profit_application": "收益提領申請通知",
  "chat.rewards_notification_subtitle_first": "創作者您好，我們是BubbleChat",
  "chat.rewards_notification_subtitle_second": "您的收益提領結果如下",
  "chat.rewards_notification_profit_application_description": "已收到您如下的收益提領申請",
  "chat.rewards_notification_request_amount": "申請金額",
  "chat.rewards_notification_request_date": "提領申請日",
  "chat.rewards_notification_withdrawal_date": "預計匯款日",
  "chat.rewards_notification_status": "狀態",
  "chat.rewards_notification_pending": "等候",
  "chat.rewards_notification_completed": "完成",
  "chat.rewards_notification_rejected": "拒絕",
  "chat.rewards_notification_hold": "待查驗",
  "chat.rewards_notification_deposit_amount": "入帳金額",
  "chat.rewards_notification_note": "備註",
  "chat.rewards_notification_deposit_tax": "入帳金額已扣除3.3%稅金",
  "chat.rewards_notification_contact_us": "如您對以上有任何疑問，請透過客服中心與我們聯繫",
  "chat.rewards_notification_profit_completion": "收益提領成功通知",
  "chat.rewards_notification_profit_completion_description": "您的收益提領已成功",
  "chat.rewards_notification_profit_reject": "收益提領失敗通知",
  "chat.rewards_notification_profit_reject_description": "很遺憾通知您，此次提領申請已遭拒絕",
  "chat.rewards_notification_profit_reject_reasons": "提領申請遭拒絕，可能是下面幾個原因",
  "chat.rewards_notification_profit_reject_reasons_copyright": "角色/世界觀/場景違反智慧財產權",
  "chat.rewards_notification_profit_reject_reasons_policy": "違反其他BubbleChat政策",
  "chat.rewards_notification_profit_reject_amount": "您被拒絕提領的金額總共是{{int_amount}}韓元",
  "chat.rewards_notification_profit_reject_amount_description": "款項將重新計入可提領餘額，待問題解決後即可再次申請提領",
  "chat.rewards_notification_profit_hold": "收益提領待查驗通知",
  "chat.rewards_notification_profit_hold_description": "很遺憾通知您，此次提領申請還在待查驗狀態",
  "chat.rewards_notification_profit_hold_reasons": "提領申請待查驗，可能是下面幾個原因",
  "chat.rewards_notification_profit_hold_amount": "您待查驗提領的金額總共是{{int_amount}}韓元",
  "chat.rewards_notification_conversion_completion": "轉換泡泡完成通知",
  "chat.rewards_notification_conversion_completion_description": "如下，泡泡轉換已完成",
  "chat.rewards_notification_conversion_amount": "泡泡轉換申請金額",
  "chat.rewards_notification_conversion_date": "泡泡轉換日",
  "chat.rewards_notification_conversion_number": "已發送泡泡數",
  "chat.rewards_notification_conversion_tax": "申請金額在扣除3.3%稅金後，將會發放泡泡",
  "chat.rewards_top_sales_monthly": "{{int_month}}月銷售額TOP",
  "chat.rewards_profit_sharing_terms": "創作者使用條款",
  "chat.rewards_terms_of_service": "服務條款",
  "chat.rewards_privacy_policy": "個人資料使用告知事項",
  "chat.rewards_operational_policy": "營運規章",
  "chat.rewards_juvenile_protection_policy": "兒童及少年福利與權益保障法",
  "chat.rewards_verify_identify_email_account": "驗證銀行帳戶前，請先進行實名認證及電子郵件地址驗證",
  "charging_stn_free_modal_allow_web_tracking_title": "同意網路追蹤",
  "charging_stn_free_modal_allow_web_tracking_description": "您是否允許使用廣告識別碼<br/>進行網站追蹤?",
  "charging_stn_free_modal_allow_web_tracking_allow": "同意",
  "charging_stn_free_modal_allow_web_tracking_decline": "拒絕",
  "chat.rewards_currency_krw": "(韓元)",
  "chat.rewards_confirmation_email": "轉換紀錄會寄送到您的電子郵件地址",
  "chat.rewards_account_holder": "戶名",
  "chat.rewards_bank": "銀行",
  "chat.rewards_account_number": "銀行帳號",
  "chat.rewards_account_info_update": "編輯銀行帳號資訊",
  "chat.rewards_legal_responsibility": "我同意，若盜用他人身份或使用非本人個人資料，將承擔所有法律責任",
  "chat.rewards_real name_id": "請輸入實名認證時使用的真實姓名",
  "chat.rewards_digit_number": "請輸入不含 '-' 的數字",
  "chat.rewards_only_number": "請輸入不含 '-' 的數字",
  "chat.rewards_account_holder_name_description": "戶名要和姓名相同",
  "chat.rewards_verify_button": "驗證",
  "chat.rewards_account_verification": "驗證銀行帳戶",
  "chat.rewards_agree_personal_information": "我同意<link1>個人資料的蒐集、處理及利用</link1>",
  "chat.rewards_available_withdrawal_amount": "可提領餘額",
  "chat.rewards_withdrawal_request_amount": "申請提領金額",
  "chat.rewards_withdrawal_amount_deduction": "*可提領餘額已從可提領收益中扣除3.3%稅金",
  "chat.rewards_withdrawal_increments": "提領請以10,000韓元為單位，申請後立即扣除",
  "chat.rewards_requests_made_date": "當月15日前提出的提領申請，將於當月25日入帳；當月15日(含)之後提出的申請，則會於次月25日入帳。入帳完成後，我們會透過電子郵件通知您。",
  "chat.rewards_withdrawal_request_cancel": "取消",
  "chat.rewards_withdrawal_request_submit": "申請",
  "chat.rewards_modal_reclaimed": "您有一部份的不公開角色/世界觀/場景，部分收益已被收回，如您有疑問，請洽<link1>客服中心</link1>",
  "chat.rewards_modal_reclaimed_button": "確認",
  "chat.rewards_currency_bubbles_zero": "泡泡",
  "chat.rewards_currency_bubbles_one": "泡泡",
  "chat.rewards_currency_bubbles_other": "泡泡",
  "chat.rewards_withdrawal_title": "申請提領",
  "chat.rewards_withdrawal_currency_krw": "韓元",
  "chat.rewards_agree_legal_terms": "請同意承擔以下法律責任",
  "chat.rewards_select_bank": "請選擇銀行",
  "chat.rewards_correct_rrn": "請正確輸入身分證字號",
  "chat.rewards_consent_collect_personal_info": "請同意個人資料的蒐集、處理及利用",
  "chat.rewards_enter_bank_code": "請輸入銀行代碼",
  "chat.rewards_bubble_conversion_verify_complete": "完成實名認證、電子郵件地址驗證、銀行帳戶驗證後即可申請轉換",
  "chat.rewards_withdrawal_verify_complete": "完成實名認證、電子郵件地址驗證、銀行帳戶驗證後即可申請提領",
  "chat.rewards_account_verification_help_text": "驗證銀行帳戶前，請先進行實名認證及電子郵件地址驗證",
  "chat.rewards_modal_unsaved_content_title": "有未儲存的修改",
  "chat.rewards_modal_unsaved_content_description": "您填的資訊全都會消失<br/>確定要離開嗎?",
  "chat.rewards_modal_unsaved_content_cancel": "取消",
  "chat.rewards_modal_unsaved_content_back": "退出",
  "chat.rewards_withdrawal_request_completed": "已完成提領申請",
  "chat.rewards_withdrawal_request_failed": "提領申請失敗",
  "chat.rewards_bubble_conversion_request_completed": "已完成兌換申請",
  "chat.rewards_bubble_conversion_request_failed": "兌換申請失敗",
  "chat.rewards_total_revenue_time_update_alert_title": "累積收益更新週期變更",
  "chat.rewards_total_revenue_time_update_alert_description": "為了系統改善與穩定性<br/>已改為每24小時更新一次。<br/><br/>請您使用時多加留意。",
  "chat.rewards_total_revenue_time_update_alert_button1": "不要再顯示",
  "chat.rewards_total_revenue_time_update_alert_button2": "確認",
  "chat.rewards_total_revenue_time_update_tooltip": "金額將以24小時為基準，每日更新一次。",
  "chat.rewards_no_transferable_alert_title": "[9/26~9/30]<br/>暫停泡泡轉換服務公告",
  "chat.rewards_no_transferable_alert_description": "為了確保十月初所得稅申報及結算順利進行，\n泡泡轉換服務將於 9月26日 00:00 起至 9月30日 23:59 暫停服務。",
  "chat.rewards_no_transferable_alert_ok_button": "確認",
  "chat.content_moderation_word_create_validation_message": "包含不適當的詞彙 {{string_words}}",
  "chat.content_moderation_word_create_failed_message": "包含不適當的詞彙，請編輯後重新嘗試",
  "chat.content_moderation_word_multi_image_error_message": "相片{{int_imageNumbers}}中有不適當的詞彙",
  "chat.content_moderation_word_multi_image_validation_message": "包含不適當的詞彙 {{string_words}}",
  "chat.content_moderation_word_conversation_toast": "包含不適當的詞彙<br/>{{string_words}}",
  "chat.content_moderation_word_create_failed_message_button": "確認",
  "chat.content_moderation_word_keyword_book_error_message": "關鍵字手冊{{int_keywordbookNumbers}}中有不適當的詞彙",
  "chat.home_sidebar_support_center": "客服中心",
  "chat.support_center_top_title": "FAQ",
  "chat.support_center_unresolved_issues": "還是有無法解決的問題嗎?",
  "chat.support_center_contact_button": "聯繫我們",
  "chat.support_center_contact_history_button": "詢問記錄",
  "chat.support_center_contact_submit_alert": "已收到您的提問",
  "chat.notification_contact_title": "聯絡我們",
  "chat.notification_contact_reply": "您的問題已回覆完成。若在 72 小時內沒有其他補充詢問，此次問題將自動結案。",
  "chat.notification_contact_reply_additional_inquiry": "您提出的追加問題已回覆完成。若在 72 小時內沒有其他補充詢問，此次問題將自動結案。",
  "chat.support_center_contact_information_title": "1 對 1 客服諮詢",
  "chat.support_center_contact_information_description1": "答覆將於平日 09:00～17:00 之間依序處理。",
  "chat.support_center_contact_information_description2": "若對同一問題還有其他疑問，請透過「追加提問」功能繼續留言。",
  "chat.support_center_contact_information_description3": "您的問題越具體，我們能提供的指引就會越精確。",
  "chat.support_center_contact_information_description4": "追加提問最多可提交 4 次，其他類型的問題請另行提問。",
  "chat.support_center_contact_category_title": "分類",
  "chat.support_center_contact_category_placeholder": "選擇問題內容",
  "chat.support_center_contact_user_environment_title": "使用者環境",
  "chat.support_center_contact_user_environment_app": "App",
  "chat.support_center_contact_user_environment_web": "Web",
  "chat.support_center_contact_user_environment_manual": "直接輸入",
  "chat.support_center_contact_user_environment_placeholder": "請選擇使用者環境。",
  "chat.support_center_contact_inquiry_title": "標題",
  "chat.support_center_contact_inquiry_placeholder": "請輸入問題標題。",
  "chat.support_center_contact_inquiry_detail": "問題內容",
  "chat.support_center_contact_inquiry_detail_placeholder": "請隨意填寫您想詢問的內容！",
  "chat.support_center_contact_add_image_optional": "附加圖片 (可選)",
  "chat.support_center_contact_add_image_format": "JPEG/PNG/WEBP/GIF",
  "chat.support_center_contact_add_image_size": "最大 10MB",
  "chat.support_center_contact_input_category_alert": "請選擇分類",
  "chat.support_center_contact_user_environment_input_alert": "請選擇使用者環境",
  "chat.support_center_contact_subject_title_input_alert": "請輸入標題",
  "chat.support_center_contact_subject_detail_input_alert": "請輸入內容",
  "chat.support_center_contact_status_inquiry_completed": "提交完成",
  "chat.support_center_contact_status_reply_completed": "答覆完成",
  "chat.support_center_contact_status_reply_closed": "問題結案",
  "chat.support_center_contact_view": "查看詳情",
  "chat.support_center_contact_view_no_inquiry_history": "沒有任何問題紀錄",
  "chat.support_center_contact_view_success_inquiry_message": "您的問題已成功提交。<br/>我們正在確認您提交的內容，並會盡快給予回覆。<br/>答覆將於平日 09:00～17:00 之間依序處理。",
  "chat.support_center_contact_view_inquiry_delete_modal": "您要取消提問嗎?",
  "chat.support_center_contact_view_inquiry_delete_modal_description": "您提交的內容將被刪除。",
  "chat.support_center_contact_modify": "編輯問題",
  "chat.support_center_contact_unresolved_issue_alert_modal": "您的問題還沒解決嗎?",
  "chat.support_center_contact_unresolved_issue_alert_modal_description1": "您可以透過「追加提問」繼續發問!",
  "chat.support_center_contact_unresolved_issue_alert_modal_description2": "「追加提問」最多可使用 4 次!",
  "chat.support_center_contact_unresolved_issue_alert_modal_description3": "若是其他類型的問題，請重新提交，我們才能更準確地協助您!",
  "chat.support_center_contact_unresolved_issue_alert_modal_button": "追加提問",
  "chat.support_center_contact_response_check_title": "此答覆對您有幫助嗎?",
  "chat.support_center_contact_response_additional_inquiry_button": "進行追加提問",
  "chat.support_center_contact_response_closed_inquiry_button": "結束問題",
  "chat.support_center_contact_previous_inquiry_title": "先前的問題與答覆",
  "chat.support_center_contact_hide_button": "收合",
  "chat.support_center_contact_see_more_button": "查看詳情",
  "chat.support_center_contact_success_inquiry_closed_toast": "您的問題已正常結案。",
  "chat.support_center_contact_resolved_inquiry_message": "此問題已解決。",
  "chat.support_center_contact_fail_submit_toast": "問題提交失敗。請再試一次。",
  "chat.support_center_contact_fail_update_toast": "問題編輯失敗。請再試一次。",
  "chat.support_center_contact_fail_additional_submit_toast": "追加提問提交失敗。追加提問最多可使用 4 次。",
  "chat.support_center_contact_fail_closed_toast": "問題結案失敗。請再試一次。",
  "chat.support_center_contact_fail_cancel_toast": "問題取消失敗。請再試一次。",
  "chat.support_center_contact_user_environment_manual_placeholder": "請自行輸入使用者環境",
  "chat.support_center_contact_user_environment_manual_input_alert": "請自行輸入使用者環境",
  "chat.support_center_contact_cancel_success_toast": "已成功取消詢問",
  "chat.support_center_contact_inquiry_complete_success_toast": "您的詢問已正常結束",
  "chat.support_center_contact_view_inquiry_support_team": "BubbleChat 客服中心",
  "chat.support_center_contact_enter_title_input_alert": "請輸入不超過 50 個字的標題",
  "chat.support_center_contact_view_inquiry_cancel_inquiry": "取消詢問",
  "chat.support_center_contact_view_inquiry_attached_image": "附加的圖片",
  "statistic_list_title": "統計",
  "statistic_domestic": "國內",
  "statistic_international": "國外",
  "statistic_identity_verification_modal_title": "完成實名認證後即可查看統計。",
  "statistic_payment_history_rewards_button": "獎勵",
  "statistic_period_record_title": "最近<span> {{string_time}}</span> {{string_name}}的 {{string_assets}}對話數總共有<span> '{{int_numbers}}句'</span>!",
  "statistic_all_record_title": "{{string_name}}的 {{string_assets}}對話數總共有<span>' '{{int_numbers}}句'</span>！",
  "statistic_help_information": "1小時會更新一次統計結果<br/>未滿100句的素材不會列入統計",
  "statistic_history_no_record": "只有擁有超過 100 聊天的 {{string_name}} 會被顯示。",
  "manual_identity_verification": "實名認證",
  "manual_identity_verification_notify1": "我同意蒐集和使用個人資訊",
  "manual_identity_verification_notify2": "我同意，若盜用他人名義或非本人之個人資料，願承擔所有法律責任。",
  "manual_identity_verification_id_card": "身分證",
  "manual_identity_verification_id_card_tooltip": "僅限使用身分證或居留證進行實名認證",
  "manual_identity_verification_id_card_file_format": "JPEG/PNG/WEBP/GIF",
  "manual_identity_verification_id_card_file_size": "最大 10MB",
  "manual_identity_verification_id_card_name_placeholder": "姓名",
  "manual_identity_verification_id_card_name_guide_th": "請輸入中文或英文",
  "manual_identity_verification_id_card_number_placeholder": "身分證字號",
  "manual_identity_verification_id_card_address_placeholder": "地址",
  "manual_identity_verification_id_card_address_guide": "如和身分證上地址不同，可能會導致認證失敗",
  "manual_identity_verification_id_card_email_placeholder": "電子郵件地址",
  "manual_identity_verification_id_card_birthdate_placeholder": "出生日期",
  "manual_identity_verification_submit_button": "提交",
  "manual_identity_verification_request_complete_title_modal": "已提交實名認證要求",
  "manual_identity_verification_request_complete_description_modal": "您提交的資料會在韓國3個工作天內<br/>進行處理並審核",
  "manual_identity_verification_ok_button": "確認",
  "manual_identity_verification_pending_title_modal": "實名認證進行中",
  "manual_identity_verification_pending_description_modal": "您已經成功提交資料<br/>會在韓國3個工作天內進行處理並審核",
  "manual_identity_verification_verifying_description": "此名義已申請過實名認證。",
  "manual_identity_verification_complete_title_modal": "已完成實名認證",
  "manual_identity_verification_complete_description_modal": "實名認證已在{{string_date}}完成",
  "manual_identity_verification_waiting_menu": "處理中",
  "web_tracking_consent_alert_modal_title": "網路追蹤同意",
  "web_tracking_consent_alert_modal_description": "是否允許使用廣告識別碼<br/>進行網路追蹤？",
  "web_tracking_consent_alert_modal_decline_button": "拒絕",
  "web_tracking_consent_alert_modal_allow_button": "同意",
  "chat.contest_page_submit_button": "提交角色",
  "chat.contest_modal_title": "提交徵選作品",
  "chat.contest_modal_description": "符合參加條件的角色才會顯示於清單",
  "chat.contest_modal_tooltip_title": "參加條件",
  "chat.contest_modal_tooltip_description1": "{{int_year}}年 {{int_month}}月 {{int_day}}日 {{int_hour}}點 {{int_minute}}分後最初公開的角色",
  "chat.contest_modal_tooltip_description2": "新增 {{int_number}}張以上相片的角色",
  "chat.contest_modal_submitted_character": "提交成功",
  "chat.contest_modal_character_empty": "無符合條件的角色",
  "chat.contest_modal_production_grant_title": "申請創作角色獎勵",
  "chat.contest_modal_production_grant_description1": "提交{{int_number}}個以上的角色才能申請",
  "chat.contest_modal_production_grant_description2": "提交角色即視為同意所有注意事項",
  "chat.contest_modal_submit_button": "提交",
  "chat.contest_modal_production_grant_title_complete": "您已成功申請創作角色獎勵",
  "chat.contest_modal_submit_alert_title": "確定要提交角色嗎？",
  "chat.contest_modal_submit_alert_description": "提交後無法取消",
  "chat.contest_modal_submit_successful_title": "您已完成角色提交",
  "chat.contest_submission_period_ended_alert_title": "已過提交期限",
  "chat.information_selected_persona_title": "目前的人格",
  "chat.information_selected_persona_login_to_use": "登入後使用",
  "chat.information_conversation_mode_title": "對話模式",
  "chat.information_conversation_mode_messenger": "聊天型",
  "chat.information_persona_bottomsheet_title": "要以哪個個人檔案對話呢？",
  "chat.information_persona_bottomsheet_description": "不使用個人檔案也可以直接開始對話",
  "chat.information_conversation_mode_bottomsheet_title": "要以哪種方式對話呢？",
  "chat.information_conversation_mode_bottomsheet_description": "小說型提供身臨其境的對話體驗<br/>聊天型提供簡單無負擔的對話體驗",
  "chat.information_conversation_mode_bottomsheet_example1": "角色打招呼了。",
  "chat.information_conversation_mode_bottomsheet_example2": "你好",
  "chat.information_conversation_mode_bottomsheet_example3": "用戶回答了。",
  "chat.conversation_menu_my_balance": "我的泡泡和洗髮精",
  "chat.conversation_long_term_memory_current_memory": "目前的記憶",
  "chat.conversation_long_term_memory_current_memory_title": "目前聊天室使用的記憶",
  "chat.conversation_long_term_memory_current_memory_description": "系統會根據您設定的摘要週期自動定期摘要您目前聊天室內的對話。",
  "chat.conversation_long_term_memory_current_memory_auto_update_toggle": "自動更新",
  "chat.conversation_long_term_memory_current_memory_next_update_label": "距離下一次更新",
  "chat.conversation_long_term_memory_current_memory_turns_remaining": "剩{{int_number}}次對話",
  "chat.conversation_long_term_memory_history_description1": "您可以選擇想要的記憶，套用到現在的記憶。",
  "chat.conversation_long_term_memory_history_description2": "記憶超過20個後，最久遠的紀錄會被刪除。({{int_numbers}}/20)",
  "chat.conversation_long_term_memory_summary_settings_title": "請設定角色記憶的摘要方式",
  "chat.conversation_long_term_memory_summary_settings_description": "可以設定角色記憶的摘要週期和字數長度<br/>也能設定摘要基準。",
  "chat.conversation_long_term_memory_summary_settings_interval_caption": "每{{int_numbers}}次對話進行一次摘要。",
  "chat.conversation_long_term_memory_summary_settings_length_caption": "記憶摘要最多{{int_numbers}}字。",
  "chat.conversation_long_term_memory_summary_settings_summary_instructions": "摘要指示",
  "chat.conversation_long_term_memory_summary_settings_guideline_placeholder": "請輸入摘要指示。",
  "chat.conversation_long_term_memory_summary_settings_auto_guideline_info": "自動設定摘要記憶的指示。",
  "chat.conversation_output_environment_header_title": "請設定對話輸出的品質和份量",
  "chat.conversation_output_environment_header_description": "記憶力和輸出量越多時，消耗的泡泡和洗髮精也會增加。",
  "chat.conversation_output_environment_memory_title": "記憶力",
  "chat.conversation_output_environment_memory_description": "設定角色在最近對話的記憶力。",
  "chat.conversation_output_environment_memory_limit_caption": "記住{{int_numbers}}次對話。",
  "chat.conversation_output_environment_memory_warning_description": "記憶力比摘要週期短時，角色可能會忘記重要內容。",
  "chat.conversation_output_environment_response_length_title": "輸出量",
  "chat.conversation_output_environment_response_length_description": "設定角色一次要輸出多長的回覆。",
  "chat.conversation_output_environment_response_length_short_button": "少一點",
  "chat.conversation_output_environment_response_length_medium_button": "普通",
  "chat.conversation_output_environment_response_length_long_button": "多一點",
  "chat.conversation_output_environment_response_length_short_description": "旁白和對白只簡潔輸出重點。",
  "chat.conversation_output_environment_response_length_medium_description": "旁白和對白維持適當長度輸出。",
  "chat.conversation_output_environment_response_length_long_description": "旁白和對白輸出豐富描寫。",
  "chat.conversation_free_limit_modal_title1": "更優秀的模型、更加身臨其境",
  "chat.conversation_free_limit_modal_description1": "無廣告打擾<br/>聊天快感不間斷",
  "chat.conversation_free_limit_modal_miru_description": "紮實的故事結構和有深度的劇情",
  "chat.conversation_free_limit_modal_ads_title": "移除廣告",
  "chat.conversation_free_limit_modal_persona_title": "升級人格設定",
  "chat.conversation_free_limit_modal_persona_description": "最多{{string_chars}}字",
  "chat.conversation_free_limit_modal_usernote_title": "升級使用者筆記",
  "chat.conversation_free_limit_modal_usernote_description": "最多{{string_chars}}字",
  "chat.conversation_free_limit_modal_memory_title": "升級長期記憶",
  "chat.conversation_free_limit_modal_memory_description": "最多{{string_chars}}字，自訂摘要週期",
  "chat.conversation_free_limit_modal_output_title": "自訂輸出設定",
  "chat.conversation_free_limit_modal_output_description": "調整記憶力、輸出量",
  "chat.conversation_free_limit_modal_upgrade_button": "變更成{{string_signature}}",
  "chat.conversation_free_limit_modal_ad_button": "觀看廣告後免費聊天",
  "chat.conversation_convert_to_free_modal_title_suffix": "使用{{string_modelname}}進行對話",
  "chat.conversation_convert_to_free_modal_subtitle": "部分功能會受限制",
  "chat.conversation_convert_to_free_modal_persona_from": "個人檔案 {{string_chars}}字",
  "chat.conversation_convert_to_free_modal_persona_to": "→ {{string_chars}}字",
  "chat.conversation_convert_to_free_modal_usernote_from": "使用者筆記 {{string_chars}}字",
  "chat.conversation_convert_to_free_modal_usernote_to": "→ 無法使用",
  "chat.conversation_convert_to_free_modal_memory_from": "長期記憶 {{string_chars}}字",
  "chat.conversation_convert_to_free_modal_memory_to": "→ {{string_chars}}字",
  "chat.conversation_convert_to_free_modal_output_settings_from": "可設定輸出環境",
  "chat.conversation_convert_to_free_modal_output_settings_to": "→ 不可變更",
  "chat.conversation_convert_to_free_modal_description1": "您輸入的個人檔案和使用者筆記的內容雖不會被刪除，但在實際對話中只會輸出縮減後的字數。",
  "chat.conversation_convert_to_free_modal_description2": "您現在套用的長期記憶摘要週期一結束，就會套用新變更後的設定值。",
  "chat.conversation_convert_to_free_modal_confirm_button": "繼續變更",
  "chat.conversation_free_model_chip": "免費",
  "chat.conversation_free_model_banner_title": "您在使用免費模型",
  "chat.conversation_free_model_banner_persona_limit_description": "使用免費模型時，人格最多可輸入{{string_chars}}字",
  "chat.conversation_free_model_banner_usernote_limit_description": "使用免費模型時，使用者筆記最多可輸入{{string_chars}}字",
  "chat.conversation_free_model_banner_memory_limit_description": "使用免費模型時，長期記憶最多可輸入{{string_chars}}字",
  "chat.conversation_free_model_banner_feature_limit_description": "使用免費模型時，功能會有所限制",
  "chat.popup_model_my_bubbles_label": "我的泡泡",
  "chat.popup_model_topup_button": "儲值",
  "chat.bottomsheet_model_title": "選擇AI模型",
  "chat.conversation_persona_no_set_persona_label": "您沒有已設定的人格",
  "chat.conversation_persona_no_set_persona_description1": "您沒有已選擇的人格",
  "chat.conversation_persona_no_set_persona_description2": "將使用我的頁面中的暱稱進行對話",
  "chat.conversation_paid_model_chip": "付費",
  "chat.bottomsheet_model_estimated_bubbles": "預估價格 {{int_value}} 泡泡",
  "chat.conversation_output_environment_memory_paid_only_description": "使用付費模型時才能調整記憶力強度",
  "chat.conversation_output_environment_response_length_paid_only_description": "使用付費模型時才能調整輸出長度",
  "chat.conversation_long_term_memory_summary_length_title": "摘要字數",
  "chat.conversation_long_term_memory_summary_length_description": "超過字數限制時會自動摘要，儲存在歷史紀錄中",
  "chat.conversation_long_term_memory_summary_settings_custom_guideline_info": "請輸入摘要記憶的指令",
  "chat.conversation_long_term_memory_summary_interval_paid_only_description": "使用付費模型時才能調整摘要週期",
  "chat.conversation_long_term_memory_summary_length_paid_only_description": "使用付費模型時才能調整摘要字數",
  "chat.conversation_no_model_label": "無模型",
  "chat.free_model_ad_unavailable_toast": "廣告載入失敗，請稍後再試。",
  "chat.free_model_ad_loading_title": "準備廣告中",
  "chat.free_model_ad_loading_desc": "請稍候…",
  "chat.conversation_free_limit_modal_ad_preparing_button": "準備廣告中",
  "chat.information_conversation_mode_bottomsheet_character": "角色",
  "chat.conversation_user_note_disabled_modal_title": "Weave 模型無法使用。",
  "chat.conversation_user_note_disabled_modal_description": "請選擇其他模型。",
  "chat.creator_verification_create_not_verified_alert_description": "若要建立素材，需先完成實名認證。",
  "chat.creator_verification_create_not_verified_alert_identity_verify_button": "進行實名認證",
  "chat.creator_verification_my_banner": "完成創作者認證，領取現金獎勵！",
  "chat.creator_verification_create_modal_description": "申請成為 BubbleChat 創作者，領取現金獎勵！",
  "chat.creator_verification_create_modal_view_benefits_button": "查看優惠內容",
  "chat.creator_verification_verified_modal_description": "您已成為 BubbleChat 的創作者！",
  "chat.creator_verification_not_verified_modal_description": "您目前不符合創作者申請資格。",
  "chat.creator_verification_verified_modal_view_rewards_button": "前往查看獎勵",
  "chat.rewards_revenue_sharing_terms_agreement_title": "為使用獎勵功能，請同意創作者使用條款。",
  "chat.rewards_revenue_sharing_terms_agreement_checkbox": "我同意創作者使用條款。",
  "chat.create_image_ai_generated_image_checkbox_description": "AI 生成圖片",
  "chat.conversation_ai_generated_banner": "此對話內容是透過 AI 生成的。",
  "dmm.point": "",
  "dmm.charge_button": "",
  "dmm.bubble": "",
  "dmm.point_owned": "",
  "dmm.not_enough_point_alert_description": "",
  "dmm.not_enough_point_alert_charge_guide": "",
  "weave.daily_limit_indicator": "免費 {{int_current}}/{{int_max}} 次",
  "weave.daily_limit_indicator_unlimited": "免費 ∞",
  "weave.daily_recharge_note": "每天午夜補充",
  "weave.free_limit_reached_title": "免費對話已全數用完",
  "weave.limit_reached_alert_title": "Weave 模型的每日使用次數已用完",
  "weave.limit_reached_alert_body": "使用 Weave Pass，享受無限暢聊",
  "weave.limit_reached_alert_switch_to_model_cta": "切換為 Miru 後開始對話",
  "weave.limit_reached_reset_notice": "免費對話將於明天午夜重新補充。",
  "weave.pass_product_name": "Weave Pass",
  "weave.pass_product_30days_title": "Weave Pass 30天",
  "weave.pass_product_1day_title": "Weave Pass 1天",
  "weave.pass_price_dmm": "{{int_numbers}} DMM 點數",
  "weave.pass_benefit_1": "不限次數，Weave 無限暢聊",
  "weave.pass_purchase_confirm": "要購買 {{string_productName}} 嗎？",
  "weave.pass_purchase_success": "購買完成！",
  "weave.pass_purchase_fail": "購買失敗。請再試一次。",
  "weave.pass_purchase_insufficient_title": "因 DMM 點數不足，{{string_productName}} 購買失敗了",
  "weave.pass_purchase_insufficient_body": "請儲值 DMM 點數後再購買商品。",
  "weave.pass_purchase_insufficient_current": "目前 DMM 點數",
  "weave.pass_purchase_insufficient_required": "購買所需 DMM 點數",
  "weave.pass_purchase_insufficient_shortage": "不足的 DMM 點數",
  "weave.pass_purchase_insufficient_cta": "前往儲值",
  "weave.pass_purchase_duplicate": "已有正在使用中的使用券。{{string_productName}} 結束後即可購買",
  "weave.pass_active_badge": "Weave Pass 使用中",
  "weave.pass_expired_title": "Weave Pass 已結束",
  "weave.pass_expired_body": "從本次對話開始，優惠將不再適用。<br/>請重新購買使用券，繼續享受順暢的對話體驗！",
  "pwa.common_later": "稍後再說",
  "pwa.install_headline": "不用安裝App，<br/>直接從主畫面開啟 {{appName}}",
  "pwa.install_banner_cta_install": "新增至主畫面",
  "pwa.install_banner_cta_open_browser": "使用瀏覽器開啟",
  "pwa.install_banner_cta_open_safari": "使用Safari開啟",
  "pwa.install_banner_inapp_text": "為了讓使用更順暢，<br/>請用瀏覽器開啟 {{appName}}",
  "pwa.install_banner_aria": "App安裝說明",
  "pwa.push_pre_title": "開啟通知，接收<br/>{{appName}} 的最新消息",
  "pwa.push_pre_desc": "我們會通知您追蹤的角色之新訊息，<br/>以及徵選活動、活動消息。",
  "pwa.push_pre_bullet_1": "活動、公告、新角色消息",
  "pwa.push_pre_bullet_2": "追蹤、按讚、留言、回覆等活動通知",
  "pwa.push_pre_bullet_3": "Bubble、藥水、使用券等虛擬貨幣通知",
  "pwa.push_pre_confirm": "開啟通知",
  "pwa.install_steps_title": "安裝方式",
  "pwa.install_steps_ios_1": "點選Safari瀏覽器下方的【分享】按鈕",
  "pwa.install_steps_ios_2": "選擇【新增】至主畫面",
  "pwa.install_steps_ios_3": "點選右上角的【新增】",
  "pwa.install_steps_aos_1": "點選右上角選單（⋮）",
  "pwa.install_steps_aos_2": "選擇新增至主畫面",
  "pwa.install_steps_aos_3": "選擇新增",
  "pwa.inapp_guide_title": "請用 {{targetBrowser}} 開啟",
  "pwa.inapp_guide_desc": "複製連結並用 {{targetBrowser}} 開啟後，<br/>請依照下列步驟安裝",
  "pwa.inapp_guide_copy": "複製連結",
  "pwa.inapp_guide_default_browser": "預設瀏覽器",
  "pwa.install_qr_caption": "請用手機相機掃描 QR Code 並下載。",
  "pwa.install_qr_desktop_cta": "在電腦上安裝捷徑",
  "pwa.offline_message": "網路連線不穩定。<br/>請稍後再試。",
  "pwa.offline_reload": "重新整理",
  "pwa.toast_copy_success": "已複製連結",
  "pwa.toast_copy_fail": "連結複製失敗",
  "pwa.toast_desktop_install_unsupported": "此瀏覽器不支援直接安裝，請點選網址列上的安裝圖示。",
  "pwa.push_default_title": "通知",
  "login.start_with_kakao": "使用 Kakao 登入",
  "login.start_with_google": "使用 Google 登入",
  "login.start_with_apple": "使用 Apple 登入",
  "login.start_with_line": "使用 LINE 登入",
  "login.start_with_dmm": "使用 DMM 登入",
  "chat.onboarding_conversation_watch_ad_alert": "請觀看廣告以繼續對話",
  "chat.onboarding_chat_load_error_modal_description": "無法載入先前的對話，是否要重新嘗試？",
  "chat.onboarding_chat_load_error_modal_not_now_button": "稍後再試",
  "chat.onboarding_character_recommendation_title": "選擇欲對話的角色",
  "chat.onboarding_character_recommendation_button": "開始對話",
  "chat.onboarding_conversation_watch_ad_alert_button": "觀看廣告",
  "chat.onboarding_login_title": "輕鬆登入<br/>繼續您心動的浪漫故事！",
  "general.chat": "BubbleChat",
  "general.chatlist": "對話",
  "chat.home_install_pwa_button": "立即新增",
  "chat.home_install_app_description": "最新消息，App 搶先看",
  "chat.custom_character_title": "請選擇欲遊玩的角色",
  "chat.custom_universe_title": "請選擇欲遊玩的世界觀",
  "chat.custom_scene_title": "請選擇欲遊玩的場景",
  "chat.custom_character_browse_button": "前往查看角色",
  "chat.custom_universe_browse_button": "前往查看世界觀",
  "chat.custom_scene_browse_button": "前往查看場景",
  "chat.information_selected_persona_and_mode_description": "以{{string_naming}}人格開始{{string_type}}對話。",
  "chat.information_conversation_mode_bottomsheet_information": "建立聊天室後即無法變更",
  "chat.information_conversation_mode_character_line_story": "「這是角色的台詞，會詳細地為您講述一段長篇故事。」",
  "chat.information_conversation_mode_character_narrative_story": "說明情境的部分，會提供比聊天型更詳細、更長的回覆。",
  "chat.information_conversation_mode_user_line": "「這是您的台詞。」",
  "chat.information_conversation_mode_user_narrative": "這是我輸入的動作。",
  "chat.information_conversation_mode_character_line_messenger": "「這是角色的台詞，會像傳訊息一樣簡短互動。」",
  "chat.information_conversation_mode_character_narrative_messenger": "說明情境的部分。",
  "chat.information_conversation_mode_messenger_bottomsheet_start_talk": "以聊天型直接開始對話",
  "chat.information_conversation_mode_story_bottomsheet_start_talk": "以小說型直接開始對話",
  "chat.information_bottomsheet_back": "選擇後返回",
  "chat.information_persona_bottomsheet_hint": "個人檔案在聊天室內也可以變更",
  "chat.information_persona_bottomsheet_start": "以此個人檔案直接開始對話",
  "chat.information_persona_edit_button": "編輯",
  "chat.information_persona_delete_button": "刪除",
  "chat.information_detail_cta_description": "以「{{persona}}」個人檔案開始「{{mode}}」對話",
  "chat.information_multi_image": "多張相片",
  "chat.information_multi_image_count": "{{int_count}}張",
  "chat.information_creator_title": "創作者",
  "chat.information_reviews_count": "{{int_count}}則留言",
  "chat.information_replies_expand": "展開{{int_count}}則留言回覆",
  "chat.information_replies_collapse": "收合{{int_count}}則留言回覆",
  "chat.information_reply_mention_button": "回覆留言",
  "chat.information_comment_pin_aria": "釘選",
  "chat.information_comment_unpin_aria": "取消釘選",
  "chat.information_comment_edit_aria": "編輯留言",
  "chat.information_reply_edit_aria": "編輯回覆",
  "general.back_aria": "返回",
  "general.share_aria": "分享",
  "general.previous_aria": "上一步",
  "chat.information_asset_nsfw": "臉紅心跳",
  "chat.bottomsheet_model_section_featured": "推薦陣容",
  "chat.bottomsheet_model_section_others": "所有模型",
  "chat.bottomsheet_model_chip_etc": "其他",
  "chat.bottomsheet_model_own_model_label": "BubbleChat自有模型",
  "chat.bottomsheet_model_changed_toast": "已變更為{{string_modelName}}",
  "chat.guest_popup_signup_headline": "藏了滿滿符合你喜好的角色！",
  "chat.guest_popup_signup_subline": "登入後打造你的專屬故事吧～",
  "chat.guest_popup_memory_headline": "現在離開的話，我會把你忘記哦⋯",
  "chat.guest_popup_memory_subline": "登入後讓我永遠記得你！",
  "chat.guest_popup_app_install_headline": "每次都要重新搜尋才進得來？",
  "chat.guest_popup_app_install_subline": "把App加到主畫面，1秒直接開聊！",
  "chat.guest_popup_ad_removal_headline": "不想對話被打斷？",
  "chat.guest_popup_ad_removal_subline": "註冊並移除廣告，盡情沉浸不受限！",
  "chat.guest_popup_watch_ad_button": "看個廣告，免費開聊！",
  "chat.guest_popup_app_download_button": "下載App",
  "chat.profile_my_password_current_label": "目前的密碼",
  "chat.profile_my_password_new_label": "新密碼",
  "chat.profile_my_status_verified": "已驗證",
  "chat.profile_my_status_unverified": "未驗證",
  "chat.profile_my_status_password_set": "已設定",
  "chat.profile_my_status_password_unset": "未設定",
  "chat.profile_my_edit_view_content_current_country_description": "只顯示在目前選取的國家所創作的內容",
  "chat.profile_my_edit_view_content_all_countries_description": "顯示所有服務國家所創作的內容",
  "chat.creator_verification_my_banner_button": "註冊創作者",
  "chat.conversation_unsupported_feature_modal_title": "想使用這個功能嗎？",
  "chat.conversation_unsupported_feature_modal_current_label": "目前的模型",
  "chat.conversation_unsupported_feature_modal_description1": "<model>{{string_modelName}}</model>不支援此功能。",
  "chat.conversation_unsupported_feature_modal_description2": "切換到其他模型，體驗更多樣的功能吧！",
  "profile.decorator_expired": "已過期",
  "general.no_products": "目前沒有可購買的商品。",
  "general.loading": "載入中…",
  "profile.user_blocked_alert_message": "封鎖之後無法檢視該用戶的留言<br/>確定要封鎖嗎?",
  "chat.profile_my_decorator_apply_button": "套用",
  "chat.profile_my_decorator_title": "裝飾",
  "chat.rewards_mg_title": "星守創作者獎勵",
  "chat.rewards_mg_current_month_revenue_pre_tax": "當月總獎勵（稅前）",
  "chat.rewards_mg_current_month_revenue_after_tax": "當月總獎勵（稅後）",
  "chat.rewards_mg_settlement_period": "計算期間",
  "chat.rewards_mg_payout_date": "當月份預定發放日",
  "chat.rewards_mg_previous_month_payout_date": "上月份預定發放日",
  "chat.rewards_mg_previous_month_revenue_pre_tax": "上月確定獎勵（稅前）",
  "chat.rewards_mg_previous_month_revenue_after_tax": "上月確定獎勵（稅後）",
  "chat.rewards_mg_contract_amount": "約定 MG（最低保證金額）",
  "chat.rewards_mg_shortfall": "MG 差額",
  "chat.rewards_mg_notice": "當月總獎勵低於約定 MG 時，將補足不足的差額，使您獲得 MG 金額。\n若總獎勵達到或超過 MG，則無差額，超出部分亦不會被扣減。\nMG 差額以每月最後一日 23:59 為基準計算，並於次月 10 日發放。\n若發放日適逢週末或國定假日，日期可能變更。\n最後一日 23:59 之後產生的獎勵將計入次月。",
  "chat.rewards_creator_information_grade": "創作者等級",
  "chat.creator_grade_stardust": "星塵",
  "chat.creator_grade_rising_star": "晨星",
  "chat.creator_grade_starkeeper": "守星者",
  "profile.user_unblocked_alert_message": "要解除該用戶的封鎖嗎?",
  "report.type.spam_text": "廣告",
  "report.type.advertisement_text": "未經許可的廣告",
  "report.type.inappropriate_text": "不當舉動",
  "report.type.personal_info_text": "洩漏個人資料",
  "report.type.other_text": "其他",
  "payment.page_list_tag_sale_period": "中秋節限定，{{date}}截止",
  "payment.page_list_bonus_expiration": "透過本商品發放的免費泡泡，有效期限為{{int_days}}天。",
  "chat.conversation_reroll_guidance_title": "重新生成指示",
  "chat.conversation_reroll_guidance_cost_tooltip": "使用重新生成指示可能會額外消耗代幣。",
  "chat.conversation_reroll_guidance_description": "想要怎麼重新寫呢？",
  "chat.conversation_reroll_guidance_description_sub": "可於輸出設定中變更重新生成指示的顯示設定。",
  "chat.conversation_reroll_guidance_input_placeholder": "例）狀態欄格式維持不變，但讓蕾娜的反應更冷淡",
  "chat.conversation_reroll_guidance_input_caption": "指示最多可輸入{{int_numbers}}個字",
  "chat.conversation_reroll_guidance_cost_info_button_label": "查看費用說明",
  "chat.conversation_reroll_guidance_reset_button": "重置",
  "chat.conversation_reroll_guidance_skip_button": "不加指示直接重新生成",
  "chat.conversation_reroll_guidance_submit_button": "重新生成",
  "chat.conversation_reroll_guidance_discovery_toast": "若想每次都直接重新生成，可於輸出設定中變更。",
  "chat.conversation_reroll_guidance_setting_title": "重新生成指示",
  "chat.conversation_reroll_guidance_setting_description": "重新生成時會顯示輸入重新生成方向的視窗。",
  "chat.conversation_reroll_guidance_setting_on_caption": "點擊重新生成後會開啟指示輸入視窗。",
  "chat.conversation_reroll_guidance_setting_off_caption": "點擊重新生成後會立即重新生成。",
  "chat.conversation_reroll_guidance_setting_off_toast": "現在點擊重新生成即可立即重新生成內容",
  "chat.custom_modal_input_settings": "輸入框設定",
  "chat.custom_modal_direction_button_position": "動作旁白按鈕位置",
  "chat.conversation_composition_title": "對話組成",
  "chat.conversation_chat_link_copy_button": "複製連結",
  "chat.conversation_chat_copy_modal_description": "請為副本命名。角色、世界觀、場景設定及目前為止的對話紀錄將完整複製。",
  "chat.free_model_ad_retry_wait_toast": "廣告載入失敗，請於{{int_seconds}}秒後再試。",
  "chat.free_model_ad_retry_wait_minutes_toast": "廣告載入失敗，請於{{int_minutes}}分鐘後再試。",
  "chat.conversation_sidebar_chat_copy": "複製對話",
  "chat.conversation_sidebar_link_copied": "已複製聊天室連結",
  "pwa.install_steps_ipad_1": "點選Safari瀏覽器上方的【分享】按鈕",
  "chat.custom_modal_tab_color": "顏色",
  "chat.custom_modal_tab_input": "輸入框",
  "chat.custom_modal_tab_lab": "實驗室",
  "chat.custom_modal_background_opacity": "背景不透明度",
  "chat.custom_modal_opacity_min": "完全透明",
  "chat.custom_modal_opacity_max": "完全不透明",
  "chat.custom_modal_reset_viewer_button": "僅重置顯示",
  "chat.custom_modal_reset_text_button": "僅重置文字",
  "chat.custom_modal_reset_color_button": "僅重置顏色",
  "chat.custom_modal_reset_input_button": "僅重置輸入框",
  "chat.custom_modal_reset_lab_button": "僅重置實驗室",
  "chat.custom_modal_reset_all_button": "全部重置",
  "chat.custom_modal_reset_all_alert_title": "要全部重置嗎？",
  "chat.custom_modal_reset_all_alert_description": "顯示、文字、顏色、輸入框設定將全部恢復為預設值。按下儲存後即會套用。",
  "chat.custom_modal_reset_all_alert_description_lab": "顯示、文字、顏色、輸入框、實驗室設定將全部恢復為預設值。按下儲存後即會套用。",
  "chat.custom_modal_reset_all_toast": "已恢復為預設值，請按下儲存以套用",
  "chat.custom_modal_apply_scope_title": "要套用到哪裡？",
  "chat.custom_modal_apply_scope_description": "請選擇要套用變更設定的範圍。",
  "chat.custom_modal_apply_scope_room_button": "僅套用到此聊天室",
  "chat.custom_modal_apply_scope_story_all_button": "套用到所有小說型聊天室",
  "chat.custom_modal_apply_scope_chat_all_button": "套用到所有聊天型聊天室",
  "chat.custom_modal_apply_scope_story_note": "全部套用僅會反映在小說型聊天室，聊天型聊天室的設定將維持不變。",
  "chat.custom_modal_apply_scope_chat_note": "全部套用僅會反映在聊天型聊天室，小說型聊天室的設定將維持不變。",
  "chat.custom_modal_apply_room_toast": "已套用到此聊天室。",
  "chat.custom_modal_apply_all_toast": "已套用到所有聊天室。",
  "chat.custom_modal_lab_font": "字體",
  "chat.custom_modal_lab_font_batang": "明體",
  "chat.custom_modal_lab_font_handwriting": "手寫體",
  "chat.create_character_multi_images_main_image_chip": "代表",
  "chat.create_character_multi_images_bulk_edit_mixed": "混合",
  "chat.create_character_multi_images_bulk_edit_public_mixed_description": "公開狀態不一致。點選後會全部變更為公開。",
  "chat.create_character_multi_images_bulk_edit_ai_mixed_description": "AI生成標示不一致。點選後會全部變更為AI生成。",
  "chat.create_character_multi_images_replace_image": "更換照片",
  "chat.create_character_multi_images_main_image_always_public": "代表照片一律公開",
  "dmm.adult_mismatch_toast_fanza": "",
  "dmm.adult_mismatch_toast_dmm": "",
  "common.service_name": "BubbleChat",
  "chat.rewards_rising_star_monthly_achievement_bonus": "{{string_month}}達成獎勵",
  "chat.rewards_rising_star_unpaid": "未發放",
  "chat.rewards_rising_star_not_morning_star_on_payout_date": "以{{string_payoutDate}}發放日為準，您並非晨星，因此未發放",
  "general.mode": "模式",
  "chat.rewards_rising_star_title": "晨星達成回饋",
  "chat.rewards_rising_star_estimated_monthly_bonus": "{{string_month}}預估達成回饋",
  "chat.rewards_rising_star_scheduled_monthly_bonus": "{{string_month}}預定發放回饋",
  "chat.rewards_rising_star_paid_monthly_bonus": "{{string_month}}已發放回饋",
  "chat.rewards_rising_star_estimated": "預估",
  "chat.rewards_rising_star_calculated": "計算完成",
  "chat.rewards_rising_star_paid": "發放完成",
  "chat.rewards_rising_star_estimate_description": "以{{string_asOfAt}}為準、計算前的預估金額 · 預定於{{string_payoutDate}}發放",
  "chat.rewards_rising_star_calculated_description": "{{string_asOfAt}}計算完成 · {{string_payoutDate}}將自動發放至獎勵",
  "chat.rewards_rising_star_paid_description": "已於{{string_payoutDate}}發放至獎勵",
  "chat.rewards_rising_star_next_calculation_date": "下次計算日",
  "chat.rewards_rising_star_payout_date": "發放日",
  "chat.rewards_rising_star_achievement_tiers": "達成級距現況",
  "chat.rewards_rising_star_next_tier_description": "距離下一級距（{{string_threshold}}以上）還差{{string_remaining}} · 達成時可獲得{{string_bonus}}",
  "chat.rewards_rising_star_highest_tier_description": "已達最高級距。合計獎勵的50%將作為回饋計入。",
  "chat.rewards_rising_star_threshold_or_more": "{{string_amount}}以上",
  "chat.rewards_rising_star_achievement_fifty_percent": "達成值的50%",
  "chat.rewards_rising_star_calculation_details": "計算過程",
  "chat.rewards_rising_star_combined_rewards": "合計獎勵",
  "chat.rewards_rising_star_applied_tier": "適用級距",
  "chat.rewards_rising_star_applied_rule": "適用規則",
  "chat.rewards_rising_star_achievement_bonus": "達成回饋",
  "chat.rewards_rising_star_fixed_bonus": "固定回饋",
  "chat.rewards_rising_star_achievement_fifty_percent_rounded_up": "達成值的50%（小數點無條件進位）",
  "chat.rewards_rising_star_not_achieved": "未達成",
  "chat.rewards_rising_star_eligible_assets": "列入計算的素材",
  "chat.rewards_rising_star_within_ninety_days_of_first_release": "首次公開後90天內",
  "chat.rewards_rising_star_first_release": "首次公開",
  "chat.rewards_rising_star_excluded": "排除",
  "chat.rewards_rising_star_total": "合計",
  "chat.rewards_rising_star_expand_all": "展開全部{{int_count}}個",
  "chat.rewards_rising_star_no_new_assets": "近90天內沒有新公開的素材",
  "chat.rewards_rising_star_new_asset_description": "公開新素材後，將從下次計算起納入合計",
  "chat.rewards_rising_star_bonus_history": "回饋入帳紀錄",
  "chat.rewards_rising_star_morning_star_bonus_history": "晨星達成回饋入帳紀錄",
  "chat.rewards_rising_star_bonus_reclaimed": "回饋收回",
  "chat.rewards_rising_star_for_year_month": "{{string_yearMonth}}的部分",
  "chat.rewards_rising_star_payout_date_label": "{{string_payoutDate}}發放",
  "chat.rewards_rising_star_base_rewards": "基本獎勵",
  "chat.rewards_rising_star_monthly_total_rewards": "每月獎勵合計",
  "chat.rewards_rising_star_bonus_guide": "晨星達成回饋說明",
  "chat.rewards_rising_star_calculation_notice": "以每月25日23:59為準，將近90天內首次公開的素材於同期間產生的獎勵加總後，計算達成回饋；計算出的回饋會於每月最後一天自動發放至獎勵。",
  "chat.rewards_rising_star_non_cumulative_notice": "各項達成回饋不會重複發放，僅適用該級距的最高回饋。",
  "chat.rewards_rising_star_rounding_notice": "50%回饋的小數點部分將無條件進位。",
  "chat.rewards_rising_star_first_release_notice": "「新公開」是以首次公開為準。",
  "chat.rewards_rising_star_recalculation_notice": "回饋計算後，若素材被刪除或設為不公開，該素材的獎勵將從計算值中排除。若於25日計算後、月底發放前發生，將在發放前重新計算回饋；若於發放後發生，已發放的回饋可能會被收回。",
  "chat.rewards_rising_star_rate_change_notice": "回饋計算後，即使分潤比例有所變更，已計算的數值仍會維持不變。",
  "chat.image_number": "相片{{int_imageNumbers}}",
  "general.ai": "AI",
  "chat.contest_entry_required": "必填",
  "chat.contest_entry_per_character_fields_hint": "請為每個角色分別填寫 · 共{{int_number}}項",
  "chat.contest_entry_staff_only_hint": "僅營運團隊會查看 · 提交後無法修改",
  "chat.contest_entry_required_character_field_error": "此為必填項目。請輸入此角色的內容。",
  "chat.contest_entry_additional_fields_remaining": "請填寫補充資訊（還剩{{int_number}}項）",
  "chat.contest_entry_review_confirmation_notice": "營運團隊審核後才會確定參賽，結果將以通知告知。",
  "chat.contest_entry_ineligible_characters_notice": "有無法提交的角色。請再次確認清單。",
  "chat.contest_entry_pending_approval": "待核准",
  "chat.contest_entry_entry_confirmed": "參賽確定",
  "chat.contest_entry_rejected": "已退回",
  "chat.contest_entry_entry_canceled": "已取消參賽",
  "chat.contest_entry_submitted_pending_review": "{{string_date}}提交 · 待審核",
  "chat.contest_entry_closed_awaiting_results": "已截止收件 · 等待評審結果",
  "chat.contest_entry_approval_revoked_pending_review": "{{string_date}}取消核准 · 重新待審核",
  "chat.contest_entry_confirmed_date": "{{string_date}}確定",
  "chat.contest_entry_confirmed_grant_amount_paid": "{{string_date}}確定 · 已發放創作角色獎勵{{string_amount}}",
  "chat.contest_entry_confirmed_grant_paid": "{{string_date}}確定 · 已發放創作角色獎勵",
  "chat.contest_entry_rejected_resubmissions_remaining": "{{string_date}}退回 · 還可重新提交{{int_number}}次",
  "chat.contest_entry_rejected_no_resubmission": "{{string_date}}退回 · 無法重新提交",
  "chat.contest_entry_rejected_after_deadline": "截止後退回 · 無法重新提交",
  "chat.contest_entry_auto_canceled_private_character": "{{string_date}}自動取消參賽 · 角色已設為不公開",
  "chat.contest_entry_public_characters_only": "僅限公開角色可參加競賽。",
  "chat.contest_entry_resubmissions_exhausted_notice": "重新提交的機會已全部用完。請改以其他作品參賽。",
  "chat.contest_entry_rejected_after_deadline_notice": "收件截止後被退回的作品無法再次提交。",
  "chat.contest_entry_view_rejection_reason": "查看退回原因",
  "chat.contest_entry_view_submission": "查看提交內容",
  "chat.contest_entry_collapse_submission": "收合提交內容",
  "chat.contest_entry_read_only_hint": "唯讀 · 提交後無法修改",
  "chat.contest_entry_rejection_reason": "退回原因",
  "chat.contest_entry_processed_date": "{{string_date}}處理",
  "chat.contest_entry_my_additional_information": "我提交的補充資訊",
  "chat.contest_entry_resubmission_attempts": "可重新提交次數",
  "chat.contest_entry_resubmissions_remaining": "剩餘{{int_number}}次（3次中已使用{{int_count}}次）",
  "chat.contest_entry_resubmissions_exhausted": "剩餘0次（3次皆已使用）",
  "chat.contest_entry_resubmission_closed": "無法重新提交（已截止收件）",
  "chat.contest_entry_resubmission_check_notice": "提交前請再次確認是否已修正退回原因。",
  "chat.contest_entry_confirm_submission": "確認提交",
  "chat.contest_entry_resubmitted_notice": "已重新提交。營運團隊審核後會通知結果。",
  "chat.contest_entry_ineligible_resubmission_notice": "角色不符合參賽條件，無法重新提交。",
  "chat.contest_entry_resubmission_rules": "重新提交規則",
  "chat.contest_entry_resubmission_rules_attempts": "依退回原因修改後，最多可重新提交3次。",
  "chat.contest_entry_resubmission_rules_review": "重新提交後會再次進入待核准狀態，並於管理員審核後確定。",
  "chat.contest_entry_resubmission_rules_deadline": "收件截止後被退回的作品無法重新提交，是否核准將於評審過程中最終決定。",
  "chat.contest_entry_resubmit": "重新提交",
  "chat.contest_entry_approval_revoked": "取消核准",
  "chat.contest_entry_view_revocation_reason": "查看取消原因",
  "chat.contest_entry_revocation_reason": "取消核准原因"
}